export const fakeBusinessData = {
  selectedBusiness: {
    name: "Demo Bakery",
    rating: 4.3371,
    turnover: 600000,
  },
  currencySymbol: "$",
};

export const fakeReviewsData = [

  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a day ago",
    "estimated_datetime": "2025-01-25T18:57:32",
    "profile_name": "Annie Kate Swain",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSURfNWRUMEFREAE",
    "review_text": "Great coffee and delicious pastries. Pizza shop attached if you’re wanting savory",
    "cumulative_rating": 4.321678321678322,
    "review_impact": 0.00236349016836801,
    "api_order": 285,
    "id": "f22407af-f4ab-4092-bc14-1d2a26016e48",
    "analysis": [
      {
        "review_id": "f22407af-f4ab-4092-bc14-1d2a26016e48",
        "comment": "delicious pastries",
        "subject_group": "pastry",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "19c65ba7-a728-4ae0-8e4a-674c4cccd1a3"
      },
      {
        "review_id": "f22407af-f4ab-4092-bc14-1d2a26016e48",
        "comment": "Great coffee",
        "subject_group": "coffee",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "a7da4f65-17de-4381-a2ca-a7804cbd14e1"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a month ago",
    "estimated_datetime": "2024-12-12T12:57:32",
    "profile_name": "Gabriela Stoynova",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUN2bV9LRk1REAE",
    "review_text": "Parisian level croissants and great variety of other pastries. Very friendly staff and great indoor seating area !",
    "cumulative_rating": 4.348314606741573,
    "review_impact": 0.00236349016836801,
    "api_order": 266,
    "id": "a47e3f0b-6c2b-4c0c-b8b2-84d86fd61143",
    "analysis": [
      {
        "review_id": "a47e3f0b-6c2b-4c0c-b8b2-84d86fd61143",
        "comment": "great indoor seating area",
        "subject_group": "seating",
        "category": "experience",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "250d584f-adcb-4b40-9795-a5a06da0cc37"
      },
      {
        "review_id": "a47e3f0b-6c2b-4c0c-b8b2-84d86fd61143",
        "comment": "Very friendly staff",
        "subject_group": "staff",
        "category": "service",
        "attribute": "friendliness",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "39649627-9ff4-4347-b697-1d7ce3caebd7"
      },
      {
        "review_id": "a47e3f0b-6c2b-4c0c-b8b2-84d86fd61143",
        "comment": "Parisian level croissants and great variety of other pastries",
        "subject_group": "pastry",
        "category": "product",
        "attribute": "variety",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "39f6741d-4f37-40d7-b172-d8f1036305a6"
      },
      {
        "review_id": "a47e3f0b-6c2b-4c0c-b8b2-84d86fd61143",
        "comment": "Parisian level croissants and great variety of other pastries",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "f52493b7-63e0-44e6-9357-e0731800a148"
      }
    ]
  },

  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a week ago",
    "estimated_datetime": "2025-01-17T00:57:32",
    "profile_name": "Mirta Langbart",
    "rating": 1,
    "provider_review_id": "ChRDSUhNMG9nS0VJQ0FnSUNfMnAxZRAB",
    "review_text": "Really rude staff.",
    "cumulative_rating": 4.330960854092527,
    "review_impact": -0.011622523817646169,
    "api_order": 280,
    "id": "dd6bc5c6-6d4e-4bb7-a01a-5c4f044e71fd",
    "analysis": [
      {
        "review_id": "dd6bc5c6-6d4e-4bb7-a01a-5c4f044e71fd",
        "comment": "Really rude staff.",
        "subject_group": "staff",
        "category": "service",
        "attribute": "rudeness",
        "sentiment": "negative",
        "attribute_impact": -0.011622523817646169,
        "id": "51868635-fbe6-4ac4-a69b-ff9ec43c6616"
      }
    ]
  },

  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "2 weeks ago",
    "estimated_datetime": "2025-01-11T18:57:32",
    "profile_name": "Essa Thabet",
    "rating": 4,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNfdUl2ZGZREAE",
    "review_text": "The pastries are very good. Recommend. However, the chairs were not that clean.",
    "cumulative_rating": 4.340501792114695,
    "review_impact": -0.0011330133281353127,
    "api_order": 278,
    "id": "194cdb1f-dc69-4b98-ab13-b6f02f43a4eb",
    "analysis": [
      {
        "review_id": "194cdb1f-dc69-4b98-ab13-b6f02f43a4eb",
        "comment": "The pastries are very good.",
        "subject_group": "pastry",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "b8fc57c5-ac4f-4f6a-856e-901c257134d6"
      },
      {
        "review_id": "194cdb1f-dc69-4b98-ab13-b6f02f43a4eb",
        "comment": "the chairs were not that clean.",
        "subject_group": "chair",
        "category": "experience",
        "attribute": "cleanliness",
        "sentiment": "negative",
        "attribute_impact": -0.0011330133281353127,
        "id": "a168bf46-9225-4632-a429-3c1ef99e520b"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a month ago",
    "estimated_datetime": "2024-12-08T12:57:32",
    "profile_name": "Hayley Di Naso",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUN2c1ozOUdBEAE",
    "review_text": "Delicious pastries and nice spot to sit and people watch. Friendly staff.",
    "cumulative_rating": 4.343396226415094,
    "review_impact": 0.00236349016836801,
    "api_order": 264,
    "id": "9c4b2e01-7ee5-4cbd-870a-17ab53119764",
    "analysis": [
      {
        "review_id": "9c4b2e01-7ee5-4cbd-870a-17ab53119764",
        "comment": "Friendly staff",
        "subject_group": "staff",
        "category": "service",
        "attribute": "friendliness",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "16561da4-364e-4b4a-af1a-3e893faec176"
      },
      {
        "review_id": "9c4b2e01-7ee5-4cbd-870a-17ab53119764",
        "comment": "nice spot to sit and people watch",
        "subject_group": "spot",
        "category": "experience",
        "attribute": "comfort",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "c8541d76-c640-4ca0-b177-8433bb313daf"
      },
      {
        "review_id": "9c4b2e01-7ee5-4cbd-870a-17ab53119764",
        "comment": "Delicious pastries",
        "subject_group": "pastry",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "e653e105-77f8-4276-901e-d71ccde3bbe3"
      }
    ]
  },


  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "2 weeks ago",
    "estimated_datetime": "2025-01-08T06:57:32",
    "profile_name": "Yoojinny Cho",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSURmanBqWHJRRRAB",
    "review_text": "I got a croissant. On the sweeter side. Everyone praised the croissant here but it not for everyone. I like my croissant buttery and fluffy. This one is dense and chewy. But I did like how it was hard and crispy putside and moist inside!",
    "cumulative_rating": 4.341726618705036,
    "review_impact": 0.00236349016836801,
    "api_order": 277,
    "id": "88c515fe-5069-4712-824e-a23cb0ec88cb",
    "analysis": [
      {
        "review_id": "88c515fe-5069-4712-824e-a23cb0ec88cb",
        "comment": "This one is dense and chewy",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "texture",
        "sentiment": "negative",
        "attribute_impact": 0.0,
        "id": "adda46d4-ebe1-4c8d-a51d-7912e19c5626"
      },
      {
        "review_id": "88c515fe-5069-4712-824e-a23cb0ec88cb",
        "comment": "Everyone praised the croissant here but it not for everyone",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "reputation",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "6ab8c69b-d05a-498c-bb59-3b0bd4d428f8"
      },
      {
        "review_id": "88c515fe-5069-4712-824e-a23cb0ec88cb",
        "comment": "I did like how it was hard and crispy outside and moist inside",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "texture",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "7bbf35bd-2d05-49b3-a369-8eec87326da6"
      },
      {
        "review_id": "88c515fe-5069-4712-824e-a23cb0ec88cb",
        "comment": "I like my croissant buttery and fluffy",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "texture",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "7f0719fe-2174-4bcd-b61a-be68ee190c13"
      },
      {
        "review_id": "88c515fe-5069-4712-824e-a23cb0ec88cb",
        "comment": "I got a croissant",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "d2d23c87-cf2d-4873-a002-e722d23ae270"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "3 weeks ago",
    "estimated_datetime": "2025-01-04T18:57:32",
    "profile_name": "Prakash Budha",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNmbTVmTkhREAE",
    "review_text": "I love their Croissant Bacon Egg & Cheese.",
    "cumulative_rating": 4.3393501805054155,
    "review_impact": 0.00236349016836801,
    "api_order": 276,
    "id": "016e4f24-c49f-4c09-b6ac-afbda4e79f52",
    "analysis": [
      {
        "review_id": "016e4f24-c49f-4c09-b6ac-afbda4e79f52",
        "comment": "I love their Croissant Bacon Egg & Cheese.",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.00236349016836801,
        "id": "47450e6b-b26c-4291-8f9a-2cc7b83d77bd"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "3 weeks ago",
    "estimated_datetime": "2025-01-01T06:57:32",
    "profile_name": "Kaylea Campbell",
    "rating": 1,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUNmbGNtYnpRRRAB",
    "review_text": "Overpriced and not even tasty. We spent over $20 on three items. The chocolate chip cookie was not good. We only ate the edges because the middle was too soft and mushy. The guy put the box in the bag crooked so the cheesecake got on the side of the box. Not worth it. The eclair was fine but not worth the price. This place will not be on our list of places to return to when we go back to New York.",
    "cumulative_rating": 4.336956521739131,
    "review_impact": -0.011622523817646169,
    "api_order": 275,
    "id": "4072a7ed-0dba-468d-b705-ddb7dd5d7a21",
    "analysis": [
      {
        "review_id": "4072a7ed-0dba-468d-b705-ddb7dd5d7a21",
        "comment": "The eclair was fine but not worth the price.",
        "subject_group": "eclair",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "e4c6aaa9-a841-4ff0-8379-75844deec491"
      },
      {
        "review_id": "4072a7ed-0dba-468d-b705-ddb7dd5d7a21",
        "comment": "The guy put the box in the bag crooked so the cheesecake got on the side of the box.",
        "subject_group": "packaging",
        "category": "service",
        "attribute": "condition",
        "sentiment": "negative",
        "attribute_impact": -0.001452815477205771,
        "id": "1ceadc3e-013f-414d-875c-53b6ae7c623f"
      },
      {
        "review_id": "4072a7ed-0dba-468d-b705-ddb7dd5d7a21",
        "comment": "Overpriced and not even tasty.",
        "subject_group": "taste",
        "category": "product",
        "attribute": "quality",
        "sentiment": "negative",
        "attribute_impact": -0.001452815477205771,
        "id": "2a3e316b-7ab1-41fe-9b96-3f9c8e2974f3"
      },
      {
        "review_id": "4072a7ed-0dba-468d-b705-ddb7dd5d7a21",
        "comment": "This place will not be on our list of places to return to when we go back to New York.",
        "subject_group": "experience",
        "category": "experience",
        "attribute": "satisfaction",
        "sentiment": "negative",
        "attribute_impact": -0.001452815477205771,
        "id": "2da46616-1b63-4df1-bb8d-543a04f54169"
      },
      {
        "review_id": "4072a7ed-0dba-468d-b705-ddb7dd5d7a21",
        "comment": "We only ate the edges because the middle was too soft and mushy.",
        "subject_group": "cookie",
        "category": "product",
        "attribute": "texture",
        "sentiment": "negative",
        "attribute_impact": -0.001452815477205771,
        "id": "8f1a0c1b-30d4-4cdd-b4d4-63362e011f87"
      },
      {
        "review_id": "4072a7ed-0dba-468d-b705-ddb7dd5d7a21",
        "comment": "Overpriced and not even tasty.",
        "subject_group": "price",
        "category": "product",
        "attribute": "value",
        "sentiment": "negative",
        "attribute_impact": -0.001452815477205771,
        "id": "935e6ceb-32c3-4a86-9632-02f93650b96e"
      },
      {
        "review_id": "4072a7ed-0dba-468d-b705-ddb7dd5d7a21",
        "comment": "We spent over $20 on three items.",
        "subject_group": "price",
        "category": "product",
        "attribute": "amount",
        "sentiment": "negative",
        "attribute_impact": -0.001452815477205771,
        "id": "9b765ee0-bf9a-4529-8c89-a4973e9c5433"
      },
      {
        "review_id": "4072a7ed-0dba-468d-b705-ddb7dd5d7a21",
        "comment": "The eclair was fine but not worth the price.",
        "subject_group": "eclair",
        "category": "product",
        "attribute": "value",
        "sentiment": "negative",
        "attribute_impact": -0.001452815477205771,
        "id": "a494e752-9e95-4743-ac9c-c2dfce0dc732"
      },
      {
        "review_id": "4072a7ed-0dba-468d-b705-ddb7dd5d7a21",
        "comment": "The chocolate chip cookie was not good.",
        "subject_group": "cookie",
        "category": "product",
        "attribute": "quality",
        "sentiment": "negative",
        "attribute_impact": -0.001452815477205771,
        "id": "aa0b89fe-a72b-4486-b905-47e369800226"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "4 weeks ago",
    "estimated_datetime": "2024-12-27T00:57:32",
    "profile_name": "Delma Pedraza",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUNmMXJ6XzhRRRAB",
    "review_text": null,
    "cumulative_rating": 4.349090909090909,
    "review_impact": 0.00236349016836801,
    "api_order": 274,
    "id": "c86e46da-aaeb-4f25-849f-aef8910b1d04",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a month ago",
    "estimated_datetime": "2024-12-26T12:57:32",
    "profile_name": "Charles",
    "rating": 1,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUR2Nzk2SmZREAE",
    "review_text": null,
    "cumulative_rating": 4.346715328467154,
    "review_impact": -0.011622523817646169,
    "api_order": 273,
    "id": "6da0946a-c9d5-4dd5-9d34-64a8756754c7",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a month ago",
    "estimated_datetime": "2024-12-24T12:57:32",
    "profile_name": "Jasem Alzaabi",
    "rating": 4,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUR2OF9qb01REAE",
    "review_text": null,
    "cumulative_rating": 4.358974358974359,
    "review_impact": -0.0011330133281353127,
    "api_order": 272,
    "id": "f5395286-4d67-448c-8322-fea667afc07d",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a month ago",
    "estimated_datetime": "2024-12-22T12:57:32",
    "profile_name": "cyril be",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUR2eWZmck5nEAE",
    "review_text": "For a Frenchie's, eating a croissant with egg and bacon is an aberration! But it was very good! It’s a change from France, thank you!",
    "cumulative_rating": 4.360294117647059,
    "review_impact": 0.00236349016836801,
    "api_order": 271,
    "id": "224274fe-d922-4375-9b86-36ebe3d14e93",
    "analysis": [
      {
        "review_id": "224274fe-d922-4375-9b86-36ebe3d14e93",
        "comment": "For a Frenchie's, eating a croissant with egg and bacon is an aberration!",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "taste",
        "sentiment": "negative",
        "attribute_impact": 0.0,
        "id": "a88c80b5-586a-420d-ac30-13000192ea4d"
      },
      {
        "review_id": "224274fe-d922-4375-9b86-36ebe3d14e93",
        "comment": "But it was very good!",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "0f844934-7996-4fe7-b6e5-6a00f29531db"
      },
      {
        "review_id": "224274fe-d922-4375-9b86-36ebe3d14e93",
        "comment": "It’s a change from France, thank you!",
        "subject_group": "change",
        "category": "experience",
        "attribute": "value",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "780a13c2-b753-4099-a962-9fc5a844a0d0"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a month ago",
    "estimated_datetime": "2024-12-20T12:57:32",
    "profile_name": "Beth Milam",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUR2cHZXbDhBRRAB",
    "review_text": "The best cinnamon roll I’ve ever had in my life!! So good that I brought one back to Alabama in my carryon! Coffee and Nutella doughnut were not bad either!",
    "cumulative_rating": 4.357933579335794,
    "review_impact": 0.00236349016836801,
    "api_order": 270,
    "id": "6cf45fed-3dc2-42d7-ad04-94ff6464446a",
    "analysis": [
      {
        "review_id": "6cf45fed-3dc2-42d7-ad04-94ff6464446a",
        "comment": "The best cinnamon roll I’ve ever had in my life!!",
        "subject_group": "cinnamon roll",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "015dc208-bb49-4e4b-ab32-4e4c5364efd0"
      },
      {
        "review_id": "6cf45fed-3dc2-42d7-ad04-94ff6464446a",
        "comment": "Coffee and Nutella doughnut were not bad either!",
        "subject_group": "doughnut",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "4ccc7c08-70ed-4d68-b04e-1c17511f1bea"
      },
      {
        "review_id": "6cf45fed-3dc2-42d7-ad04-94ff6464446a",
        "comment": "So good that I brought one back to Alabama in my carryon!",
        "subject_group": "cinnamon roll",
        "category": "product",
        "attribute": "desire",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "9d2dfa82-3bd6-4219-9d83-cb87bae842cd"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a month ago",
    "estimated_datetime": "2024-12-18T12:57:32",
    "profile_name": "josi gmaer",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUR2eHZmeUJ3EAE",
    "review_text": "I love this place everything is delicious",
    "cumulative_rating": 4.355555555555555,
    "review_impact": 0.00236349016836801,
    "api_order": 269,
    "id": "c9560329-f850-4948-85ab-13df97b35489",
    "analysis": [
      {
        "review_id": "c9560329-f850-4948-85ab-13df97b35489",
        "comment": "I love this place",
        "subject_group": "place",
        "category": "experience",
        "attribute": "love",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "286e138b-acd8-4304-b77f-b21a216590d2"
      },
      {
        "review_id": "c9560329-f850-4948-85ab-13df97b35489",
        "comment": "everything is delicious",
        "subject_group": "product",
        "category": "product",
        "attribute": "deliciousness",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "2b760d70-35f1-441c-a660-ba3e01f46c90"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a month ago",
    "estimated_datetime": "2024-12-16T12:57:32",
    "profile_name": "Craig Blalock",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUR2dXBPVTJRRRAB",
    "review_text": "Had breakfast here multiple times on our most recent visit. The ham/gruyere croissant and the smoked salmon croissant were delicious. The crème brûlée doughnut was a masterpiece!",
    "cumulative_rating": 4.353159851301116,
    "review_impact": 0.00236349016836801,
    "api_order": 268,
    "id": "f4932808-e3e3-4526-8404-0640f03733a5",
    "analysis": [
      {
        "review_id": "f4932808-e3e3-4526-8404-0640f03733a5",
        "comment": "The ham/gruyere croissant and the smoked salmon croissant were delicious.",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "d5d9615e-9986-4256-816e-072d28fb9a19"
      },
      {
        "review_id": "f4932808-e3e3-4526-8404-0640f03733a5",
        "comment": "The crème brûlée doughnut was a masterpiece!",
        "subject_group": "doughnut",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "d93cfc44-ff94-4783-837a-5d17c92ba1f5"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a month ago",
    "estimated_datetime": "2024-12-14T12:57:32",
    "profile_name": "akhil chowdary (abc)",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUR2NUptdmhRRRAB",
    "review_text": null,
    "cumulative_rating": 4.350746268656716,
    "review_impact": 0.00236349016836801,
    "api_order": 267,
    "id": "560354f5-6d5b-4250-ad25-03789c43f48f",
    "analysis": []
  },

  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a month ago",
    "estimated_datetime": "2024-12-10T12:57:32",
    "profile_name": "Zachary Eide",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUN2NjVxTGZnEAE",
    "review_text": "This was our favorite bakery while we were visiting NYC. The staff was very friendly and the food was absolutely fantastic.  Highly recommended.",
    "cumulative_rating": 4.345864661654136,
    "review_impact": 0.00236349016836801,
    "api_order": 265,
    "id": "9f7f1b4b-ceb4-4647-bfe0-a5b5fca2957b",
    "analysis": [
      {
        "review_id": "9f7f1b4b-ceb4-4647-bfe0-a5b5fca2957b",
        "comment": "Highly recommended",
        "subject_group": "recommendation",
        "category": "experience",
        "attribute": "high",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "3a16daea-af8e-40d3-b044-80eb7562143c"
      },
      {
        "review_id": "9f7f1b4b-ceb4-4647-bfe0-a5b5fca2957b",
        "comment": "the food was absolutely fantastic",
        "subject_group": "food",
        "category": "product",
        "attribute": "fantastic",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "b9b7a63b-e66f-471c-8013-e55778d0c055"
      },
      {
        "review_id": "9f7f1b4b-ceb4-4647-bfe0-a5b5fca2957b",
        "comment": "The staff was very friendly",
        "subject_group": "staff",
        "category": "service",
        "attribute": "friendliness",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "e48e3617-4292-4e46-bf7d-95b872ee58e8"
      },
      {
        "review_id": "9f7f1b4b-ceb4-4647-bfe0-a5b5fca2957b",
        "comment": "This was our favorite bakery while we were visiting NYC",
        "subject_group": "bakery",
        "category": "experience",
        "attribute": "favorite",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "fcc6a6cd-d58b-4e56-8869-5e9f6ab30031"
      }
    ]
  },

  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a month ago",
    "estimated_datetime": "2024-12-06T12:57:32",
    "profile_name": "Giojo 7",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUN2MGNPVEFREAE",
    "review_text": null,
    "cumulative_rating": 4.340909090909091,
    "review_impact": 0.00236349016836801,
    "api_order": 263,
    "id": "035e8175-2253-4d1c-851d-f717bb7ccaf3",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "7 months ago",
    "estimated_datetime": "2024-06-25T07:48:57.714288",
    "profile_name": "O E",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNMNDVXclNREAE",
    "review_text": "Their croissant is absolutely amazing—better than Lafayette's viral croissant. It's perfectly flaky and delicious. Highly recommend trying it!",
    "cumulative_rating": 4.388888888888889,
    "review_impact": 0.00236349016836801,
    "api_order": 197,
    "id": "d3988cf2-d086-4988-b57a-92204b81094d",
    "analysis": [
      {
        "review_id": "d3988cf2-d086-4988-b57a-92204b81094d",
        "comment": "It's perfectly flaky and delicious",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "58ec196a-984a-4d79-bd46-29ca7b3b70ce"
      },
      {
        "review_id": "d3988cf2-d086-4988-b57a-92204b81094d",
        "comment": "It's perfectly flaky and delicious",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "texture",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "95e0876a-c913-4b13-98aa-128e6b18883a"
      },
      {
        "review_id": "d3988cf2-d086-4988-b57a-92204b81094d",
        "comment": "Highly recommend trying it",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "recommendation",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "b86c39ee-d23b-4e9c-b370-36e579427493"
      },
      {
        "review_id": "d3988cf2-d086-4988-b57a-92204b81094d",
        "comment": "Their croissant is absolutely amazing",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "d3c87f32-bcba-44c5-9779-d65026993f85"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a month ago",
    "estimated_datetime": "2024-12-04T12:57:32",
    "profile_name": "Natacha Pamphile",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUN2cXVqQUtnEAE",
    "review_text": "Someone recommended that I grab breakfast here and am I so happy that I acted on the suggestion. The scent of freshly baked (in house might I add) pastries grabs you at the door. The most pleasant staff and shout out to Ari for making my first experience there a fantastic one. I will definitely return when I'm in the neighborhood.",
    "cumulative_rating": 4.338403041825095,
    "review_impact": 0.00236349016836801,
    "api_order": 262,
    "id": "89076010-d253-4458-a1e2-ef63bf530e5a",
    "analysis": [
      {
        "review_id": "89076010-d253-4458-a1e2-ef63bf530e5a",
        "comment": "The most pleasant staff and shout out to Ari for making my first experience there a fantastic one",
        "subject_group": "staff",
        "category": "service",
        "attribute": "pleasantness",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "00c7b510-f564-4a3b-b2b6-adf739d0ea89"
      },
      {
        "review_id": "89076010-d253-4458-a1e2-ef63bf530e5a",
        "comment": "The scent of freshly baked pastries grabs you at the door",
        "subject_group": "pastry",
        "category": "product",
        "attribute": "scent",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "277e7ad9-f6bc-4169-a057-88d631f305b6"
      },
      {
        "review_id": "89076010-d253-4458-a1e2-ef63bf530e5a",
        "comment": "The most pleasant staff and shout out to Ari for making my first experience there a fantastic one",
        "subject_group": "experience",
        "category": "experience",
        "attribute": "fantastic",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "fccfce15-7c87-4ce9-b5eb-b9904be766d7"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a month ago",
    "estimated_datetime": "2024-12-02T12:57:32",
    "profile_name": "Alexandru Ursu",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUN2bk5ia1hnEAE",
    "review_text": null,
    "cumulative_rating": 4.33587786259542,
    "review_impact": 0.00236349016836801,
    "api_order": 261,
    "id": "2adf4f29-c60c-4c37-9c10-ed27a8473e08",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a month ago",
    "estimated_datetime": "2024-11-30T12:57:32",
    "profile_name": "SK S",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSURQeTVibTZ3RRAB",
    "review_text": "**Usually** you can rate a bakery in NYC just off their chocolate chip cookies, this is one of those places! The cookie is really over the top, I would definitely go back and get it again!!!!",
    "cumulative_rating": 4.333333333333333,
    "review_impact": 0.00236349016836801,
    "api_order": 260,
    "id": "1378d497-4d7a-47e7-b480-3ac9a00ac979",
    "analysis": [
      {
        "review_id": "1378d497-4d7a-47e7-b480-3ac9a00ac979",
        "comment": "The cookie is really over the top",
        "subject_group": "cookie",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "1c6da61b-2489-4b63-8068-84a11b08b1a9"
      },
      {
        "review_id": "1378d497-4d7a-47e7-b480-3ac9a00ac979",
        "comment": "I would definitely go back and get it again",
        "subject_group": "experience",
        "category": "experience",
        "attribute": "satisfaction",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "4d1c875e-a747-4215-a33a-b2202e1f8de9"
      },
      {
        "review_id": "1378d497-4d7a-47e7-b480-3ac9a00ac979",
        "comment": "Usually you can rate a bakery in NYC just off their chocolate chip cookies",
        "subject_group": "cookie",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "740203b1-862b-4587-92ee-9d1bed6f375a"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a month ago",
    "estimated_datetime": "2024-11-28T12:57:32",
    "profile_name": "Eric Kim",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSURQa3YyLXdBRRAB",
    "review_text": "We’ve fallen in love with this cute little corner bakery during our 2-week period of frequent visits to downtown nyc. Involved with me dropping wife off and waiting in the car for 30-60 minutes at a time and thank God that Siena is here!\n\nAtmosphere (5/5) - I first noticed it while driving by because of their full-length glass facade showing ppl cozy and enjoying their cup of joe and croissants! It’s cozy but not tiny, with comfortable seatings. Music not too loud, employees smiling, great vibe.\n\nFood (5/5) - I ordered bunch of things so far, starting with\n- Smoked salmon everything bagel (5/5) - an employee swore his undying love for this one when asked btwn that and a croissant sandwich, and it was a winner! Beautiful to look at, crunchy as hell on the first bite, and surprisingly loaded with oodles of smoked salmon. Slices of avocado and tomato on top of that means there’s no way to eat gracefully without spillage so pull your plates close and enjoy the chomp. I found the croissant-like bagel a pleasure to bite into, and while slightly salty, it was balanced out with the rest of the ingredients. Don’t let its size fool you - you’ll be full for 3 hrs!\n- Sausage pastry (5/5) - I forgot the name but it’s in the pics. Unassuming flaky number with flavorful sausage and other toppings (tomato?$ rounding out the robust flavor. Smaller than the lox bagel but still nicely filling.\n- Lattes and coffees were on-point as well. I had a PSL that tasted good without overpowering sweetness found in most, and enjoyed a full-bodied drip.\n\nService - this is self-serve type of place so you are informed to bring your plates to the back rubbish area. One key locked bathroom for after-Joe break, and the bakery staff are pleasant and nice.\n\nThis one set a high bar for me in all that a bakery/cafe should be. You should stop by - you won’t be disappointed.",
    "cumulative_rating": 4.3307692307692305,
    "review_impact": 0.00236349016836801,
    "api_order": 259,
    "id": "faf04494-5a36-4a64-9789-2a691ea2c371",
    "analysis": [
      {
        "review_id": "faf04494-5a36-4a64-9789-2a691ea2c371",
        "comment": "Unassuming flaky number with flavorful sausage and other toppings rounding out the robust flavor.",
        "subject_group": "pastry",
        "category": "product",
        "attribute": "flavor",
        "sentiment": "positive",
        "attribute_impact": 0.00015756601122453399,
        "id": "05e6ba99-40fd-49dc-905b-67d7f6d25548"
      },
      {
        "review_id": "faf04494-5a36-4a64-9789-2a691ea2c371",
        "comment": "Food (5/5) - I ordered bunch of things so far, starting with Smoked salmon everything bagel (5/5) - an employee swore his undying love for this one when asked btwn that and a croissant sandwich, and it was a winner!",
        "subject_group": "food",
        "category": "product",
        "attribute": "appearance",
        "sentiment": "positive",
        "attribute_impact": 0.00015756601122453399,
        "id": "0e476ccb-3f1e-4049-bfc6-7fdf38b38f34"
      },
      {
        "review_id": "faf04494-5a36-4a64-9789-2a691ea2c371",
        "comment": "It’s cozy but not tiny, with comfortable seatings.",
        "subject_group": "atmosphere",
        "category": "experience",
        "attribute": "size",
        "sentiment": "positive",
        "attribute_impact": 0.00015756601122453399,
        "id": "287fc436-0e75-4903-aa5e-5cb41074b50f"
      },
      {
        "review_id": "faf04494-5a36-4a64-9789-2a691ea2c371",
        "comment": "Beautiful to look at, crunchy as hell on the first bite, and surprisingly loaded with oodles of smoked salmon.",
        "subject_group": "bagel",
        "category": "product",
        "attribute": "texture",
        "sentiment": "positive",
        "attribute_impact": 0.00015756601122453399,
        "id": "30ed86d3-05aa-48e7-8e75-6893252bceb9"
      },
      {
        "review_id": "faf04494-5a36-4a64-9789-2a691ea2c371",
        "comment": "Lattes and coffees were on-point as well.",
        "subject_group": "coffee",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.00015756601122453399,
        "id": "46672379-343d-4b13-886c-86bcc890bf45"
      },
      {
        "review_id": "faf04494-5a36-4a64-9789-2a691ea2c371",
        "comment": "One key locked bathroom for after-Joe break, and the bakery staff are pleasant and nice.",
        "subject_group": "staff",
        "category": "service",
        "attribute": "attitude",
        "sentiment": "positive",
        "attribute_impact": 0.00015756601122453399,
        "id": "52a24624-e591-4f07-bc6a-288d4f577d4c"
      },
      {
        "review_id": "faf04494-5a36-4a64-9789-2a691ea2c371",
        "comment": "It’s cozy but not tiny, with comfortable seatings.",
        "subject_group": "atmosphere",
        "category": "experience",
        "attribute": "seating",
        "sentiment": "positive",
        "attribute_impact": 0.00015756601122453399,
        "id": "6498554d-b262-4b62-ad36-5ec60ce9c424"
      },
      {
        "review_id": "faf04494-5a36-4a64-9789-2a691ea2c371",
        "comment": "Beautiful to look at, crunchy as hell on the first bite, and surprisingly loaded with oodles of smoked salmon.",
        "subject_group": "bagel",
        "category": "product",
        "attribute": "appearance",
        "sentiment": "positive",
        "attribute_impact": 0.00015756601122453399,
        "id": "7f777433-b2b2-44d5-a9e8-244d763dd78f"
      },
      {
        "review_id": "faf04494-5a36-4a64-9789-2a691ea2c371",
        "comment": "Unassuming flaky number with flavorful sausage and other toppings rounding out the robust flavor.",
        "subject_group": "pastry",
        "category": "product",
        "attribute": "texture",
        "sentiment": "positive",
        "attribute_impact": 0.00015756601122453399,
        "id": "985f5a1e-6dcb-4bfa-b6cc-53b287e5ff80"
      },
      {
        "review_id": "faf04494-5a36-4a64-9789-2a691ea2c371",
        "comment": "I found the croissant-like bagel a pleasure to bite into, and while slightly salty, it was balanced out with the rest of the ingredients.",
        "subject_group": "bagel",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.00015756601122453399,
        "id": "b6164ce1-ea5b-4106-872f-64f2f41a18ca"
      },
      {
        "review_id": "faf04494-5a36-4a64-9789-2a691ea2c371",
        "comment": "I found the croissant-like bagel a pleasure to bite into, and while slightly salty, it was balanced out with the rest of the ingredients.",
        "subject_group": "bagel",
        "category": "product",
        "attribute": "texture",
        "sentiment": "positive",
        "attribute_impact": 0.00015756601122453399,
        "id": "b86878bf-f438-4ea0-a246-d194bafe2c7c"
      },
      {
        "review_id": "faf04494-5a36-4a64-9789-2a691ea2c371",
        "comment": "Food (5/5) - I ordered bunch of things so far, starting with Smoked salmon everything bagel (5/5) - an employee swore his undying love for this one when asked btwn that and a croissant sandwich, and it was a winner!",
        "subject_group": "food",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.00015756601122453399,
        "id": "c3f0e4eb-6961-4a9e-bab2-cd55e548b143"
      },
      {
        "review_id": "faf04494-5a36-4a64-9789-2a691ea2c371",
        "comment": "I had a PSL that tasted good without overpowering sweetness found in most, and enjoyed a full-bodied drip.",
        "subject_group": "psl",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.00015756601122453399,
        "id": "e16f2dd3-62f0-48dd-a7e3-718b68264386"
      },
      {
        "review_id": "faf04494-5a36-4a64-9789-2a691ea2c371",
        "comment": "Atmosphere (5/5) - I first noticed it while driving by because of their full-length glass facade showing ppl cozy and enjoying their cup of joe and croissants!",
        "subject_group": "atmosphere",
        "category": "experience",
        "attribute": "comfort",
        "sentiment": "positive",
        "attribute_impact": 0.00015756601122453399,
        "id": "25b30636-47bf-43ce-8ae1-0fe037f16993"
      },
      {
        "review_id": "faf04494-5a36-4a64-9789-2a691ea2c371",
        "comment": "Atmosphere (5/5) - I first noticed it while driving by because of their full-length glass facade showing ppl cozy and enjoying their cup of joe and croissants!",
        "subject_group": "atmosphere",
        "category": "experience",
        "attribute": "vibe",
        "sentiment": "positive",
        "attribute_impact": 0.00015756601122453399,
        "id": "cfe8fc38-7f67-4efc-b828-f75e138b7d6f"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "2 months ago",
    "estimated_datetime": "2024-11-25T23:45:32",
    "profile_name": "Veronica Trigo Colomo",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUNQcnNDS3d3RRAB",
    "review_text": "We had it right below the hotel and we had breakfast every morning. The unmatched service. And everything is delicious",
    "cumulative_rating": 4.328185328185328,
    "review_impact": 0.00236349016836801,
    "api_order": 258,
    "id": "977a928a-fd20-4b73-82c4-fbb035c78eab",
    "analysis": [
      {
        "review_id": "977a928a-fd20-4b73-82c4-fbb035c78eab",
        "comment": "We had it right below the hotel and we had breakfast every morning.",
        "subject_group": "breakfast",
        "category": "product",
        "attribute": "location",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "3b652a99-6332-48b0-8489-431035abe52f"
      },
      {
        "review_id": "977a928a-fd20-4b73-82c4-fbb035c78eab",
        "comment": "And everything is delicious.",
        "subject_group": "food",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "63f45276-7a83-4d2e-8d3d-95197e998eb2"
      },
      {
        "review_id": "977a928a-fd20-4b73-82c4-fbb035c78eab",
        "comment": "The unmatched service.",
        "subject_group": "service",
        "category": "service",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "f3b1e3d2-a291-4300-9682-c11e237f8c2f"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "2 months ago",
    "estimated_datetime": "2024-11-22T21:21:32",
    "profile_name": "Jaquana Burrell",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUQzemRUVVlnEAE",
    "review_text": "This was my first time coming here my husband and I were on a spur of the moment weekend trip to NY I’m pregnant and hungry and I must say the food was amazing the customer service was A1 as a Boston food truck owner myself I got the sausage egg and cheese on a Croissant and the half and half sweet tea with lemonade you can smell the butter from the bag the eggs were fluffy and the tea was perfect I wish I had pics but it was soo good I forgot I will be telling everyone at home about this place always coming back when we visit NY",
    "cumulative_rating": 4.325581395348837,
    "review_impact": 0.00236349016836801,
    "api_order": 257,
    "id": "0816b867-101f-4f64-80f9-2789d6be253d",
    "analysis": [
      {
        "review_id": "0816b867-101f-4f64-80f9-2789d6be253d",
        "comment": "the food was amazing",
        "subject_group": "food",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0003376414526240014,
        "id": "222caaa1-a310-416f-8e44-59b5cd680171"
      },
      {
        "review_id": "0816b867-101f-4f64-80f9-2789d6be253d",
        "comment": "the customer service was A1",
        "subject_group": "customer service",
        "category": "service",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0003376414526240014,
        "id": "9c91f85b-e538-4621-8536-d5e7835f6c4e"
      },
      {
        "review_id": "0816b867-101f-4f64-80f9-2789d6be253d",
        "comment": "the half and half sweet tea with lemonade",
        "subject_group": "sweet tea",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.0003376414526240014,
        "id": "cd053e53-b6fd-40fa-ae17-23b5ea20bac6"
      },
      {
        "review_id": "0816b867-101f-4f64-80f9-2789d6be253d",
        "comment": "I got the sausage egg and cheese on a Croissant",
        "subject_group": "sausage egg and cheese",
        "category": "product",
        "attribute": "preparation",
        "sentiment": "positive",
        "attribute_impact": 0.0003376414526240014,
        "id": "d2640f5d-64cd-45bd-b2e3-77df91bdc9da"
      },
      {
        "review_id": "0816b867-101f-4f64-80f9-2789d6be253d",
        "comment": "the eggs were fluffy",
        "subject_group": "eggs",
        "category": "product",
        "attribute": "texture",
        "sentiment": "positive",
        "attribute_impact": 0.0003376414526240014,
        "id": "e6d11603-6fe6-46c8-b7f8-a9789f5b8cdd"
      },
      {
        "review_id": "0816b867-101f-4f64-80f9-2789d6be253d",
        "comment": "the tea was perfect",
        "subject_group": "tea",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0003376414526240014,
        "id": "f44a3e41-6e2c-45f6-b4b1-67c29dc61b06"
      },
      {
        "review_id": "0816b867-101f-4f64-80f9-2789d6be253d",
        "comment": "you can smell the butter from the bag",
        "subject_group": "butter",
        "category": "product",
        "attribute": "aroma",
        "sentiment": "positive",
        "attribute_impact": 0.0003376414526240014,
        "id": "f6047640-58d6-452d-a094-a0a4a9aae264"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "2 months ago",
    "estimated_datetime": "2024-11-19T18:57:32",
    "profile_name": "Niko Nikodem",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUQzeklIalVnEAE",
    "review_text": "Close to Wall St., close to Battery Park, close to the WTC. Right in the center 😉 Great pastry shop and more. Pleasant interior and selection of coffees.",
    "cumulative_rating": 4.3229571984435795,
    "review_impact": 0.00236349016836801,
    "api_order": 256,
    "id": "d5165bec-3cf0-4f71-92ce-3a3a5ca24452",
    "analysis": [
      {
        "review_id": "d5165bec-3cf0-4f71-92ce-3a3a5ca24452",
        "comment": "Close to Wall St., close to Battery Park, close to the WTC.",
        "subject_group": "location",
        "category": "experience",
        "attribute": "accessibility",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "3d7de081-1130-4496-a220-a8a8f5d511ec"
      },
      {
        "review_id": "d5165bec-3cf0-4f71-92ce-3a3a5ca24452",
        "comment": "Pleasant interior and selection of coffees.",
        "subject_group": "coffee",
        "category": "product",
        "attribute": "variety",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "3f869f61-7b95-479d-bd8b-35d12d02d73a"
      },
      {
        "review_id": "d5165bec-3cf0-4f71-92ce-3a3a5ca24452",
        "comment": "Great pastry shop and more.",
        "subject_group": "pastry",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "9be3c75c-2e2f-45bd-b444-8975eb039875"
      },
      {
        "review_id": "d5165bec-3cf0-4f71-92ce-3a3a5ca24452",
        "comment": "Pleasant interior and selection of coffees.",
        "subject_group": "interior",
        "category": "experience",
        "attribute": "atmosphere",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "9e42a3f6-61cf-40bc-b8cb-21089a3a045e"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "2 months ago",
    "estimated_datetime": "2024-11-16T16:33:32",
    "profile_name": "Vladimir Khachaturov",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUMzcWN6dWVnEAE",
    "review_text": "We accidentally walked into the place and decided to give it a try. Service was fast, employees were nice, and it was pretty clean. I really loved my cappuccino l, ecler and croissant. The only downsize was the dirt chairs. Those need to be changed, but overall, it's a good place. I definitely recommend coming here.",
    "cumulative_rating": 4.3203125,
    "review_impact": 0.00236349016836801,
    "api_order": 255,
    "id": "372c8f35-0ca4-4e80-b592-206f6ab37951",
    "analysis": [
      {
        "review_id": "372c8f35-0ca4-4e80-b592-206f6ab37951",
        "comment": "the only downsize was the dirt chairs",
        "subject_group": "chair",
        "category": "experience",
        "attribute": "condition",
        "sentiment": "negative",
        "attribute_impact": 0.0,
        "id": "26cde985-7381-416d-aad9-9f9216fd850e"
      },
      {
        "review_id": "372c8f35-0ca4-4e80-b592-206f6ab37951",
        "comment": "I really loved my cappuccino",
        "subject_group": "cappuccino",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "3308cdaa-7afb-4a65-8392-7382563259ef"
      },
      {
        "review_id": "372c8f35-0ca4-4e80-b592-206f6ab37951",
        "comment": "employees were nice",
        "subject_group": "employee",
        "category": "service",
        "attribute": "friendliness",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "72160d45-6fcc-443c-ba85-6e723a5e5329"
      },
      {
        "review_id": "372c8f35-0ca4-4e80-b592-206f6ab37951",
        "comment": "I really loved my eclair",
        "subject_group": "eclair",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "a0eb2ada-6d27-4c53-812f-c1dba41485cd"
      },
      {
        "review_id": "372c8f35-0ca4-4e80-b592-206f6ab37951",
        "comment": "Service was fast",
        "subject_group": "service",
        "category": "service",
        "attribute": "speed",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "be565e6c-7dce-4b91-8e78-24eb6c1b6eaf"
      },
      {
        "review_id": "372c8f35-0ca4-4e80-b592-206f6ab37951",
        "comment": "it was pretty clean",
        "subject_group": "place",
        "category": "experience",
        "attribute": "cleanliness",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "e9eab797-1540-49e1-9f43-905ce58ab0ee"
      },
      {
        "review_id": "372c8f35-0ca4-4e80-b592-206f6ab37951",
        "comment": "I really loved my croissant",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "ed0b26c8-29b7-4f9e-9078-7f21ff461bb0"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "2 months ago",
    "estimated_datetime": "2024-11-13T14:09:32",
    "profile_name": "Anatoly Tolpin",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUMzNU15MEFnEAE",
    "review_text": "Great eclair !",
    "cumulative_rating": 4.317647058823529,
    "review_impact": 0.00236349016836801,
    "api_order": 254,
    "id": "0911dd69-962a-48d4-b2de-9d55a94df50c",
    "analysis": [
      {
        "review_id": "0911dd69-962a-48d4-b2de-9d55a94df50c",
        "comment": "Great eclair !",
        "subject_group": "eclair",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00236349016836801,
        "id": "5b8bcd47-6a0f-4242-b018-5bb6e6478808"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "4 days ago",
    "estimated_datetime": "2025-01-23T00:57:32",
    "profile_name": "Vikramaditya Vicky",
    "rating": 3,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSURfNHZTTnBRRRAB",
    "review_text": "I tried a chocolate croissant right after work. While it was good, I found it overpriced for the taste and size. I paid $10 for a mid-sized croissant, which felt steep. For the quality and location, I believe $6 would have been a more reasonable price. Overall, it was decent, but not worth the premium.",
    "cumulative_rating": 4.316901408450704,
    "review_impact": -0.004629516824638635,
    "api_order": 283,
    "id": "2bdc5a1b-3c0c-4064-809f-60257be8c72b",
    "analysis": [
      {
        "review_id": "2bdc5a1b-3c0c-4064-809f-60257be8c72b",
        "comment": "I tried a chocolate croissant right after work.",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "85953bb0-66fa-4773-927a-34d7001a48af"
      },
      {
        "review_id": "2bdc5a1b-3c0c-4064-809f-60257be8c72b",
        "comment": "I found it overpriced for the taste and size.",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "price",
        "sentiment": "negative",
        "attribute_impact": -0.0011573792061596588,
        "id": "241a997d-1aa7-4278-88c8-540fefdee26c"
      },
      {
        "review_id": "2bdc5a1b-3c0c-4064-809f-60257be8c72b",
        "comment": "Overall, it was decent, but not worth the premium.",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "value",
        "sentiment": "negative",
        "attribute_impact": -0.0011573792061596588,
        "id": "2a05223b-3b94-4c1e-a5be-deafd9b5e92a"
      },
      {
        "review_id": "2bdc5a1b-3c0c-4064-809f-60257be8c72b",
        "comment": "For the quality and location, I believe $6 would have been a more reasonable price.",
        "subject_group": "price",
        "category": "product",
        "attribute": "value",
        "sentiment": "negative",
        "attribute_impact": -0.0011573792061596588,
        "id": "a420ae7c-9d34-4be6-9e04-13513d4cf825"
      },
      {
        "review_id": "2bdc5a1b-3c0c-4064-809f-60257be8c72b",
        "comment": "I paid $10 for a mid-sized croissant, which felt steep.",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "price",
        "sentiment": "negative",
        "attribute_impact": -0.0011573792061596588,
        "id": "f057fe64-1746-4ea4-a132-dd6fdcd7fa67"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "2 months ago",
    "estimated_datetime": "2024-11-10T11:45:32",
    "profile_name": "Naima",
    "rating": 1,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUMzZ0p1OS1nRRAB",
    "review_text": null,
    "cumulative_rating": 4.31496062992126,
    "review_impact": -0.011622523817646169,
    "api_order": 253,
    "id": "b03a0a1d-5d78-49c6-95a9-e446668f7a03",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "2 months ago",
    "estimated_datetime": "2024-11-07T09:21:32",
    "profile_name": "Tina Sol",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSURYbDhpSU1BEAE",
    "review_text": "What a warm and welcoming bakeshop! This spot is not only cute and yummy, but the staff are super sweet! And don’t even get me started on the matcha - the quality was phenomenal! Truly a must-visit",
    "cumulative_rating": 4.32806324110672,
    "review_impact": 0.00236349016836801,
    "api_order": 252,
    "id": "4bc74e54-3e30-4331-b4ce-4c9c54e1e9a7",
    "analysis": [
      {
        "review_id": "4bc74e54-3e30-4331-b4ce-4c9c54e1e9a7",
        "comment": "And don’t even get me started on the matcha - the quality was phenomenal!",
        "subject_group": "matcha",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "26071ab6-9290-4f66-a10b-48bb83d41461"
      },
      {
        "review_id": "4bc74e54-3e30-4331-b4ce-4c9c54e1e9a7",
        "comment": "This spot is not only cute and yummy, but the staff are super sweet!",
        "subject_group": "spot",
        "category": "experience",
        "attribute": "cuteness",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "32059796-d8cd-4579-b0fd-1ad2fbfacbc1"
      },
      {
        "review_id": "4bc74e54-3e30-4331-b4ce-4c9c54e1e9a7",
        "comment": "What a warm and welcoming bakeshop!",
        "subject_group": "bakeshop",
        "category": "experience",
        "attribute": "warmth",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "400458e3-f785-4440-9a7a-724baa1df5ed"
      },
      {
        "review_id": "4bc74e54-3e30-4331-b4ce-4c9c54e1e9a7",
        "comment": "This spot is not only cute and yummy, but the staff are super sweet!",
        "subject_group": "spot",
        "category": "experience",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "74cdc5d4-16bf-448b-9a45-c734e4f1945f"
      },
      {
        "review_id": "4bc74e54-3e30-4331-b4ce-4c9c54e1e9a7",
        "comment": "This spot is not only cute and yummy, but the staff are super sweet!",
        "subject_group": "staff",
        "category": "service",
        "attribute": "kindness",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "b521286a-98d0-431f-95d4-9d20798daa5c"
      },
      {
        "review_id": "4bc74e54-3e30-4331-b4ce-4c9c54e1e9a7",
        "comment": "What a warm and welcoming bakeshop!",
        "subject_group": "bakeshop",
        "category": "experience",
        "attribute": "welcoming",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "c954d0e3-72f6-4e7b-a8dc-7a82595a48b3"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "2 months ago",
    "estimated_datetime": "2024-11-04T06:57:32",
    "profile_name": "Jordan Michelle",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSURYaDlubjl3RRAB",
    "review_text": "This place has the best food. It is really pricey but every now and then to come is fine. It really adds up in the wallet if you’re coming a couple times a week though.",
    "cumulative_rating": 4.325396825396825,
    "review_impact": 0.00236349016836801,
    "api_order": 251,
    "id": "94c3c61c-f2c4-4100-ad57-a2017d1f4faa",
    "analysis": [
      {
        "review_id": "94c3c61c-f2c4-4100-ad57-a2017d1f4faa",
        "comment": "It is really pricey",
        "subject_group": "price",
        "category": "product",
        "attribute": "cost",
        "sentiment": "negative",
        "attribute_impact": 0.0,
        "id": "2db6ad17-e13d-406c-80a2-7135429c0e1c"
      },
      {
        "review_id": "94c3c61c-f2c4-4100-ad57-a2017d1f4faa",
        "comment": "It really adds up in the wallet if you’re coming a couple times a week though",
        "subject_group": "cost",
        "category": "product",
        "attribute": "expense",
        "sentiment": "negative",
        "attribute_impact": 0.0,
        "id": "06370bf3-9530-43b4-a64a-8ee3d6d4f5e8"
      },
      {
        "review_id": "94c3c61c-f2c4-4100-ad57-a2017d1f4faa",
        "comment": "This place has the best food",
        "subject_group": "food",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00236349016836801,
        "id": "856a1873-8b8f-4bbe-a525-928b4e72bc79"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "2 months ago",
    "estimated_datetime": "2024-11-01T04:33:32",
    "profile_name": "Peter",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSURCdnNldHZnRRAB",
    "review_text": "Great breakfast. Plain croissant is the best I ever had anywhere. And they have alot of different types of croissants too. I also tried the crookie or the chocolate chip cookie croissant. It was soooo good.",
    "cumulative_rating": 4.322709163346613,
    "review_impact": 0.00236349016836801,
    "api_order": 250,
    "id": "8d441867-bac6-4d7e-83c5-8f362e0c066a",
    "analysis": [
      {
        "review_id": "8d441867-bac6-4d7e-83c5-8f362e0c066a",
        "comment": "I also tried the crookie or the chocolate chip cookie croissant",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "variety",
        "sentiment": "positive",
        "attribute_impact": 0.00047269803367360196,
        "id": "08a18830-54bd-4b94-815e-2a975fae7e1a"
      },
      {
        "review_id": "8d441867-bac6-4d7e-83c5-8f362e0c066a",
        "comment": "Great breakfast",
        "subject_group": "breakfast",
        "category": "experience",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00047269803367360196,
        "id": "256a36c2-7204-4443-bcfe-7e4ef533af4c"
      },
      {
        "review_id": "8d441867-bac6-4d7e-83c5-8f362e0c066a",
        "comment": "Plain croissant is the best I ever had anywhere",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00047269803367360196,
        "id": "75460d9e-9f52-4731-9e33-4cec488053c8"
      },
      {
        "review_id": "8d441867-bac6-4d7e-83c5-8f362e0c066a",
        "comment": "It was soooo good",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00047269803367360196,
        "id": "773ae973-5b07-455b-877f-9ef5f90c4e60"
      },
      {
        "review_id": "8d441867-bac6-4d7e-83c5-8f362e0c066a",
        "comment": "they have a lot of different types of croissants too",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "variety",
        "sentiment": "positive",
        "attribute_impact": 0.00047269803367360196,
        "id": "ca532864-6a4c-4a93-919e-3e23f509cd34"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "2 months ago",
    "estimated_datetime": "2024-10-29T02:09:32",
    "profile_name": "ADSJ 07",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSURYODl1RUJnEAE",
    "review_text": null,
    "cumulative_rating": 4.32,
    "review_impact": 0.00236349016836801,
    "api_order": 249,
    "id": "33efa9bb-1c50-48dd-9cd9-d9b42b400640",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "3 months ago",
    "estimated_datetime": "2024-10-26T18:00:41.473692",
    "profile_name": "shweta singhal",
    "rating": 1,
    "provider_review_id": "ChRDSUhNMG9nS0VJQ0FnSURYc3RjQxAB",
    "review_text": "It is the worst place in nyc. Super expensive and the staff is so bad. It felt like they don’t care for customers. Coffee was cold and when we told them they said machine made it and they can’t do much. Don’t waste your money on this cafe.",
    "cumulative_rating": 4.317269076305221,
    "review_impact": -0.011622523817646169,
    "api_order": 248,
    "id": "e18ab357-87ce-4375-ad44-d9c0a4873df8",
    "analysis": [
      {
        "review_id": "e18ab357-87ce-4375-ad44-d9c0a4873df8",
        "comment": "Coffee was cold",
        "subject_group": "coffee",
        "category": "product",
        "attribute": "temperature",
        "sentiment": "negative",
        "attribute_impact": -0.0023245047635292336,
        "id": "03198d92-a0f7-4d3e-99d1-1865e01dfb20"
      },
      {
        "review_id": "e18ab357-87ce-4375-ad44-d9c0a4873df8",
        "comment": "Super expensive",
        "subject_group": "price",
        "category": "product",
        "attribute": "expense",
        "sentiment": "negative",
        "attribute_impact": -0.0023245047635292336,
        "id": "2a276716-2904-46f3-8dcd-2283711be0da"
      },
      {
        "review_id": "e18ab357-87ce-4375-ad44-d9c0a4873df8",
        "comment": "Don’t waste your money on this cafe",
        "subject_group": "money",
        "category": "experience",
        "attribute": "value",
        "sentiment": "negative",
        "attribute_impact": -0.0023245047635292336,
        "id": "85cde71d-dd71-4757-a93f-29cf3d02c9e6"
      },
      {
        "review_id": "e18ab357-87ce-4375-ad44-d9c0a4873df8",
        "comment": "the staff is so bad",
        "subject_group": "staff",
        "category": "service",
        "attribute": "quality",
        "sentiment": "negative",
        "attribute_impact": -0.0023245047635292336,
        "id": "cdd4e761-d17e-44b4-af9d-84ab970fd66d"
      },
      {
        "review_id": "e18ab357-87ce-4375-ad44-d9c0a4873df8",
        "comment": "It felt like they don’t care for customers",
        "subject_group": "care",
        "category": "service",
        "attribute": "attention",
        "sentiment": "negative",
        "attribute_impact": -0.0023245047635292336,
        "id": "e0bdc379-f5a4-4e1b-a679-b61cc2df3f75"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "3 months ago",
    "estimated_datetime": "2024-10-25T04:07:00.421060",
    "profile_name": "Seimen Burum",
    "rating": 4,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSURYdUtlTkN3EAE",
    "review_text": "Nice clean bakery with good coffee and food.",
    "cumulative_rating": 4.330645161290323,
    "review_impact": -0.0011330133281353127,
    "api_order": 247,
    "id": "4f2278ed-db5f-4219-a477-f0801e013e65",
    "analysis": [
      {
        "review_id": "4f2278ed-db5f-4219-a477-f0801e013e65",
        "comment": "Nice clean bakery with good coffee and food",
        "subject_group": "bakery",
        "category": "experience",
        "attribute": "cleanliness",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "ede6b0b9-6388-40d5-bee2-00ffba63cdb1"
      },
      {
        "review_id": "4f2278ed-db5f-4219-a477-f0801e013e65",
        "comment": "Nice clean bakery with good coffee and food",
        "subject_group": "coffee",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "2e137e80-a92d-4d14-8bda-c230bcc9ecbd"
      },
      {
        "review_id": "4f2278ed-db5f-4219-a477-f0801e013e65",
        "comment": "Nice clean bakery with good coffee and food",
        "subject_group": "food",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "8eb0a4e8-d9a1-4ee1-9f8d-919a43669ee3"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "3 months ago",
    "estimated_datetime": "2024-10-23T14:13:19.368428",
    "profile_name": "Kevin Wong",
    "rating": 1,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUNYMTRuUW93RRAB",
    "review_text": "Food was ok but expensive. Customer service is atrocious! We bought $40 worth of stuff (4 plates of pastries) and they wouldn’t even give us more than 2 sets of utensils even after we asked for it.",
    "cumulative_rating": 4.331983805668016,
    "review_impact": -0.011622523817646169,
    "api_order": 246,
    "id": "dab62817-6886-428b-b361-5d707399caaa",
    "analysis": [
      {
        "review_id": "dab62817-6886-428b-b361-5d707399caaa",
        "comment": "Food was ok but expensive",
        "subject_group": "food",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "704d1119-b562-4836-8a07-1c8a24a94a99"
      },
      {
        "review_id": "dab62817-6886-428b-b361-5d707399caaa",
        "comment": "Customer service is atrocious",
        "subject_group": "service",
        "category": "service",
        "attribute": "quality",
        "sentiment": "negative",
        "attribute_impact": -0.003874174605882056,
        "id": "28ec6386-81a5-4228-ad43-4ec75486fd1a"
      },
      {
        "review_id": "dab62817-6886-428b-b361-5d707399caaa",
        "comment": "Food was ok but expensive",
        "subject_group": "food",
        "category": "product",
        "attribute": "price",
        "sentiment": "negative",
        "attribute_impact": -0.003874174605882056,
        "id": "7fd1c2eb-8a15-483c-b189-c950fe5dfd9c"
      },
      {
        "review_id": "dab62817-6886-428b-b361-5d707399caaa",
        "comment": "We bought $40 worth of stuff and they wouldn’t even give us more than 2 sets of utensils even after we asked for it",
        "subject_group": "service",
        "category": "service",
        "attribute": "response",
        "sentiment": "negative",
        "attribute_impact": -0.003874174605882056,
        "id": "9e779e59-c5ea-4380-a987-d4743b8f0828"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "3 months ago",
    "estimated_datetime": "2024-10-22T00:19:38.315796",
    "profile_name": "Emma",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUNYb19DSmdBRRAB",
    "review_text": "I ordered a croissant and a coffee, it was very good, there is a wide choice of hot drinks and a small variety of quality pastries.",
    "cumulative_rating": 4.345528455284553,
    "review_impact": 0.00236349016836801,
    "api_order": 245,
    "id": "9f842526-08b5-4764-8130-0e8e477e6df8",
    "analysis": [
      {
        "review_id": "9f842526-08b5-4764-8130-0e8e477e6df8",
        "comment": "there is a wide choice of hot drinks",
        "subject_group": "choice",
        "category": "product",
        "attribute": "variety",
        "sentiment": "positive",
        "attribute_impact": 0.00047269803367360196,
        "id": "2cd4e386-38d9-4f1d-8b20-feb0e859453b"
      },
      {
        "review_id": "9f842526-08b5-4764-8130-0e8e477e6df8",
        "comment": "I ordered a croissant and a coffee",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00047269803367360196,
        "id": "47f03995-042c-425b-8e30-e23c7836bb02"
      },
      {
        "review_id": "9f842526-08b5-4764-8130-0e8e477e6df8",
        "comment": "it was very good",
        "subject_group": "experience",
        "category": "experience",
        "attribute": "satisfaction",
        "sentiment": "positive",
        "attribute_impact": 0.00047269803367360196,
        "id": "53864b56-d5fb-4b38-b021-5794547234bc"
      },
      {
        "review_id": "9f842526-08b5-4764-8130-0e8e477e6df8",
        "comment": "I ordered a croissant and a coffee",
        "subject_group": "coffee",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00047269803367360196,
        "id": "cde06c6d-6600-49b9-906f-abe483a2a55a"
      },
      {
        "review_id": "9f842526-08b5-4764-8130-0e8e477e6df8",
        "comment": "a small variety of quality pastries",
        "subject_group": "pastry",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00047269803367360196,
        "id": "e7ed16f7-0440-450d-9752-2f599a4a464f"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "3 months ago",
    "estimated_datetime": "2024-10-20T10:25:57.263164",
    "profile_name": "Caffe",
    "rating": 4,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUNYZy1uVGpRRRAB",
    "review_text": "A little small but fast service",
    "cumulative_rating": 4.3428571428571425,
    "review_impact": -0.0011330133281353127,
    "api_order": 244,
    "id": "cbb22536-34eb-4488-b58c-53b00822258c",
    "analysis": [
      {
        "review_id": "cbb22536-34eb-4488-b58c-53b00822258c",
        "comment": "A little small but fast service",
        "subject_group": "service",
        "category": "service",
        "attribute": "speed",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "9df76e6d-6dc4-4640-8ce4-179dd87d304a"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "3 months ago",
    "estimated_datetime": "2024-10-18T20:32:16.210532",
    "profile_name": "Angelo",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNYX2VYaVRnEAE",
    "review_text": "I’m here everyday and this place is part of my daily routine. It’s a neighborhood staple and by far the best croissants I’ve had since my Paris days. Great Job to the entire staff.",
    "cumulative_rating": 4.344262295081967,
    "review_impact": 0.00236349016836801,
    "api_order": 243,
    "id": "1acb0cb3-d46c-4c04-8e7e-d952a20fea86",
    "analysis": [
      {
        "review_id": "1acb0cb3-d46c-4c04-8e7e-d952a20fea86",
        "comment": "I’m here everyday and this place is part of my daily routine",
        "subject_group": "place",
        "category": "experience",
        "attribute": "routine",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "19b43fbf-671a-4bbb-96ec-107695c07ed3"
      },
      {
        "review_id": "1acb0cb3-d46c-4c04-8e7e-d952a20fea86",
        "comment": "It’s a neighborhood staple",
        "subject_group": "staple",
        "category": "product",
        "attribute": "neighborhood",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "3ba36ec6-f392-4d54-9e1e-d7c06a0d3942"
      },
      {
        "review_id": "1acb0cb3-d46c-4c04-8e7e-d952a20fea86",
        "comment": "by far the best croissants I’ve had since my Paris days",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "aa8bf452-e96e-4df6-84d3-147f974e4087"
      },
      {
        "review_id": "1acb0cb3-d46c-4c04-8e7e-d952a20fea86",
        "comment": "Great Job to the entire staff",
        "subject_group": "staff",
        "category": "service",
        "attribute": "performance",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "c3ae13af-8c78-4cca-abe5-3eb911fbd935"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a week ago",
    "estimated_datetime": "2025-01-14T16:57:32",
    "profile_name": "Trung Tran",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNfeXIzOFlREAE",
    "review_text": "We had a good experience. It was our last morning in NYC before heading out (car service to LGA).  I surprised the family w some breakfast from Siena.  Good food, value seemed reasonable.  I was there a few min before open, and the staff was friendly, esp for how early it was.  Our other breakfast spot had been a nearby Delicatessen.",
    "cumulative_rating": 4.3428571428571425,
    "review_impact": 0.00236349016836801,
    "api_order": 279,
    "id": "991b1689-b63e-4761-8372-13f2f564bd47",
    "analysis": [
      {
        "review_id": "991b1689-b63e-4761-8372-13f2f564bd47",
        "comment": "Good food, value seemed reasonable",
        "subject_group": "food",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "317504a5-0acd-4560-b368-a0477969f674"
      },
      {
        "review_id": "991b1689-b63e-4761-8372-13f2f564bd47",
        "comment": "We had a good experience",
        "subject_group": "experience",
        "category": "experience",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "601c045f-b499-4a97-a7c8-3d7bf79a4a99"
      },
      {
        "review_id": "991b1689-b63e-4761-8372-13f2f564bd47",
        "comment": "the staff was friendly",
        "subject_group": "staff",
        "category": "service",
        "attribute": "friendliness",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "638d8925-47f7-4da2-8354-13cff27b0611"
      },
      {
        "review_id": "991b1689-b63e-4761-8372-13f2f564bd47",
        "comment": "Good food, value seemed reasonable",
        "subject_group": "value",
        "category": "product",
        "attribute": "reasonableness",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "65499f22-00e7-4bad-a632-31485bddf1fa"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "3 months ago",
    "estimated_datetime": "2024-10-17T06:38:35.157900",
    "profile_name": "Zach Balis",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNYX1lXRmJBEAE",
    "review_text": "The quality of food and service was excellent! It’s a neighborhood staple that everyone should try.",
    "cumulative_rating": 4.341563786008231,
    "review_impact": 0.00236349016836801,
    "api_order": 242,
    "id": "50f5ef68-4ad8-4ea9-8508-1ca524cf8ea9",
    "analysis": [
      {
        "review_id": "50f5ef68-4ad8-4ea9-8508-1ca524cf8ea9",
        "comment": "It’s a neighborhood staple that everyone should try.",
        "subject_group": "staple",
        "category": "product",
        "attribute": "neighborhood",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "79443d1b-fcf5-4eef-a9b6-523f1e8b5071"
      },
      {
        "review_id": "50f5ef68-4ad8-4ea9-8508-1ca524cf8ea9",
        "comment": "The quality of food and service was excellent!",
        "subject_group": "food",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "ac08308b-e300-4175-b42a-54c4f8cb2a73"
      },
      {
        "review_id": "50f5ef68-4ad8-4ea9-8508-1ca524cf8ea9",
        "comment": "The quality of food and service was excellent!",
        "subject_group": "service",
        "category": "service",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "b4e77d66-83bf-4ff2-99e4-d6f5c0bfed7b"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "3 months ago",
    "estimated_datetime": "2024-10-15T16:44:54.105268",
    "profile_name": "Damian Ayarza",
    "rating": 1,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNYbmFQTU5nEAE",
    "review_text": "Very bad service from the store manager despite the kindness of a waitress who wanted to help us place the order, I told her not to get angry 3 times and she kept yelling until we left, bad experience, go to George's across the street …",
    "cumulative_rating": 4.338842975206612,
    "review_impact": -0.011622523817646169,
    "api_order": 241,
    "id": "f6f9b2a2-a7c7-4b78-b67b-b09bd4151959",
    "analysis": [
      {
        "review_id": "f6f9b2a2-a7c7-4b78-b67b-b09bd4151959",
        "comment": "despite the kindness of a waitress who wanted to help us place the order",
        "subject_group": "waitress",
        "category": "service",
        "attribute": "kindness",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "311a4f04-a6e7-437f-9bdf-bb40cd1c6dd6"
      },
      {
        "review_id": "f6f9b2a2-a7c7-4b78-b67b-b09bd4151959",
        "comment": "she kept yelling until we left",
        "subject_group": "service",
        "category": "service",
        "attribute": "behavior",
        "sentiment": "negative",
        "attribute_impact": -0.003874174605882056,
        "id": "83b84c81-1b4b-4ac5-a832-b327082f2337"
      },
      {
        "review_id": "f6f9b2a2-a7c7-4b78-b67b-b09bd4151959",
        "comment": "bad experience",
        "subject_group": "experience",
        "category": "experience",
        "attribute": "quality",
        "sentiment": "negative",
        "attribute_impact": -0.003874174605882056,
        "id": "aff383b4-6f98-49d4-afbb-ecff7074a8a2"
      },
      {
        "review_id": "f6f9b2a2-a7c7-4b78-b67b-b09bd4151959",
        "comment": "Very bad service from the store manager",
        "subject_group": "service",
        "category": "service",
        "attribute": "quality",
        "sentiment": "negative",
        "attribute_impact": -0.003874174605882056,
        "id": "c47d2fd0-08a6-415c-a18a-7cd7fb4b9c96"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "3 months ago",
    "estimated_datetime": "2024-10-14T02:51:13.052636",
    "profile_name": "Maria Zapata Canessa",
    "rating": 2,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNYMHUta0tBEAE",
    "review_text": null,
    "cumulative_rating": 4.352697095435684,
    "review_impact": -0.008126020321142846,
    "api_order": 240,
    "id": "f2ceca47-6a3f-4562-bdf5-015fa12456d7",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "3 months ago",
    "estimated_datetime": "2024-10-12T12:57:32.000004",
    "profile_name": "E Gv",
    "rating": 1,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUNYLU9EZmdnRRAB",
    "review_text": "I went to pick up an order at this place, when I entered I found a very hostile attitude, she didn't even want to talk to me, the others told her, and she was the one in front, she just looked at me angril",
    "cumulative_rating": 4.3625,
    "review_impact": -0.011622523817646169,
    "api_order": 239,
    "id": "1b5ab56e-72e3-40fc-ac0e-2f15f6b8f23b",
    "analysis": [
      {
        "review_id": "1b5ab56e-72e3-40fc-ac0e-2f15f6b8f23b",
        "comment": "she just looked at me angrily",
        "subject_group": "gaze",
        "category": "service",
        "attribute": "anger",
        "sentiment": "negative",
        "attribute_impact": -0.003874174605882056,
        "id": "1e6cf90c-9214-413e-9a4a-6013d75212c7"
      },
      {
        "review_id": "1b5ab56e-72e3-40fc-ac0e-2f15f6b8f23b",
        "comment": "she didn't even want to talk to me",
        "subject_group": "communication",
        "category": "service",
        "attribute": "lack",
        "sentiment": "negative",
        "attribute_impact": -0.003874174605882056,
        "id": "5a7fa16b-42d7-44ac-be19-a4a5e8f57677"
      },
      {
        "review_id": "1b5ab56e-72e3-40fc-ac0e-2f15f6b8f23b",
        "comment": "I found a very hostile attitude",
        "subject_group": "attitude",
        "category": "service",
        "attribute": "hostility",
        "sentiment": "negative",
        "attribute_impact": -0.003874174605882056,
        "id": "a8843939-2ac2-4ae6-9940-b939d61272ad"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "3 months ago",
    "estimated_datetime": "2024-10-10T23:03:50.947372",
    "profile_name": "Amit Kosto",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNYOE1TTE53EAE",
    "review_text": "Amazing food. Took like 8 things salty and sweet. Everything was very very tasty",
    "cumulative_rating": 4.376569037656904,
    "review_impact": 0.00236349016836801,
    "api_order": 238,
    "id": "11762276-6695-4899-b1ef-d04600d51da1",
    "analysis": [
      {
        "review_id": "11762276-6695-4899-b1ef-d04600d51da1",
        "comment": "Everything was very very tasty",
        "subject_group": "food",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "86d0b4ba-611f-4e09-808a-f4bbb6f95931"
      },
      {
        "review_id": "11762276-6695-4899-b1ef-d04600d51da1",
        "comment": "Amazing food",
        "subject_group": "food",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "c01c1309-ad85-4d01-b3ad-c7ee4d59ab02"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "3 months ago",
    "estimated_datetime": "2024-10-09T09:10:09.894740",
    "profile_name": "einav shir",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNYOE1UOUFnEAE",
    "review_text": null,
    "cumulative_rating": 4.373949579831932,
    "review_impact": 0.00236349016836801,
    "api_order": 237,
    "id": "f696b14c-eee3-4dce-bebb-17d1f9886c0b",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "6 days ago",
    "estimated_datetime": "2025-01-21T00:57:32",
    "profile_name": "Saady Restrepo",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSURfOEpXeGtBRRAB",
    "review_text": "Very fresh sweets, friendly service, everything clean\nHighly recommended if you are in that area.",
    "cumulative_rating": 4.321554770318021,
    "review_impact": 0.00236349016836801,
    "api_order": 282,
    "id": "ac31096c-557a-4ab3-8b14-387fb2cb2b11",
    "analysis": [
      {
        "review_id": "ac31096c-557a-4ab3-8b14-387fb2cb2b11",
        "comment": "Highly recommended if you are in that area",
        "subject_group": "recommendation",
        "category": "experience",
        "attribute": "recommendation",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "175f64e9-ffd6-4ccb-8020-29242e671207"
      },
      {
        "review_id": "ac31096c-557a-4ab3-8b14-387fb2cb2b11",
        "comment": "Very fresh sweets",
        "subject_group": "sweet",
        "category": "product",
        "attribute": "freshness",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "2047157a-5e37-4f1e-8610-f103cf30a458"
      },
      {
        "review_id": "ac31096c-557a-4ab3-8b14-387fb2cb2b11",
        "comment": "everything clean",
        "subject_group": "cleanliness",
        "category": "experience",
        "attribute": "cleanliness",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "6e105893-6bea-4c50-a38c-14a44055c78e"
      },
      {
        "review_id": "ac31096c-557a-4ab3-8b14-387fb2cb2b11",
        "comment": "friendly service",
        "subject_group": "service",
        "category": "service",
        "attribute": "friendliness",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "9914bca8-0826-4b6f-a37b-c905963d198a"
      }
    ]
  },

  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "3 months ago",
    "estimated_datetime": "2024-10-07T19:16:28.842108",
    "profile_name": "LVS",
    "rating": 3,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUNYNE11WmlRRRAB",
    "review_text": "Very pretty bakery, with a very nice choice of treats, pastries, pastries, they even have a pizzeria right next door,\n\nHonestly it's very good, but as a French person I admit that it's missing a little something in terms of the dough, the bread, etc...\nBut above all the prices are quite high and this is quickly felt when you have a few pastries for breakfast 😅\n\n@lvs.kid",
    "cumulative_rating": 4.371308016877637,
    "review_impact": -0.004629516824638635,
    "api_order": 236,
    "id": "02aba57f-ef3a-436d-ad63-5c595833f4bb",
    "analysis": [
      {
        "review_id": "02aba57f-ef3a-436d-ad63-5c595833f4bb",
        "comment": "Very pretty bakery",
        "subject_group": "bakery",
        "category": "experience",
        "attribute": "beauty",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "6899adff-f473-4b45-92bc-c6d7d2699797"
      },
      {
        "review_id": "02aba57f-ef3a-436d-ad63-5c595833f4bb",
        "comment": "very nice choice of treats",
        "subject_group": "choice",
        "category": "product",
        "attribute": "variety",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "dd61ec73-a286-4128-8579-e7f665145e86"
      },
      {
        "review_id": "02aba57f-ef3a-436d-ad63-5c595833f4bb",
        "comment": "the prices are quite high",
        "subject_group": "prices",
        "category": "product",
        "attribute": "cost",
        "sentiment": "negative",
        "attribute_impact": -0.0023147584123193177,
        "id": "c4112fff-0e85-416a-b6c5-d57fb4b8792d"
      },
      {
        "review_id": "02aba57f-ef3a-436d-ad63-5c595833f4bb",
        "comment": "it's missing a little something in terms of the dough",
        "subject_group": "dough",
        "category": "product",
        "attribute": "quality",
        "sentiment": "negative",
        "attribute_impact": -0.0023147584123193177,
        "id": "d9992794-f942-4f28-9d4d-b5890533f5b5"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "3 months ago",
    "estimated_datetime": "2024-10-06T05:22:47.789476",
    "profile_name": "Virginia Caseiro",
    "rating": 2,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSURuLThId3JRRRAB",
    "review_text": "2nd time and 2nd disappointment. The pastries are pretty but overpriced and tasteless. They charge you 3% for payment by credit card without informing you. $10.08 for a Nutella cheesecake even though it's not Nutella at all.\nI won't come back again.",
    "cumulative_rating": 4.377118644067797,
    "review_impact": -0.008126020321142846,
    "api_order": 235,
    "id": "00467a31-78c4-406d-81af-222b9ef6c2dd",
    "analysis": [
      {
        "review_id": "00467a31-78c4-406d-81af-222b9ef6c2dd",
        "comment": "The pastries are pretty but overpriced and tasteless.",
        "subject_group": "pastry",
        "category": "product",
        "attribute": "appearance",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "6a2cf7d4-fff0-4667-8e43-3d77b673b738"
      },
      {
        "review_id": "00467a31-78c4-406d-81af-222b9ef6c2dd",
        "comment": "$10.08 for a Nutella cheesecake even though it's not Nutella at all.",
        "subject_group": "cheesecake",
        "category": "product",
        "attribute": "authenticity",
        "sentiment": "negative",
        "attribute_impact": -0.0013543367201904744,
        "id": "39410831-3862-4e2e-bace-e52e946a75cb"
      },
      {
        "review_id": "00467a31-78c4-406d-81af-222b9ef6c2dd",
        "comment": "They charge you 3% for payment by credit card without informing you.",
        "subject_group": "charge",
        "category": "service",
        "attribute": "transparency",
        "sentiment": "negative",
        "attribute_impact": -0.0013543367201904744,
        "id": "6fb9d91e-f410-462c-98f0-0a52293adda9"
      },
      {
        "review_id": "00467a31-78c4-406d-81af-222b9ef6c2dd",
        "comment": "The pastries are pretty but overpriced and tasteless.",
        "subject_group": "pastry",
        "category": "product",
        "attribute": "price",
        "sentiment": "negative",
        "attribute_impact": -0.0013543367201904744,
        "id": "8c3868dc-8cdb-4943-9582-ee5c53959e19"
      },
      {
        "review_id": "00467a31-78c4-406d-81af-222b9ef6c2dd",
        "comment": "The pastries are pretty but overpriced and tasteless.",
        "subject_group": "pastry",
        "category": "product",
        "attribute": "taste",
        "sentiment": "negative",
        "attribute_impact": -0.0013543367201904744,
        "id": "9ac1b0c7-c7a8-4b25-8430-1518c72242fa"
      },
      {
        "review_id": "00467a31-78c4-406d-81af-222b9ef6c2dd",
        "comment": "I won't come back again.",
        "subject_group": "return",
        "category": "experience",
        "attribute": "decision",
        "sentiment": "negative",
        "attribute_impact": -0.0013543367201904744,
        "id": "b438c39d-11e7-4463-814f-c9acf0bac6de"
      },
      {
        "review_id": "00467a31-78c4-406d-81af-222b9ef6c2dd",
        "comment": "$10.08 for a Nutella cheesecake even though it's not Nutella at all.",
        "subject_group": "cheesecake",
        "category": "product",
        "attribute": "price",
        "sentiment": "negative",
        "attribute_impact": -0.0013543367201904744,
        "id": "faad42a3-8816-4f7e-a3c6-504077242f17"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "3 months ago",
    "estimated_datetime": "2024-10-04T15:29:06.736844",
    "profile_name": "Sunny",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSURucWVXSnR3RRAB",
    "review_text": "Always right to try good desserts here!",
    "cumulative_rating": 4.3872340425531915,
    "review_impact": 0.00236349016836801,
    "api_order": 234,
    "id": "6c0c283f-96ed-440f-a07d-f6358029506c",
    "analysis": [
      {
        "review_id": "6c0c283f-96ed-440f-a07d-f6358029506c",
        "comment": "Always right to try good desserts here!",
        "subject_group": "dessert",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00236349016836801,
        "id": "c7dd2f20-16a5-45d9-842d-a0ebbd50b196"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "3 months ago",
    "estimated_datetime": "2024-10-03T01:35:25.684212",
    "profile_name": "Andressa Bernardi",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSURuanF1Mm5RRRAB",
    "review_text": "Very good.",
    "cumulative_rating": 4.384615384615385,
    "review_impact": 0.00236349016836801,
    "api_order": 233,
    "id": "d0b6261e-c70a-4b75-b597-c6b10b00beb1",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "3 months ago",
    "estimated_datetime": "2024-10-01T11:41:44.631580",
    "profile_name": "Natalia Galvan",
    "rating": 3,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSURuOXEtdllBEAE",
    "review_text": "High prices, small portions. Bad service, they don't smile, they are in a hurry, they just send people away.  I don't recommend it, there are many other places to choose from.",
    "cumulative_rating": 4.381974248927039,
    "review_impact": -0.004629516824638635,
    "api_order": 232,
    "id": "3b533391-3698-44f5-99b9-75f6873637dc",
    "analysis": [
      {
        "review_id": "3b533391-3698-44f5-99b9-75f6873637dc",
        "comment": "Bad service",
        "subject_group": "service",
        "category": "service",
        "attribute": "bad",
        "sentiment": "negative",
        "attribute_impact": -0.000661359546376948,
        "id": "35aef998-9053-4c39-a619-4f153264c0c0"
      },
      {
        "review_id": "3b533391-3698-44f5-99b9-75f6873637dc",
        "comment": "they just send people away",
        "subject_group": "service",
        "category": "service",
        "attribute": "dismissal",
        "sentiment": "negative",
        "attribute_impact": -0.000661359546376948,
        "id": "1b1b9db6-d320-482e-aa79-f1b98ca3a10e"
      },
      {
        "review_id": "3b533391-3698-44f5-99b9-75f6873637dc",
        "comment": "they don't smile",
        "subject_group": "smile",
        "category": "service",
        "attribute": "lack",
        "sentiment": "negative",
        "attribute_impact": -0.000661359546376948,
        "id": "3d67f6e7-9544-4b35-a4d8-6eeff5b32b12"
      },
      {
        "review_id": "3b533391-3698-44f5-99b9-75f6873637dc",
        "comment": "I don't recommend it",
        "subject_group": "recommendation",
        "category": "experience",
        "attribute": "lack",
        "sentiment": "negative",
        "attribute_impact": -0.000661359546376948,
        "id": "5a825019-d6d5-4da3-8f5c-a2f3fc60bfb7"
      },
      {
        "review_id": "3b533391-3698-44f5-99b9-75f6873637dc",
        "comment": "they are in a hurry",
        "subject_group": "hurry",
        "category": "service",
        "attribute": "presence",
        "sentiment": "negative",
        "attribute_impact": -0.000661359546376948,
        "id": "7207db89-c345-4e53-9e2d-99f9fea60e07"
      },
      {
        "review_id": "3b533391-3698-44f5-99b9-75f6873637dc",
        "comment": "High prices",
        "subject_group": "price",
        "category": "product",
        "attribute": "high",
        "sentiment": "negative",
        "attribute_impact": -0.000661359546376948,
        "id": "b4b0af83-1f8d-4923-8878-f1e8e87f6ed7"
      },
      {
        "review_id": "3b533391-3698-44f5-99b9-75f6873637dc",
        "comment": "small portions",
        "subject_group": "portion",
        "category": "product",
        "attribute": "small",
        "sentiment": "negative",
        "attribute_impact": -0.000661359546376948,
        "id": "e4ff755b-4ac2-4bb0-afb0-92ada1960f42"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "3 months ago",
    "estimated_datetime": "2024-09-29T21:48:03.578948",
    "profile_name": "Arturo Azzurro",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSURuOHNLZk1nEAE",
    "review_text": "Everything OK ;)",
    "cumulative_rating": 4.387931034482759,
    "review_impact": 0.00236349016836801,
    "api_order": 231,
    "id": "24b45628-d8e6-4064-80ab-75f89a6ff252",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "3 months ago",
    "estimated_datetime": "2024-09-28T07:54:22.526316",
    "profile_name": "Fabio Lovece",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNuMDRHZElBEAE",
    "review_text": "Nice Place for breakfast. Perfect",
    "cumulative_rating": 4.3852813852813854,
    "review_impact": 0.00236349016836801,
    "api_order": 230,
    "id": "f7694392-ee79-46bb-b40f-b9c4e420735d",
    "analysis": [
      {
        "review_id": "f7694392-ee79-46bb-b40f-b9c4e420735d",
        "comment": "Perfect.",
        "subject_group": "experience",
        "category": "experience",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "4bbac375-9875-4c41-901b-8e1fd84bc9d0"
      },
      {
        "review_id": "f7694392-ee79-46bb-b40f-b9c4e420735d",
        "comment": "Nice Place for breakfast.",
        "subject_group": "place",
        "category": "experience",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "96317389-6285-4f92-9d76-9c4550d22e02"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "4 months ago",
    "estimated_datetime": "2024-09-26T05:57:32",
    "profile_name": "Nola",
    "rating": 3,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNuOU5lM0J3EAE",
    "review_text": "Nice selection of European style pâtisserie.. Espresso-based drinks could improve some as the water to coffee ratio was off and their Americano tasted weak and watery.\n\nTheir laminated baked goodie was soooo good. Had the spinach and feta croissant...flaky, crunchy, buttery, Although at 8$....I thought it was a bit high, but may be at the right price point for the neighborhood.\n\nWorkers were nice. Greeted you and thank you. Interior was clean and inviting too.",
    "cumulative_rating": 4.3826086956521735,
    "review_impact": -0.004629516824638635,
    "api_order": 229,
    "id": "5af17acd-a127-410a-ba23-483ddfdd727f",
    "analysis": [
      {
        "review_id": "5af17acd-a127-410a-ba23-483ddfdd727f",
        "comment": "Nice selection of European style pâtisserie.",
        "subject_group": "pâtisserie",
        "category": "product",
        "attribute": "selection",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "68a9a754-74ea-4c1a-8085-823fcb58c9df"
      },
      {
        "review_id": "5af17acd-a127-410a-ba23-483ddfdd727f",
        "comment": "Their laminated baked goodie was soooo good.",
        "subject_group": "goodie",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "0f2ce629-8877-40c2-833c-fcbebdcdc13f"
      },
      {
        "review_id": "5af17acd-a127-410a-ba23-483ddfdd727f",
        "comment": "Had the spinach and feta croissant...flaky, crunchy, buttery.",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "texture",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "ee3ed48c-c9cb-44ba-a95f-8d14c00212e2"
      },
      {
        "review_id": "5af17acd-a127-410a-ba23-483ddfdd727f",
        "comment": "Workers were nice.",
        "subject_group": "worker",
        "category": "service",
        "attribute": "attitude",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "cf6db005-1320-4286-a1d9-165cdd8d245c"
      },
      {
        "review_id": "5af17acd-a127-410a-ba23-483ddfdd727f",
        "comment": "Greeted you and thank you.",
        "subject_group": "greeting",
        "category": "service",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "e873f9df-2d72-4561-9179-c219976c2e64"
      },
      {
        "review_id": "5af17acd-a127-410a-ba23-483ddfdd727f",
        "comment": "Interior was clean and inviting too.",
        "subject_group": "interior",
        "category": "experience",
        "attribute": "cleanliness",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "a80e7cd8-843c-47ec-8eea-4a52b43a76ed"
      },
      {
        "review_id": "5af17acd-a127-410a-ba23-483ddfdd727f",
        "comment": "Interior was clean and inviting too.",
        "subject_group": "interior",
        "category": "experience",
        "attribute": "atmosphere",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "fc8d04a4-23fd-4361-b052-4b08ccdaefff"
      },
      {
        "review_id": "5af17acd-a127-410a-ba23-483ddfdd727f",
        "comment": "Espresso-based drinks could improve some as the water to coffee ratio was off and their Americano tasted weak and watery.",
        "subject_group": "drink",
        "category": "product",
        "attribute": "ratio",
        "sentiment": "negative",
        "attribute_impact": -0.0015431722748795451,
        "id": "212c3330-561c-4f8c-b641-fabed38a4ce9"
      },
      {
        "review_id": "5af17acd-a127-410a-ba23-483ddfdd727f",
        "comment": "Although at 8$....I thought it was a bit high, but may be at the right price point for the neighborhood.",
        "subject_group": "price",
        "category": "product",
        "attribute": "value",
        "sentiment": "negative",
        "attribute_impact": -0.0015431722748795451,
        "id": "305fa690-2875-4f13-be5a-3f3ba0fa9efe"
      },
      {
        "review_id": "5af17acd-a127-410a-ba23-483ddfdd727f",
        "comment": "Espresso-based drinks could improve some as the water to coffee ratio was off and their Americano tasted weak and watery.",
        "subject_group": "drink",
        "category": "product",
        "attribute": "taste",
        "sentiment": "negative",
        "attribute_impact": -0.0015431722748795451,
        "id": "3ebaa17d-71c9-4621-93c4-20dab17ece0c"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "4 months ago",
    "estimated_datetime": "2024-09-23T15:57:32",
    "profile_name": "Jos Pagan",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSURIMnNtWFdREAE",
    "review_text": "Best pistachio donuts and tiramisu latte ever!!!",
    "cumulative_rating": 4.388646288209607,
    "review_impact": 0.00236349016836801,
    "api_order": 228,
    "id": "b6cfb24c-3764-4635-805b-8056321ba84e",
    "analysis": [
      {
        "review_id": "b6cfb24c-3764-4635-805b-8056321ba84e",
        "comment": "Best pistachio donuts and tiramisu latte ever!!!",
        "subject_group": "latte",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "d40812d2-3c3a-478b-b04d-915d4fc810d9"
      },
      {
        "review_id": "b6cfb24c-3764-4635-805b-8056321ba84e",
        "comment": "Best pistachio donuts and tiramisu latte ever!!!",
        "subject_group": "donut",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "fc2053dd-36f7-43e2-bfcd-9bc1038d699c"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "4 months ago",
    "estimated_datetime": "2024-09-21T01:57:32",
    "profile_name": "BanjoS",
    "rating": 4,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSURIaUtUcGVnEAE",
    "review_text": "Cake wasn’t the best, tasty but I had better in New York, a bit expensive for NY Cheesecake",
    "cumulative_rating": 4.385964912280702,
    "review_impact": -0.0011330133281353127,
    "api_order": 227,
    "id": "0e5277dd-feb9-41b9-8bed-e5ff7a32afba",
    "analysis": [
      {
        "review_id": "0e5277dd-feb9-41b9-8bed-e5ff7a32afba",
        "comment": "tasty but I had better in New York",
        "subject_group": "cake",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "b3518053-8e06-41dd-913b-55f5dd92579f"
      },
      {
        "review_id": "0e5277dd-feb9-41b9-8bed-e5ff7a32afba",
        "comment": "a bit expensive for NY Cheesecake",
        "subject_group": "cheesecake",
        "category": "product",
        "attribute": "price",
        "sentiment": "negative",
        "attribute_impact": -0.0005665066640676564,
        "id": "4fa323f6-3b24-487d-998f-cea89b5a5d01"
      },
      {
        "review_id": "0e5277dd-feb9-41b9-8bed-e5ff7a32afba",
        "comment": "Cake wasn’t the best",
        "subject_group": "cake",
        "category": "product",
        "attribute": "quality",
        "sentiment": "negative",
        "attribute_impact": -0.0005665066640676564,
        "id": "72cb6d36-94c1-4fee-8c38-152c638f2f29"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "4 months ago",
    "estimated_datetime": "2024-09-18T11:57:32",
    "profile_name": "M Senti",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUNIXzlDazZRRRAB",
    "review_text": "The Crookies are realy yummy",
    "cumulative_rating": 4.387665198237886,
    "review_impact": 0.00236349016836801,
    "api_order": 226,
    "id": "91657256-5b62-4fb8-a35b-418aa47d2311",
    "analysis": [
      {
        "review_id": "91657256-5b62-4fb8-a35b-418aa47d2311",
        "comment": "The Crookies are realy yummy",
        "subject_group": "crookie",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.00236349016836801,
        "id": "f349581d-37f9-45fa-978e-8ad08b829bb3"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "4 months ago",
    "estimated_datetime": "2024-09-15T21:57:32",
    "profile_name": "Lauren Mills",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNIdmE2bGVnEAE",
    "review_text": "Stumbled upon this gem and enjoyed everything we ordered. The everything bagel with cream cheese, croissant breakfast sandwich, and coffee were all delicious. We went back for dessert after dinner and got the cheesecake and fruit tart. Would definitely recommend!",
    "cumulative_rating": 4.384955752212389,
    "review_impact": 0.00236349016836801,
    "api_order": 225,
    "id": "bc1fda38-15d8-46f7-a5b6-708e9409935f",
    "analysis": [
      {
        "review_id": "bc1fda38-15d8-46f7-a5b6-708e9409935f",
        "comment": "The croissant breakfast sandwich was delicious",
        "subject_group": "sandwich",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.00047269803367360196,
        "id": "1da36af3-f688-45d1-a23a-23a9444d236f"
      },
      {
        "review_id": "bc1fda38-15d8-46f7-a5b6-708e9409935f",
        "comment": "The cheesecake was delicious",
        "subject_group": "cheesecake",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.00047269803367360196,
        "id": "286c3094-71b1-4453-938a-2fbe00d4f238"
      },
      {
        "review_id": "bc1fda38-15d8-46f7-a5b6-708e9409935f",
        "comment": "The fruit tart was delicious",
        "subject_group": "tart",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.00047269803367360196,
        "id": "4a437342-6757-4869-88f9-2e151077d347"
      },
      {
        "review_id": "bc1fda38-15d8-46f7-a5b6-708e9409935f",
        "comment": "The everything bagel with cream cheese was delicious",
        "subject_group": "bagel",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.00047269803367360196,
        "id": "ec2ff362-d4db-42ee-971b-29509c60ab7c"
      },
      {
        "review_id": "bc1fda38-15d8-46f7-a5b6-708e9409935f",
        "comment": "The coffee was delicious",
        "subject_group": "coffee",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.00047269803367360196,
        "id": "ff074742-b799-4a98-87d9-cd83ffbd26c1"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "4 months ago",
    "estimated_datetime": "2024-09-13T07:57:32",
    "profile_name": "Margarita Varer",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNIMmZiUEN3EAE",
    "review_text": "Everything was delicious.",
    "cumulative_rating": 4.3822222222222225,
    "review_impact": 0.00236349016836801,
    "api_order": 224,
    "id": "6e655c82-828f-4a5d-86de-8778b63be9b9",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "4 months ago",
    "estimated_datetime": "2024-09-10T17:57:32",
    "profile_name": "Brooklyn Cosmic",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNIMm9pa0l3EAE",
    "review_text": "Really good cheesecake although the matcha is absolute trash, it's way too bitter but other than that it's really good",
    "cumulative_rating": 4.379464285714286,
    "review_impact": 0.00236349016836801,
    "api_order": 223,
    "id": "a42dac51-f8f7-41d8-af61-04b66007ff47",
    "analysis": [
      {
        "review_id": "a42dac51-f8f7-41d8-af61-04b66007ff47",
        "comment": "the matcha is absolute trash, it's way too bitter",
        "subject_group": "matcha",
        "category": "product",
        "attribute": "quality",
        "sentiment": "negative",
        "attribute_impact": 0.0,
        "id": "00a733bf-00c0-4265-9320-9891c612d299"
      },
      {
        "review_id": "a42dac51-f8f7-41d8-af61-04b66007ff47",
        "comment": "the matcha is absolute trash, it's way too bitter",
        "subject_group": "matcha",
        "category": "product",
        "attribute": "bitterness",
        "sentiment": "negative",
        "attribute_impact": 0.0,
        "id": "eb7d7ae3-07b0-4bd0-967b-abb7e0b01338"
      },
      {
        "review_id": "a42dac51-f8f7-41d8-af61-04b66007ff47",
        "comment": "other than that it's really good",
        "subject_group": "overall experience",
        "category": "experience",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "83df9029-2947-48b5-b635-3538bd1de092"
      },
      {
        "review_id": "a42dac51-f8f7-41d8-af61-04b66007ff47",
        "comment": "Really good cheesecake",
        "subject_group": "cheesecake",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "e85cf900-2797-4bc6-8ba9-2964721254c8"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "4 months ago",
    "estimated_datetime": "2024-09-08T03:57:32",
    "profile_name": "Jose Manuel Lopez Campos",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUNIeXBHQmpBRRAB",
    "review_text": "Typical American breakfast",
    "cumulative_rating": 4.376681614349776,
    "review_impact": 0.00236349016836801,
    "api_order": 222,
    "id": "aa2a3167-570d-4936-a826-56776eecd7c7",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "4 months ago",
    "estimated_datetime": "2024-09-05T13:57:32",
    "profile_name": "M K",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUNIMlBxMGdBRRAB",
    "review_text": null,
    "cumulative_rating": 4.373873873873874,
    "review_impact": 0.00236349016836801,
    "api_order": 221,
    "id": "ccb897c7-2139-48f4-9f06-0500cd954ccc",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "4 months ago",
    "estimated_datetime": "2024-09-02T23:57:32",
    "profile_name": "Xinyi Wei",
    "rating": 2,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNIa1BudEN3EAE",
    "review_text": "The bakery is not fresh when i was there, not sure if it's because i went there after 6. There was a fruit fly on the croissant",
    "cumulative_rating": 4.3710407239819,
    "review_impact": -0.008126020321142846,
    "api_order": 220,
    "id": "7ab790eb-4370-40d5-829b-b7191fd46cc4",
    "analysis": [
      {
        "review_id": "7ab790eb-4370-40d5-829b-b7191fd46cc4",
        "comment": "The bakery is not fresh when i was there",
        "subject_group": "bakery",
        "category": "experience",
        "attribute": "freshness",
        "sentiment": "negative",
        "attribute_impact": -0.004063010160571423,
        "id": "11fe13c1-b77d-41b1-a66b-88cb2366bddd"
      },
      {
        "review_id": "7ab790eb-4370-40d5-829b-b7191fd46cc4",
        "comment": "There was a fruit fly on the croissant",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "cleanliness",
        "sentiment": "negative",
        "attribute_impact": -0.004063010160571423,
        "id": "5b7c13b1-af2c-4588-85ae-e1f2badf5ee0"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "4 months ago",
    "estimated_datetime": "2024-08-31T09:57:32",
    "profile_name": "Som Tharuedee",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUQ3eV9USm5RRRAB",
    "review_text": "Tasty and perfect cream cheese donut and raspberry jam donut!!",
    "cumulative_rating": 4.381818181818182,
    "review_impact": 0.00236349016836801,
    "api_order": 219,
    "id": "cde891bb-40c5-4839-8131-5b3c6637d2f6",
    "analysis": [
      {
        "review_id": "cde891bb-40c5-4839-8131-5b3c6637d2f6",
        "comment": "Tasty and perfect cream cheese donut",
        "subject_group": "donut",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "18b33033-45c1-44ea-9e3d-508b112aaed9"
      },
      {
        "review_id": "cde891bb-40c5-4839-8131-5b3c6637d2f6",
        "comment": "Tasty and perfect cream cheese donut",
        "subject_group": "donut",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "256a6876-a913-4acd-8ec2-897e37e5c524"
      },
      {
        "review_id": "cde891bb-40c5-4839-8131-5b3c6637d2f6",
        "comment": "raspberry jam donut",
        "subject_group": "donut",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "9a70ebce-7618-40d0-9a08-dbc9ea4c178c"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "4 months ago",
    "estimated_datetime": "2024-08-28T19:57:32",
    "profile_name": "Arnau",
    "rating": 4,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUQ3NDhQeWJ3EAE",
    "review_text": "Decent place for breakfast, high prices for what they serve (but in line with the area).",
    "cumulative_rating": 4.378995433789954,
    "review_impact": -0.0011330133281353127,
    "api_order": 218,
    "id": "ee74de0d-6883-4c51-ad00-df3417569c69",
    "analysis": [
      {
        "review_id": "ee74de0d-6883-4c51-ad00-df3417569c69",
        "comment": "Decent place for breakfast",
        "subject_group": "place",
        "category": "experience",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "d347efdc-7e66-4027-9564-91ea49252bd2"
      },
      {
        "review_id": "ee74de0d-6883-4c51-ad00-df3417569c69",
        "comment": "high prices for what they serve",
        "subject_group": "price",
        "category": "product",
        "attribute": "value",
        "sentiment": "negative",
        "attribute_impact": -0.0011330133281353127,
        "id": "da28a36f-4c4c-4170-833e-b9066f531752"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "5 months ago",
    "estimated_datetime": "2024-08-26T08:20:36.615388",
    "profile_name": "Stephanie S",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUQ3MmRqQ2lRRRAB",
    "review_text": "Expensive but so delicious. I enjoyed everything I tried here.",
    "cumulative_rating": 4.3807339449541285,
    "review_impact": 0.00236349016836801,
    "api_order": 217,
    "id": "a16bfcc2-04e7-4383-beb7-9427192ade18",
    "analysis": [
      {
        "review_id": "a16bfcc2-04e7-4383-beb7-9427192ade18",
        "comment": "Expensive but so delicious.",
        "subject_group": "product",
        "category": "product",
        "attribute": "price",
        "sentiment": "negative",
        "attribute_impact": 0.0,
        "id": "f292fd72-2e61-459b-b0a6-49cb9b4bf727"
      },
      {
        "review_id": "a16bfcc2-04e7-4383-beb7-9427192ade18",
        "comment": "I enjoyed everything I tried here.",
        "subject_group": "experience",
        "category": "experience",
        "attribute": "satisfaction",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "045a60f6-7372-4fc9-8239-5fb84bd7b136"
      },
      {
        "review_id": "a16bfcc2-04e7-4383-beb7-9427192ade18",
        "comment": "Expensive but so delicious.",
        "subject_group": "product",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "7ee99981-10b6-4bef-afc8-a968f633537f"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "5 months ago",
    "estimated_datetime": "2024-08-23T23:06:45.846156",
    "profile_name": "SaND M",
    "rating": 4,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUQ3M3F1UlF3EAE",
    "review_text": null,
    "cumulative_rating": 4.377880184331797,
    "review_impact": -0.0011330133281353127,
    "api_order": 216,
    "id": "5af73896-522d-4d49-b067-82fc5dac8289",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "5 months ago",
    "estimated_datetime": "2024-08-21T13:52:55.076926",
    "profile_name": "L S",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUM3bjlIX0lREAE",
    "review_text": "As expected, nice food, service and bit patient but it’s in NYC….",
    "cumulative_rating": 4.37962962962963,
    "review_impact": 0.00236349016836801,
    "api_order": 215,
    "id": "2f9f561a-73b7-4768-8548-0dd679be753f",
    "analysis": [
      {
        "review_id": "2f9f561a-73b7-4768-8548-0dd679be753f",
        "comment": "service and bit patient",
        "subject_group": "service",
        "category": "service",
        "attribute": "patience",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "2d95b708-dc4a-4233-bb37-41940947f23c"
      },
      {
        "review_id": "2f9f561a-73b7-4768-8548-0dd679be753f",
        "comment": "nice food",
        "subject_group": "food",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "373e1e4a-c94c-43b9-8610-050c9b80e36f"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "5 months ago",
    "estimated_datetime": "2024-08-19T04:39:04.307694",
    "profile_name": "L E",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUM3bWV2R0p3EAE",
    "review_text": "I stumbled across this place by accident bc it was near my hotel. I was very surprised I never heard about this place considering everything looked absolutely gourmet & delicious. I ordered the prosciutto sandwhich which happened to have some sort of truffle, chocolate chip cookie & creme brulee donut! All items were equally delicious. If you are queueing in line for levain cookies, you're doing it wrong. This chocolate chip cookie is the only chocolate chip cookie you should be trying. Same goes for the creme brulee donut! Everything was delicious,  you should def try.",
    "cumulative_rating": 4.376744186046512,
    "review_impact": 0.00236349016836801,
    "api_order": 214,
    "id": "ce2d553e-6a8b-4fe4-a35a-b0669d793cb3",
    "analysis": [
      {
        "review_id": "ce2d553e-6a8b-4fe4-a35a-b0669d793cb3",
        "comment": "If you are queueing in line for levain cookies, you're doing it wrong.",
        "subject_group": "cookie",
        "category": "product",
        "attribute": "recommendation",
        "sentiment": "negative",
        "attribute_impact": 0.0,
        "id": "76291e9d-852e-4e51-82dc-b2d9769a3266"
      },
      {
        "review_id": "ce2d553e-6a8b-4fe4-a35a-b0669d793cb3",
        "comment": "Same goes for the creme brulee donut!",
        "subject_group": "donut",
        "category": "product",
        "attribute": "recommendation",
        "sentiment": "positive",
        "attribute_impact": 0.00029543627104600123,
        "id": "10b0b3fb-0601-436c-aaff-dafa719db5a3"
      },
      {
        "review_id": "ce2d553e-6a8b-4fe4-a35a-b0669d793cb3",
        "comment": "Everything was delicious, you should def try.",
        "subject_group": "items",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.00029543627104600123,
        "id": "31f56d5f-1218-4f0d-a052-f09116eeaed6"
      },
      {
        "review_id": "ce2d553e-6a8b-4fe4-a35a-b0669d793cb3",
        "comment": "I was very surprised I never heard about this place considering everything looked absolutely gourmet & delicious.",
        "subject_group": "place",
        "category": "experience",
        "attribute": "surprise",
        "sentiment": "positive",
        "attribute_impact": 0.00029543627104600123,
        "id": "562a3b18-e4bd-4fe1-a606-ddeacc8964fc"
      },
      {
        "review_id": "ce2d553e-6a8b-4fe4-a35a-b0669d793cb3",
        "comment": "I ordered the prosciutto sandwich which happened to have some sort of truffle, chocolate chip cookie & creme brulee donut!",
        "subject_group": "donut",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.00029543627104600123,
        "id": "5d4804e1-0122-4146-89ca-0de44b9fa692"
      },
      {
        "review_id": "ce2d553e-6a8b-4fe4-a35a-b0669d793cb3",
        "comment": "I ordered the prosciutto sandwich which happened to have some sort of truffle, chocolate chip cookie & creme brulee donut!",
        "subject_group": "cookie",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.00029543627104600123,
        "id": "b978e080-df7d-401b-a1be-e074f3ee20e4"
      },
      {
        "review_id": "ce2d553e-6a8b-4fe4-a35a-b0669d793cb3",
        "comment": "This chocolate chip cookie is the only chocolate chip cookie you should be trying.",
        "subject_group": "cookie",
        "category": "product",
        "attribute": "recommendation",
        "sentiment": "positive",
        "attribute_impact": 0.00029543627104600123,
        "id": "c1e58bed-443c-4316-b240-a074d4c8a933"
      },
      {
        "review_id": "ce2d553e-6a8b-4fe4-a35a-b0669d793cb3",
        "comment": "I was very surprised I never heard about this place considering everything looked absolutely gourmet & delicious.",
        "subject_group": "place",
        "category": "experience",
        "attribute": "appearance",
        "sentiment": "positive",
        "attribute_impact": 0.00029543627104600123,
        "id": "ca5fac09-a590-418f-bb6c-497157d35ef3"
      },
      {
        "review_id": "ce2d553e-6a8b-4fe4-a35a-b0669d793cb3",
        "comment": "I ordered the prosciutto sandwich which happened to have some sort of truffle, chocolate chip cookie & creme brulee donut!",
        "subject_group": "sandwich",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.00029543627104600123,
        "id": "d5697f83-f53f-4d19-acce-d4b0898d8d0d"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "5 months ago",
    "estimated_datetime": "2024-08-16T19:25:13.538464",
    "profile_name": "림륜",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUM3a2JDQVBREAE",
    "review_text": "it's good,\nI thought the bread inside would be chewy and very sweet, but it wasn't and I enjoyed it very much.\nThe coffee didn't suit our tastes, but it went well with the sweet donuts.\n\nThe boss looks a bit rough, but\nHe was a very considerate person who looked after his customers and provided them with what they needed.\n\nOh, there was also a bathroom.\n\nthank you Have a nice stay.",
    "cumulative_rating": 4.373831775700935,
    "review_impact": 0.00236349016836801,
    "api_order": 213,
    "id": "b6ad1078-1489-45cb-a8d8-c393716e54ab",
    "analysis": [
      {
        "review_id": "b6ad1078-1489-45cb-a8d8-c393716e54ab",
        "comment": "I thought the bread inside would be chewy and very sweet, but it wasn't and I enjoyed it very much.",
        "subject_group": "bread",
        "category": "product",
        "attribute": "chewiness",
        "sentiment": "negative",
        "attribute_impact": 0.0,
        "id": "50aad222-5e2b-4e49-88fb-c74df1f9d19b"
      },
      {
        "review_id": "b6ad1078-1489-45cb-a8d8-c393716e54ab",
        "comment": "I thought the bread inside would be chewy and very sweet, but it wasn't and I enjoyed it very much.",
        "subject_group": "bread",
        "category": "product",
        "attribute": "sweetness",
        "sentiment": "negative",
        "attribute_impact": 0.0,
        "id": "ea3dc864-a3da-4790-9530-922a4c617f30"
      },
      {
        "review_id": "b6ad1078-1489-45cb-a8d8-c393716e54ab",
        "comment": "The coffee didn't suit our tastes, but it went well with the sweet donuts.",
        "subject_group": "coffee",
        "category": "product",
        "attribute": "taste",
        "sentiment": "negative",
        "attribute_impact": 0.0,
        "id": "c408edb2-e53a-4424-aa99-5c6a62be781f"
      },
      {
        "review_id": "b6ad1078-1489-45cb-a8d8-c393716e54ab",
        "comment": "He was a very considerate person who looked after his customers and provided them with what they needed.",
        "subject_group": "person",
        "category": "service",
        "attribute": "consideration",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "16aff18d-f43e-4420-913f-3ee439f15532"
      },
      {
        "review_id": "b6ad1078-1489-45cb-a8d8-c393716e54ab",
        "comment": "The coffee didn't suit our tastes, but it went well with the sweet donuts.",
        "subject_group": "donut",
        "category": "product",
        "attribute": "pairing",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "4786bd8e-3097-4593-a3fc-fbfb1a2513f9"
      },
      {
        "review_id": "b6ad1078-1489-45cb-a8d8-c393716e54ab",
        "comment": "I thought the bread inside would be chewy and very sweet, but it wasn't and I enjoyed it very much.",
        "subject_group": "bread",
        "category": "product",
        "attribute": "enjoyment",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "c160f2c0-1dba-42b4-8ff5-c870dcf25836"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "5 months ago",
    "estimated_datetime": "2024-08-14T10:11:22.769232",
    "profile_name": "Fabian",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUM3aXItWUp3EAE",
    "review_text": "Expensive but have come here several times! Bagel without contents is the budget tip! 2-3$",
    "cumulative_rating": 4.370892018779343,
    "review_impact": 0.00236349016836801,
    "api_order": 212,
    "id": "c4b2103c-8b24-4b1e-99b1-7eb409574150",
    "analysis": [
      {
        "review_id": "c4b2103c-8b24-4b1e-99b1-7eb409574150",
        "comment": "Expensive but have come here several times!",
        "subject_group": "bakery",
        "category": "experience",
        "attribute": "price",
        "sentiment": "negative",
        "attribute_impact": 0.0,
        "id": "f915e7a8-7423-4aad-9ba1-1de722757f82"
      },
      {
        "review_id": "c4b2103c-8b24-4b1e-99b1-7eb409574150",
        "comment": "Expensive but have come here several times!",
        "subject_group": "bakery",
        "category": "experience",
        "attribute": "frequency",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "3e99704c-0a43-4066-832a-9ac838c71aa9"
      },
      {
        "review_id": "c4b2103c-8b24-4b1e-99b1-7eb409574150",
        "comment": "Bagel without contents is the budget tip!",
        "subject_group": "bagel",
        "category": "product",
        "attribute": "value",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "e0a8fff2-fefe-46cd-81d8-cc64cbf4a6ad"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "5 months ago",
    "estimated_datetime": "2024-08-12T00:57:32.000002",
    "profile_name": "Salem Alshehri",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUM3b1BpR2lRRRAB",
    "review_text": null,
    "cumulative_rating": 4.367924528301887,
    "review_impact": 0.00236349016836801,
    "api_order": 211,
    "id": "119f1f4f-5276-4697-9e37-9b25200a69a5",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "5 months ago",
    "estimated_datetime": "2024-08-09T15:43:41.230770",
    "profile_name": "Priya",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSURieDlpSm9nRRAB",
    "review_text": "Got the spiral pistachio croissant and it was delicious. The croissant part actually tasted like a croissant, which hasn’t always been the case when I’ve tried this elsewhere. Other items looked good too.",
    "cumulative_rating": 4.3649289099526065,
    "review_impact": 0.00236349016836801,
    "api_order": 210,
    "id": "3c0ec6c6-2b18-4024-a583-c35cd81b9086",
    "analysis": [
      {
        "review_id": "3c0ec6c6-2b18-4024-a583-c35cd81b9086",
        "comment": "Got the spiral pistachio croissant and it was delicious",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "426c9e28-41ec-4520-9573-34028d2be5e2"
      },
      {
        "review_id": "3c0ec6c6-2b18-4024-a583-c35cd81b9086",
        "comment": "Other items looked good too",
        "subject_group": "item",
        "category": "product",
        "attribute": "appearance",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "5b36baae-01fd-4b2c-a6a0-d33b356d3291"
      },
      {
        "review_id": "3c0ec6c6-2b18-4024-a583-c35cd81b9086",
        "comment": "The croissant part actually tasted like a croissant, which hasn’t always been the case when I’ve tried this elsewhere",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "c2632253-4344-4a5e-ad16-79e41a5361cd"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "5 months ago",
    "estimated_datetime": "2024-08-07T06:29:50.461540",
    "profile_name": "Bakha",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSURicGRiOGpRRRAB",
    "review_text": "I had a pistachio croissant. There was cream in the pastry too! It's a store where the staff is friendly and makes you feel good. The sparrows were also delicious.",
    "cumulative_rating": 4.3619047619047615,
    "review_impact": 0.00236349016836801,
    "api_order": 209,
    "id": "cfbc17d9-6cca-4f25-861b-0e1788677311",
    "analysis": [
      {
        "review_id": "cfbc17d9-6cca-4f25-861b-0e1788677311",
        "comment": "There was cream in the pastry too",
        "subject_group": "pastry",
        "category": "product",
        "attribute": "filling",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "136de4ee-d7de-44ed-b350-957fc694a87b"
      },
      {
        "review_id": "cfbc17d9-6cca-4f25-861b-0e1788677311",
        "comment": "I had a pistachio croissant",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "flavor",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "2c489172-7a97-4d72-af6a-7c54efcf053b"
      },
      {
        "review_id": "cfbc17d9-6cca-4f25-861b-0e1788677311",
        "comment": "It's a store where the staff is friendly and makes you feel good",
        "subject_group": "staff",
        "category": "service",
        "attribute": "friendliness",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "b603cc7d-e1cb-4ad1-a26e-f3bcf3fecb7e"
      },
      {
        "review_id": "cfbc17d9-6cca-4f25-861b-0e1788677311",
        "comment": "The sparrows were also delicious",
        "subject_group": "sparrow",
        "category": "product",
        "attribute": "flavor",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "bdd2b6d2-71c7-48c6-8102-8153606a0fe4"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "5 months ago",
    "estimated_datetime": "2024-08-04T21:15:59.692308",
    "profile_name": "Cianna Arnason",
    "rating": 1,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSURiOGZQVzFnRRAB",
    "review_text": "Bad customer service! Do not reccomend.",
    "cumulative_rating": 4.358851674641149,
    "review_impact": -0.011622523817646169,
    "api_order": 208,
    "id": "f9c2a9f8-73c0-4f52-a0cb-611eae06833e",
    "analysis": [
      {
        "review_id": "f9c2a9f8-73c0-4f52-a0cb-611eae06833e",
        "comment": "Do not reccomend.",
        "subject_group": "recommendation",
        "category": "experience",
        "attribute": "value",
        "sentiment": "negative",
        "attribute_impact": -0.005811261908823084,
        "id": "b8aaa2f5-7101-433c-a8d6-c281ef52077d"
      },
      {
        "review_id": "f9c2a9f8-73c0-4f52-a0cb-611eae06833e",
        "comment": "Bad customer service!",
        "subject_group": "service",
        "category": "service",
        "attribute": "quality",
        "sentiment": "negative",
        "attribute_impact": -0.005811261908823084,
        "id": "e0ff9030-8ec8-4239-92cb-412de320235c"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "5 months ago",
    "estimated_datetime": "2024-08-02T12:02:08.923078",
    "profile_name": "Hervé T.",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSURiak9YaXRRRRAB",
    "review_text": "Small bakery, which offers cereal yogurts and very special croissants. They are very good but cost around $10 each.\nThe service is New York style. That is to say, you have to be quick and precise.",
    "cumulative_rating": 4.375,
    "review_impact": 0.00236349016836801,
    "api_order": 207,
    "id": "01703eb2-c1b5-47d8-b831-15fff7583f31",
    "analysis": [
      {
        "review_id": "01703eb2-c1b5-47d8-b831-15fff7583f31",
        "comment": "Small bakery, which offers cereal yogurts and very special croissants.",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "price",
        "sentiment": "negative",
        "attribute_impact": 0.0,
        "id": "4a6cacbe-ecfa-4e25-94f1-b65bc7e42882"
      },
      {
        "review_id": "01703eb2-c1b5-47d8-b831-15fff7583f31",
        "comment": "Small bakery, which offers cereal yogurts and very special croissants.",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00047269803367360196,
        "id": "5345b91e-7d98-4438-bac7-255c4bf9b856"
      },
      {
        "review_id": "01703eb2-c1b5-47d8-b831-15fff7583f31",
        "comment": "You have to be quick and precise.",
        "subject_group": "service",
        "category": "service",
        "attribute": "speed",
        "sentiment": "positive",
        "attribute_impact": 0.00047269803367360196,
        "id": "915e9bb1-3c62-4e08-895c-194299b3f97a"
      },
      {
        "review_id": "01703eb2-c1b5-47d8-b831-15fff7583f31",
        "comment": "The service is New York style.",
        "subject_group": "service",
        "category": "service",
        "attribute": "style",
        "sentiment": "positive",
        "attribute_impact": 0.00047269803367360196,
        "id": "d5495d09-402e-4bda-a045-672d953cc200"
      },
      {
        "review_id": "01703eb2-c1b5-47d8-b831-15fff7583f31",
        "comment": "Small bakery, which offers cereal yogurts and very special croissants.",
        "subject_group": "bakery",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00047269803367360196,
        "id": "dc67210e-dd5c-4f84-b0bd-af95c61501c8"
      },
      {
        "review_id": "01703eb2-c1b5-47d8-b831-15fff7583f31",
        "comment": "You have to be quick and precise.",
        "subject_group": "service",
        "category": "service",
        "attribute": "accuracy",
        "sentiment": "positive",
        "attribute_impact": 0.00047269803367360196,
        "id": "edc33444-6840-4cb6-b303-288a78a6ac23"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "5 months ago",
    "estimated_datetime": "2024-07-31T02:48:18.153846",
    "profile_name": "Laura Lor (Lorelau)",
    "rating": 3,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUNielo3V3FnRRAB",
    "review_text": "We stopped there for breakfast as the bakery just opened and they were still preparing the last baked goods… those looked amazing! The roll croissant and the croissant sandwich indeed were very tasty. We tried also two eclair and those were instead very disappointing, chewy and surely not fresh. The service were not exactly friendly and were giving the impression to be bothered, which for us ruined the whole experience.",
    "cumulative_rating": 4.371980676328502,
    "review_impact": -0.004629516824638635,
    "api_order": 206,
    "id": "8b8928ca-9ff3-4097-9e66-e3b440973240",
    "analysis": [
      {
        "review_id": "8b8928ca-9ff3-4097-9e66-e3b440973240",
        "comment": "the bakery just opened and they were still preparing the last baked goods",
        "subject_group": "bakery",
        "category": "experience",
        "attribute": "opening",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "e3ae83be-b085-42f2-9490-1b74126378a6"
      },
      {
        "review_id": "8b8928ca-9ff3-4097-9e66-e3b440973240",
        "comment": "the bakery just opened and they were still preparing the last baked goods",
        "subject_group": "bakery",
        "category": "experience",
        "attribute": "preparation",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "e6dfdf8e-f955-4c6d-8640-33eb4b875991"
      },
      {
        "review_id": "8b8928ca-9ff3-4097-9e66-e3b440973240",
        "comment": "those looked amazing",
        "subject_group": "goods",
        "category": "product",
        "attribute": "appearance",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "93cce1eb-8fa5-47fe-aa94-186953672c10"
      },
      {
        "review_id": "8b8928ca-9ff3-4097-9e66-e3b440973240",
        "comment": "the roll croissant and the croissant sandwich indeed were very tasty",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "d99729df-ee5f-4b90-8922-8a7833ce748e"
      },
      {
        "review_id": "8b8928ca-9ff3-4097-9e66-e3b440973240",
        "comment": "the roll croissant and the croissant sandwich indeed were very tasty",
        "subject_group": "sandwich",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "8196575d-28e6-4078-a23c-af6eca211258"
      },
      {
        "review_id": "8b8928ca-9ff3-4097-9e66-e3b440973240",
        "comment": "the service were not exactly friendly and were giving the impression to be bothered",
        "subject_group": "service",
        "category": "service",
        "attribute": "attitude",
        "sentiment": "negative",
        "attribute_impact": -0.0007715861374397726,
        "id": "133655c3-fe33-45f3-bab2-5365335fe321"
      },
      {
        "review_id": "8b8928ca-9ff3-4097-9e66-e3b440973240",
        "comment": "two eclair and those were instead very disappointing, chewy and surely not fresh",
        "subject_group": "eclair",
        "category": "product",
        "attribute": "texture",
        "sentiment": "negative",
        "attribute_impact": -0.0007715861374397726,
        "id": "69a3f933-0324-4105-9786-f324de2bd30d"
      },
      {
        "review_id": "8b8928ca-9ff3-4097-9e66-e3b440973240",
        "comment": "two eclair and those were instead very disappointing, chewy and surely not fresh",
        "subject_group": "eclair",
        "category": "product",
        "attribute": "freshness",
        "sentiment": "negative",
        "attribute_impact": -0.0007715861374397726,
        "id": "771e3424-03b7-4143-8896-bfa1e031e1bc"
      },
      {
        "review_id": "8b8928ca-9ff3-4097-9e66-e3b440973240",
        "comment": "which for us ruined the whole experience",
        "subject_group": "experience",
        "category": "experience",
        "attribute": "quality",
        "sentiment": "negative",
        "attribute_impact": -0.0007715861374397726,
        "id": "ddeda218-e29c-4a71-9ff1-e089fce31c2f"
      },
      {
        "review_id": "8b8928ca-9ff3-4097-9e66-e3b440973240",
        "comment": "two eclair and those were instead very disappointing, chewy and surely not fresh",
        "subject_group": "eclair",
        "category": "product",
        "attribute": "quality",
        "sentiment": "negative",
        "attribute_impact": -0.0007715861374397726,
        "id": "e0828fbc-b283-4b9f-aecc-1fcf34320dee"
      },
      {
        "review_id": "8b8928ca-9ff3-4097-9e66-e3b440973240",
        "comment": "the service were not exactly friendly and were giving the impression to be bothered",
        "subject_group": "service",
        "category": "service",
        "attribute": "friendliness",
        "sentiment": "negative",
        "attribute_impact": -0.0007715861374397726,
        "id": "ebb0dc37-71e7-4929-9813-9c62ebb79b76"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "5 months ago",
    "estimated_datetime": "2024-07-28T17:34:27.384616",
    "profile_name": "Matthew Yang",
    "rating": 1,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUNib2NuNm1RRRAB",
    "review_text": "food tastes worse than the worst bakery I’ve been to before this; breakfast sandwiches are worse than McDonalds but 3x the price; service was fine",
    "cumulative_rating": 4.378640776699029,
    "review_impact": -0.011622523817646169,
    "api_order": 205,
    "id": "0eee04f9-1a0a-4d90-bd8c-247ebb58effe",
    "analysis": [
      {
        "review_id": "0eee04f9-1a0a-4d90-bd8c-247ebb58effe",
        "comment": "service was fine",
        "subject_group": "service",
        "category": "service",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "5ccf4108-aa71-48e5-b577-21f437596e96"
      },
      {
        "review_id": "0eee04f9-1a0a-4d90-bd8c-247ebb58effe",
        "comment": "food tastes worse than the worst bakery I’ve been to before this",
        "subject_group": "food",
        "category": "product",
        "attribute": "taste",
        "sentiment": "negative",
        "attribute_impact": -0.003874174605882056,
        "id": "0bc202ca-59bb-45db-8581-2b67a08a5f30"
      },
      {
        "review_id": "0eee04f9-1a0a-4d90-bd8c-247ebb58effe",
        "comment": "breakfast sandwiches are worse than McDonalds but 3x the price",
        "subject_group": "sandwich",
        "category": "product",
        "attribute": "price",
        "sentiment": "negative",
        "attribute_impact": -0.003874174605882056,
        "id": "8c1fcccb-f64c-43fe-be1a-18b42c127158"
      },
      {
        "review_id": "0eee04f9-1a0a-4d90-bd8c-247ebb58effe",
        "comment": "breakfast sandwiches are worse than McDonalds but 3x the price",
        "subject_group": "sandwich",
        "category": "product",
        "attribute": "taste",
        "sentiment": "negative",
        "attribute_impact": -0.003874174605882056,
        "id": "d8f66658-bcc7-45e2-b2ba-64893dfbc2e0"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "6 months ago",
    "estimated_datetime": "2024-07-25T09:31:49.142859",
    "profile_name": "Birgit Jung",
    "rating": 4,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNiNU8tWk9BEAE",
    "review_text": "This is how tomorrow can start.\nBreakfast in New York and watching life in NY through the windows.",
    "cumulative_rating": 4.3951219512195125,
    "review_impact": -0.0011330133281353127,
    "api_order": 204,
    "id": "c9cb6744-2aa5-4144-974e-a9556b3e09da",
    "analysis": [
      {
        "review_id": "c9cb6744-2aa5-4144-974e-a9556b3e09da",
        "comment": "Breakfast in New York",
        "subject_group": "breakfast",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "b7652c60-cbc6-4f4c-bde3-cb0778c44726"
      },
      {
        "review_id": "c9cb6744-2aa5-4144-974e-a9556b3e09da",
        "comment": "watching life in NY through the windows",
        "subject_group": "view",
        "category": "experience",
        "attribute": "enjoyment",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "cd0145f4-3285-497f-a2bb-f9718df85252"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "6 months ago",
    "estimated_datetime": "2024-07-21T02:40:23.428573",
    "profile_name": "Gal N",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSURyNVktcVJ3EAE",
    "review_text": "I came to this nice bakery by chance and I was very satisfied. The cheesecake was delicious and the corazons were a feast for the eyes.",
    "cumulative_rating": 4.397058823529412,
    "review_impact": 0.00236349016836801,
    "api_order": 203,
    "id": "c4ac06d6-67e0-444d-ab90-6ed9503acd2c",
    "analysis": [
      {
        "review_id": "c4ac06d6-67e0-444d-ab90-6ed9503acd2c",
        "comment": "The cheesecake was delicious",
        "subject_group": "cheesecake",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "0de21305-7397-4d6d-af44-195cccb12868"
      },
      {
        "review_id": "c4ac06d6-67e0-444d-ab90-6ed9503acd2c",
        "comment": "I came to this nice bakery by chance and I was very satisfied",
        "subject_group": "bakery",
        "category": "experience",
        "attribute": "satisfaction",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "dec3891a-b3f2-4f81-8b74-e74733cc2048"
      },
      {
        "review_id": "c4ac06d6-67e0-444d-ab90-6ed9503acd2c",
        "comment": "the corazons were a feast for the eyes",
        "subject_group": "corazon",
        "category": "product",
        "attribute": "appearance",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "fc4a4d78-a0f2-4973-866d-6f061d272e61"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "6 months ago",
    "estimated_datetime": "2024-07-16T19:48:57.714287",
    "profile_name": "Timothy Carmon",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSURydHRDbVh3EAE",
    "review_text": "Great place to grab breakfast and take a minute to sit and relax. Egg sandwich on a croissant is highly recommended.  Great variety of pastries as well. If you’re in the area you can’t go wrong with this quaint pastry place.",
    "cumulative_rating": 4.394088669950739,
    "review_impact": 0.00236349016836801,
    "api_order": 202,
    "id": "60903201-955b-4080-a041-7e17d65f46ae",
    "analysis": [
      {
        "review_id": "60903201-955b-4080-a041-7e17d65f46ae",
        "comment": "If you’re in the area you can’t go wrong with this quaint pastry place.",
        "subject_group": "place",
        "category": "experience",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "6053b20d-5d3b-4a77-ac87-e0ebcd810e43"
      },
      {
        "review_id": "60903201-955b-4080-a041-7e17d65f46ae",
        "comment": "Great variety of pastries as well.",
        "subject_group": "variety",
        "category": "product",
        "attribute": "selection",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "9d1a57d2-9625-4f29-b7c7-a324b5ace57e"
      },
      {
        "review_id": "60903201-955b-4080-a041-7e17d65f46ae",
        "comment": "Egg sandwich on a croissant is highly recommended.",
        "subject_group": "sandwich",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "b20d5bb0-c413-4c70-8bd8-f9ab9dd37a9f"
      },
      {
        "review_id": "60903201-955b-4080-a041-7e17d65f46ae",
        "comment": "Great place to grab breakfast and take a minute to sit and relax.",
        "subject_group": "place",
        "category": "experience",
        "attribute": "atmosphere",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "c378fc23-2bac-417a-a184-c02f689334d4"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "6 months ago",
    "estimated_datetime": "2024-07-12T12:57:32.000001",
    "profile_name": "Coach Dani",
    "rating": 4,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSURycXVyWU93EAE",
    "review_text": "Now this croissant is as good as it looks. Disastrously delicious. But it is basically a $10 pastry so do with that info what you will.",
    "cumulative_rating": 4.391089108910891,
    "review_impact": -0.0011330133281353127,
    "api_order": 201,
    "id": "360b69ed-bc60-43fc-9dbc-825e6837c803",
    "analysis": [
      {
        "review_id": "360b69ed-bc60-43fc-9dbc-825e6837c803",
        "comment": "Now this croissant is as good as it looks.",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "appearance",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "f865a1d7-42e0-4574-a0f4-dc6e17a52399"
      },
      {
        "review_id": "360b69ed-bc60-43fc-9dbc-825e6837c803",
        "comment": "Now this croissant is as good as it looks.",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "07776d86-2cd3-414b-99db-61fbdf0e8ccb"
      },
      {
        "review_id": "360b69ed-bc60-43fc-9dbc-825e6837c803",
        "comment": "Disastrously delicious.",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "6966c034-7a19-48f2-848c-3580690861cb"
      },
      {
        "review_id": "360b69ed-bc60-43fc-9dbc-825e6837c803",
        "comment": "But it is basically a $10 pastry so do with that info what you will.",
        "subject_group": "pastry",
        "category": "product",
        "attribute": "price",
        "sentiment": "negative",
        "attribute_impact": -0.0011330133281353127,
        "id": "a0e13e2e-d30f-4977-afd1-f37d695b5d4f"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "6 months ago",
    "estimated_datetime": "2024-07-08T06:06:06.285715",
    "profile_name": "Bhakti Dalvi",
    "rating": 4,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNyZ2FLeEJnEAE",
    "review_text": "Got the pan suisse pain au chocolaté, it was good not too sweet but the filling was overpowering making it a bit soggy.\nThe blueberry muffin was fresh and nice. The crème brûlée donut was average.",
    "cumulative_rating": 4.393034825870647,
    "review_impact": -0.0011330133281353127,
    "api_order": 200,
    "id": "9ceb504d-cb43-465b-a769-98e6c20fe96d",
    "analysis": [
      {
        "review_id": "9ceb504d-cb43-465b-a769-98e6c20fe96d",
        "comment": "Got the pan suisse pain au chocolaté, it was good not too sweet but the filling was overpowering making it a bit soggy.",
        "subject_group": "pan suisse pain au chocolaté",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "ae5ff69f-94f5-4234-9243-f4ee871137d3"
      },
      {
        "review_id": "9ceb504d-cb43-465b-a769-98e6c20fe96d",
        "comment": "The blueberry muffin was fresh and nice.",
        "subject_group": "blueberry muffin",
        "category": "product",
        "attribute": "freshness",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "6f6072f3-c875-4f5e-934a-6bdaa2362d2d"
      },
      {
        "review_id": "9ceb504d-cb43-465b-a769-98e6c20fe96d",
        "comment": "Got the pan suisse pain au chocolaté, it was good not too sweet but the filling was overpowering making it a bit soggy.",
        "subject_group": "pan suisse pain au chocolaté",
        "category": "product",
        "attribute": "filling",
        "sentiment": "negative",
        "attribute_impact": -0.0005665066640676564,
        "id": "11f476b2-9aca-46ab-937d-757795ce6bce"
      },
      {
        "review_id": "9ceb504d-cb43-465b-a769-98e6c20fe96d",
        "comment": "The crème brûlée donut was average.",
        "subject_group": "crème brûlée donut",
        "category": "product",
        "attribute": "quality",
        "sentiment": "negative",
        "attribute_impact": -0.0005665066640676564,
        "id": "8766dfde-2a38-4643-9d82-6ca0e1650bbc"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "6 months ago",
    "estimated_datetime": "2024-07-03T23:14:40.571429",
    "profile_name": "Michael Rupli",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUNycXRQV25BRRAB",
    "review_text": null,
    "cumulative_rating": 4.395,
    "review_impact": 0.00236349016836801,
    "api_order": 199,
    "id": "86965bc7-d985-4c5b-95fd-0f975e67fc50",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "6 months ago",
    "estimated_datetime": "2024-06-29T16:23:14.857143",
    "profile_name": "Metego",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNyNHNLMExnEAE",
    "review_text": "The cookie was one of the best cookies I’ve tried in New York!\nThe cookie croissant tastes very good too and is definitely something new to try out :)",
    "cumulative_rating": 4.391959798994975,
    "review_impact": 0.00236349016836801,
    "api_order": 198,
    "id": "268a15b1-8b37-4b01-a6c5-5d9de27a1232",
    "analysis": [
      {
        "review_id": "268a15b1-8b37-4b01-a6c5-5d9de27a1232",
        "comment": "The cookie croissant tastes very good too and is definitely something new to try out :)",
        "subject_group": "cookie croissant",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "0470d3ea-9052-4177-afb8-9d996e8a97ef"
      },
      {
        "review_id": "268a15b1-8b37-4b01-a6c5-5d9de27a1232",
        "comment": "The cookie croissant tastes very good too and is definitely something new to try out :)",
        "subject_group": "cookie croissant",
        "category": "product",
        "attribute": "novelty",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "4799fb00-6856-4e99-9240-eb3cd464169d"
      },
      {
        "review_id": "268a15b1-8b37-4b01-a6c5-5d9de27a1232",
        "comment": "The cookie was one of the best cookies I’ve tried in New York!",
        "subject_group": "cookie",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "e24efcde-1854-4b74-ace7-44142b82ad34"
      }
    ]
  },

  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "7 months ago",
    "estimated_datetime": "2024-06-20T21:31:49.142860",
    "profile_name": "Karen White",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUNMcUlqUGhRRRAB",
    "review_text": "So delicious",
    "cumulative_rating": 4.385786802030457,
    "review_impact": 0.00236349016836801,
    "api_order": 196,
    "id": "5d1f52ed-70a2-4752-9255-e3c4be10abe3",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "7 months ago",
    "estimated_datetime": "2024-06-16T11:14:40.571430",
    "profile_name": "Ahmad Zia",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUN6ODl5Ym53RRAB",
    "review_text": "Thanks Carlos great service appreciate you",
    "cumulative_rating": 4.38265306122449,
    "review_impact": 0.00236349016836801,
    "api_order": 195,
    "id": "4558b82d-20e6-4f69-8bbe-025c3a9f7c6c",
    "analysis": [
      {
        "review_id": "4558b82d-20e6-4f69-8bbe-025c3a9f7c6c",
        "comment": "Thanks Carlos great service appreciate you",
        "subject_group": "service",
        "category": "service",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00236349016836801,
        "id": "90318a60-33bd-4a72-967f-b4fe329d012c"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "7 months ago",
    "estimated_datetime": "2024-06-12T00:57:32.000002",
    "profile_name": "Okuyasu Nijimura",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUN6MEt5ZkFREAE",
    "review_text": "Every time I'm about to head to school on Mondays or Fridays if I'm feeling like treating myself (and I'm not broke) I go there and get a bacon egg and cheese,  and when I tell you everything from the sandwiches to the drinks are so good I would sell my kidney for one rn. (All in all great food great drinks and the people there are amazing)",
    "cumulative_rating": 4.37948717948718,
    "review_impact": 0.00236349016836801,
    "api_order": 194,
    "id": "37034804-f3b3-4bed-8400-de9c16b82706",
    "analysis": [
      {
        "review_id": "37034804-f3b3-4bed-8400-de9c16b82706",
        "comment": "great food great drinks and the people there are amazing",
        "subject_group": "person",
        "category": "service",
        "attribute": "friendliness",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "07a005f9-f214-4bf4-b6aa-a8394ddee243"
      },
      {
        "review_id": "37034804-f3b3-4bed-8400-de9c16b82706",
        "comment": "great food great drinks and the people there are amazing",
        "subject_group": "food",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "22d477b7-019f-4e0f-8c05-d343c4c4836f"
      },
      {
        "review_id": "37034804-f3b3-4bed-8400-de9c16b82706",
        "comment": "everything from the sandwiches to the drinks are so good",
        "subject_group": "sandwich",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "5ec6d10a-c950-4115-8318-0debdd5c5fa5"
      },
      {
        "review_id": "37034804-f3b3-4bed-8400-de9c16b82706",
        "comment": "great food great drinks and the people there are amazing",
        "subject_group": "drink",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "832774d9-434e-4721-be03-6b9b0bdcfe18"
      },
      {
        "review_id": "37034804-f3b3-4bed-8400-de9c16b82706",
        "comment": "I go there and get a bacon egg and cheese",
        "subject_group": "sandwich",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "9021a075-f584-4e52-87e4-959904971b61"
      },
      {
        "review_id": "37034804-f3b3-4bed-8400-de9c16b82706",
        "comment": "everything from the sandwiches to the drinks are so good",
        "subject_group": "drink",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "9e3771df-a9e0-44e0-b4e2-c730b1d90cf2"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "7 months ago",
    "estimated_datetime": "2024-06-07T14:40:23.428572",
    "profile_name": "Αλέξανδρος Ντούνης",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSURUaDZ2bzZBRRAB",
    "review_text": null,
    "cumulative_rating": 4.376288659793815,
    "review_impact": 0.00236349016836801,
    "api_order": 193,
    "id": "a803a9b3-8291-4da1-9a8c-9711119f517b",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "7 months ago",
    "estimated_datetime": "2024-06-03T04:23:14.857144",
    "profile_name": "Konstantinos Prasinos",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSURUaDVQdDR3RRAB",
    "review_text": null,
    "cumulative_rating": 4.373056994818653,
    "review_impact": 0.00236349016836801,
    "api_order": 192,
    "id": "b4b43a57-3816-49c4-91e2-db32dae1bbbe",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "7 months ago",
    "estimated_datetime": "2024-05-29T18:06:06.285714",
    "profile_name": "Gilbert Ortiz",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSURUaDdYa1V3EAE",
    "review_text": "Discovered this place while wandering around\nIt has ruined croissants from anywhere else",
    "cumulative_rating": 4.369791666666667,
    "review_impact": 0.00236349016836801,
    "api_order": 191,
    "id": "514ce574-df83-461b-85d7-483a76330f90",
    "analysis": [
      {
        "review_id": "514ce574-df83-461b-85d7-483a76330f90",
        "comment": "It has ruined croissants from anywhere else",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "quality",
        "sentiment": "negative",
        "attribute_impact": 0.0,
        "id": "2a308b10-3a03-4db0-826f-9df1a70fd780"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "8 months ago",
    "estimated_datetime": "2024-05-25T00:57:32",
    "profile_name": "jonny rosas",
    "rating": 1,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSURUdWNTOWRREAE",
    "review_text": "Extremely rude customer service. They must not like their job. Pastries are ok, I would not to go out of my way for this place.",
    "cumulative_rating": 4.366492146596858,
    "review_impact": -0.011622523817646169,
    "api_order": 190,
    "id": "7676eb75-d344-430e-b586-89c45863015c",
    "analysis": [
      {
        "review_id": "7676eb75-d344-430e-b586-89c45863015c",
        "comment": "Pastries are ok.",
        "subject_group": "pastry",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "def9d7f7-fd73-487a-919c-5cf39c651f3e"
      },
      {
        "review_id": "7676eb75-d344-430e-b586-89c45863015c",
        "comment": "They must not like their job.",
        "subject_group": "service",
        "category": "service",
        "attribute": "job satisfaction",
        "sentiment": "negative",
        "attribute_impact": -0.003874174605882056,
        "id": "3285dea9-88d7-418d-885e-6945da237a78"
      },
      {
        "review_id": "7676eb75-d344-430e-b586-89c45863015c",
        "comment": "Extremely rude customer service.",
        "subject_group": "service",
        "category": "service",
        "attribute": "rudeness",
        "sentiment": "negative",
        "attribute_impact": -0.003874174605882056,
        "id": "d985a171-0a85-40bd-9a54-1854d6832eb3"
      },
      {
        "review_id": "7676eb75-d344-430e-b586-89c45863015c",
        "comment": "I would not go out of my way for this place.",
        "subject_group": "experience",
        "category": "experience",
        "attribute": "effort",
        "sentiment": "negative",
        "attribute_impact": -0.003874174605882056,
        "id": "f707ee5d-2fcf-4394-9a16-1a9776298fe9"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "8 months ago",
    "estimated_datetime": "2024-05-20T00:57:32",
    "profile_name": "Trevor Brandt-Sarif",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNUazlhYURREAE",
    "review_text": "Amazing caprese,  excellent cheesecake, very good Nutella donut",
    "cumulative_rating": 4.38421052631579,
    "review_impact": 0.00236349016836801,
    "api_order": 189,
    "id": "ed0b52a0-b596-4ccc-b528-c706824a9af8",
    "analysis": [
      {
        "review_id": "ed0b52a0-b596-4ccc-b528-c706824a9af8",
        "comment": "excellent cheesecake",
        "subject_group": "cheesecake",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "2afd26d3-4a1f-4d94-bf28-f711fc525de6"
      },
      {
        "review_id": "ed0b52a0-b596-4ccc-b528-c706824a9af8",
        "comment": "Amazing caprese",
        "subject_group": "caprese",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "2be7c645-c037-4403-9d62-638e5ca6f860"
      },
      {
        "review_id": "ed0b52a0-b596-4ccc-b528-c706824a9af8",
        "comment": "very good Nutella donut",
        "subject_group": "donut",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "ea086d88-7951-4424-8121-1fe5d0eb0a98"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "8 months ago",
    "estimated_datetime": "2024-05-15T00:57:32",
    "profile_name": "ally",
    "rating": 4,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNUaGJub0JREAE",
    "review_text": "Second time coming here! The sandwiches are very good but very expensive in my opinion.\nPhotos: Prosciutto & chicken ranch, cookie and yogurt.\n\nAbout $22 each.\n\nThere are lots of choices in both sandwiches and pastries! To be tested!",
    "cumulative_rating": 4.380952380952381,
    "review_impact": -0.0011330133281353127,
    "api_order": 188,
    "id": "ef7662c4-aa53-4020-b7a7-f92708da5d67",
    "analysis": [
      {
        "review_id": "ef7662c4-aa53-4020-b7a7-f92708da5d67",
        "comment": "The sandwiches are very good but very expensive in my opinion.",
        "subject_group": "sandwich",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "b9d58fc4-9554-40c7-81f2-885f4c9492c9"
      },
      {
        "review_id": "ef7662c4-aa53-4020-b7a7-f92708da5d67",
        "comment": "There are lots of choices in both sandwiches and pastries!",
        "subject_group": "choice",
        "category": "product",
        "attribute": "variety",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "bdb08f1a-a123-40f2-b663-93e47b8eb7bf"
      },
      {
        "review_id": "ef7662c4-aa53-4020-b7a7-f92708da5d67",
        "comment": "The sandwiches are very good but very expensive in my opinion.",
        "subject_group": "sandwich",
        "category": "product",
        "attribute": "price",
        "sentiment": "negative",
        "attribute_impact": -0.0011330133281353127,
        "id": "224f436d-92b5-40a1-814d-80482d54d2fc"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "8 months ago",
    "estimated_datetime": "2024-05-10T00:57:32",
    "profile_name": "Marius M",
    "rating": 3,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNUNEptR1BREAE",
    "review_text": "The roll and the donut was medium. I expected more based on their prices.",
    "cumulative_rating": 4.382978723404255,
    "review_impact": -0.004629516824638635,
    "api_order": 187,
    "id": "d4f2e595-a3e8-45e2-9948-8c69573b8a48",
    "analysis": [
      {
        "review_id": "d4f2e595-a3e8-45e2-9948-8c69573b8a48",
        "comment": "The roll and the donut was medium.",
        "subject_group": "donut",
        "category": "product",
        "attribute": "quality",
        "sentiment": "negative",
        "attribute_impact": -0.0015431722748795451,
        "id": "25759b17-5793-4e74-80ee-8920755a82c8"
      },
      {
        "review_id": "d4f2e595-a3e8-45e2-9948-8c69573b8a48",
        "comment": "The roll and the donut was medium.",
        "subject_group": "roll",
        "category": "product",
        "attribute": "quality",
        "sentiment": "negative",
        "attribute_impact": -0.0015431722748795451,
        "id": "64309cd2-e39b-42f2-b370-3b389410ede6"
      },
      {
        "review_id": "d4f2e595-a3e8-45e2-9948-8c69573b8a48",
        "comment": "I expected more based on their prices.",
        "subject_group": "price",
        "category": "product",
        "attribute": "value",
        "sentiment": "negative",
        "attribute_impact": -0.0015431722748795451,
        "id": "69e03383-4f11-4e20-9a9e-ec71adc51641"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "8 months ago",
    "estimated_datetime": "2024-05-05T00:57:32",
    "profile_name": "Romano Pravdič",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSURqZzZmX0hREAE",
    "review_text": "The New York cheesecake is delicious and the espresso tastes excellent. Would recommend!",
    "cumulative_rating": 4.390374331550802,
    "review_impact": 0.00236349016836801,
    "api_order": 186,
    "id": "5f5abd2b-1ed1-47fc-88f7-8f627b53f2ae",
    "analysis": [
      {
        "review_id": "5f5abd2b-1ed1-47fc-88f7-8f627b53f2ae",
        "comment": "the espresso tastes excellent",
        "subject_group": "espresso",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "38791746-f7e6-4838-b857-d1c978f04747"
      },
      {
        "review_id": "5f5abd2b-1ed1-47fc-88f7-8f627b53f2ae",
        "comment": "Would recommend",
        "subject_group": "recommendation",
        "category": "experience",
        "attribute": "value",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "80a57554-82db-4d0f-8c8c-9cdd612f9b43"
      },
      {
        "review_id": "5f5abd2b-1ed1-47fc-88f7-8f627b53f2ae",
        "comment": "The New York cheesecake is delicious",
        "subject_group": "cheesecake",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "e673dfb3-3169-4f0a-947c-83d4effd4f5e"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "8 months ago",
    "estimated_datetime": "2024-04-30T00:57:32",
    "profile_name": "Laura Swenson",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSURqaFBuWVN3EAE",
    "review_text": null,
    "cumulative_rating": 4.387096774193548,
    "review_impact": 0.00236349016836801,
    "api_order": 185,
    "id": "4968ea1b-889f-4c94-986d-df1ec36c1e1f",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "9 months ago",
    "estimated_datetime": "2024-04-26T12:09:32",
    "profile_name": "jávea 13",
    "rating": 1,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNqbDZUUmRREAE",
    "review_text": "I would give it zero stars if I could. Dirty place and the food leaves a lot to be desired.",
    "cumulative_rating": 4.383783783783784,
    "review_impact": -0.011622523817646169,
    "api_order": 184,
    "id": "f63a613d-e8df-4313-b04d-f310f138ab65",
    "analysis": [
      {
        "review_id": "f63a613d-e8df-4313-b04d-f310f138ab65",
        "comment": "the food leaves a lot to be desired",
        "subject_group": "food",
        "category": "product",
        "attribute": "quality",
        "sentiment": "negative",
        "attribute_impact": -0.005811261908823084,
        "id": "0eab1b4c-672a-4df0-ad95-110a68861418"
      },
      {
        "review_id": "f63a613d-e8df-4313-b04d-f310f138ab65",
        "comment": "Dirty place",
        "subject_group": "place",
        "category": "experience",
        "attribute": "cleanliness",
        "sentiment": "negative",
        "attribute_impact": -0.005811261908823084,
        "id": "2c606826-0762-4b6c-9929-523c3c25ea01"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "9 months ago",
    "estimated_datetime": "2024-04-24T10:33:32",
    "profile_name": "Aline T.",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUNqZy1XNTZBRRAB",
    "review_text": "Practical place for a quick meal, like breakfast. There are small tables to sit at your meal, very comfortable and charming.",
    "cumulative_rating": 4.4021739130434785,
    "review_impact": 0.00236349016836801,
    "api_order": 183,
    "id": "0a7f47f8-c41c-4325-97bc-5340645fec3c",
    "analysis": [
      {
        "review_id": "0a7f47f8-c41c-4325-97bc-5340645fec3c",
        "comment": "Practical place for a quick meal",
        "subject_group": "place",
        "category": "experience",
        "attribute": "meal type",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "06a95345-bbe2-45fd-8fa0-6257a52a9ae9"
      },
      {
        "review_id": "0a7f47f8-c41c-4325-97bc-5340645fec3c",
        "comment": "There are small tables to sit at your meal",
        "subject_group": "table",
        "category": "experience",
        "attribute": "comfort",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "855b814e-4c8c-48b4-9838-747790886097"
      },
      {
        "review_id": "0a7f47f8-c41c-4325-97bc-5340645fec3c",
        "comment": "There are small tables to sit at your meal",
        "subject_group": "table",
        "category": "experience",
        "attribute": "size",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "a85a6177-958b-43de-8549-cc81f27b3254"
      },
      {
        "review_id": "0a7f47f8-c41c-4325-97bc-5340645fec3c",
        "comment": "very comfortable and charming",
        "subject_group": "atmosphere",
        "category": "experience",
        "attribute": "comfort",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "d0a33a60-5576-4233-8dc7-a3a6866b7686"
      },
      {
        "review_id": "0a7f47f8-c41c-4325-97bc-5340645fec3c",
        "comment": "very comfortable and charming",
        "subject_group": "atmosphere",
        "category": "experience",
        "attribute": "charm",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "d7bf1e5d-bb80-4167-8e2d-5782dfe3b155"
      },
      {
        "review_id": "0a7f47f8-c41c-4325-97bc-5340645fec3c",
        "comment": "Practical place for a quick meal",
        "subject_group": "place",
        "category": "experience",
        "attribute": "practicality",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "e81905a8-b0b9-4f53-8a8a-fbb6db97d327"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "9 months ago",
    "estimated_datetime": "2024-04-22T08:57:32",
    "profile_name": "A PG",
    "rating": 4,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNqN2RPTUx3EAE",
    "review_text": "Came in here looking for decaf coffee (they had decaf drip!!!), and a baked good. Decided on plain croissant. The flavored ones looked good too, but at $8.50/ piece, I thought too pricy.\nGot served quickly. Asked when the croissants were made. They said 7am, and made on site.\nGot back to office to warm up croissant. It was a decent croissant (I like Breads bakery more), and coffee was OK. (Grounds found at bottom of cup…). Spent $8 for coffee & croissant.",
    "cumulative_rating": 4.398907103825136,
    "review_impact": -0.0011330133281353127,
    "api_order": 182,
    "id": "ad31e675-447c-4a6a-989d-0df62a460ddd",
    "analysis": [
      {
        "review_id": "ad31e675-447c-4a6a-989d-0df62a460ddd",
        "comment": "Came in here looking for decaf coffee (they had decaf drip!!!), and a baked good.",
        "subject_group": "coffee",
        "category": "product",
        "attribute": "availability",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "775f4d14-ee9f-4984-b0b3-3bca23c4cb4c"
      },
      {
        "review_id": "ad31e675-447c-4a6a-989d-0df62a460ddd",
        "comment": "The flavored ones looked good too, but at $8.50/ piece, I thought too pricy.",
        "subject_group": "flavored one",
        "category": "product",
        "attribute": "appearance",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "8d334f8f-d7b4-4792-bddf-28078da36477"
      },
      {
        "review_id": "ad31e675-447c-4a6a-989d-0df62a460ddd",
        "comment": "Got served quickly.",
        "subject_group": "service",
        "category": "service",
        "attribute": "speed",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "e9859c92-c504-47ec-bce7-1e7b8fe7a908"
      },
      {
        "review_id": "ad31e675-447c-4a6a-989d-0df62a460ddd",
        "comment": "They said 7am, and made on site.",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "freshness",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "1962b92f-fdc3-4e48-90c0-874ac053660f"
      },
      {
        "review_id": "ad31e675-447c-4a6a-989d-0df62a460ddd",
        "comment": "It was a decent croissant (I like Breads bakery more), and coffee was OK.",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "2debbc77-6701-4686-9514-bf48bc38157f"
      },
      {
        "review_id": "ad31e675-447c-4a6a-989d-0df62a460ddd",
        "comment": "(Grounds found at bottom of cup…).",
        "subject_group": "coffee",
        "category": "product",
        "attribute": "cleanliness",
        "sentiment": "negative",
        "attribute_impact": -0.0005665066640676564,
        "id": "c27b03fb-6b4e-41f1-adc0-87240c730861"
      },
      {
        "review_id": "ad31e675-447c-4a6a-989d-0df62a460ddd",
        "comment": "The flavored ones looked good too, but at $8.50/ piece, I thought too pricy.",
        "subject_group": "flavored one",
        "category": "product",
        "attribute": "price",
        "sentiment": "negative",
        "attribute_impact": -0.0005665066640676564,
        "id": "e4927a86-2e88-4dc1-a608-37fac855fc99"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "9 months ago",
    "estimated_datetime": "2024-04-20T07:21:32",
    "profile_name": "Juan jose Garrido Moreno",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNqb2VHN0Z3EAE",
    "review_text": "Lovely bakery! Great chocolate croissant!!",
    "cumulative_rating": 4.4010989010989015,
    "review_impact": 0.00236349016836801,
    "api_order": 181,
    "id": "a255b5a7-2524-4508-b896-aca0261c4317",
    "analysis": [
      {
        "review_id": "a255b5a7-2524-4508-b896-aca0261c4317",
        "comment": "Lovely bakery!",
        "subject_group": "bakery",
        "category": "experience",
        "attribute": "loveliness",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "0a285ab1-80b9-47fe-8786-984b7c180ad7"
      },
      {
        "review_id": "a255b5a7-2524-4508-b896-aca0261c4317",
        "comment": "Great chocolate croissant!!",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "greatness",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "278159a2-16d9-4035-be80-b0ce96700e9a"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "9 months ago",
    "estimated_datetime": "2024-04-18T05:45:32",
    "profile_name": "Ahmed Mohamed",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUREajdqM1d3EAE",
    "review_text": "I liked the Americano",
    "cumulative_rating": 4.397790055248619,
    "review_impact": 0.00236349016836801,
    "api_order": 180,
    "id": "ab39d967-f5b7-4de1-b52f-7a0c354d9f0b",
    "analysis": [
      {
        "review_id": "ab39d967-f5b7-4de1-b52f-7a0c354d9f0b",
        "comment": "I liked the Americano",
        "subject_group": "americano",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.00236349016836801,
        "id": "05eae552-694f-4aa3-a59c-d6e5ff4ec5fd"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "9 months ago",
    "estimated_datetime": "2024-04-16T04:09:32",
    "profile_name": "Telse",
    "rating": 4,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUREaFlENjZRRRAB",
    "review_text": "We made a quick stop for a cappuccino and a filled donut and were not disappointed.\nBut the seating area could be cleaner.",
    "cumulative_rating": 4.394444444444445,
    "review_impact": -0.0011330133281353127,
    "api_order": 179,
    "id": "aad48247-8c80-4296-b367-355d19666fc1",
    "analysis": [
      {
        "review_id": "aad48247-8c80-4296-b367-355d19666fc1",
        "comment": "We made a quick stop for a cappuccino and a filled donut and were not disappointed.",
        "subject_group": "cappuccino",
        "category": "product",
        "attribute": "satisfaction",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "ce5552ee-a757-4ba4-b7e9-6cd60906175d"
      },
      {
        "review_id": "aad48247-8c80-4296-b367-355d19666fc1",
        "comment": "We made a quick stop for a cappuccino and a filled donut and were not disappointed.",
        "subject_group": "donut",
        "category": "product",
        "attribute": "satisfaction",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "c4d60973-a66f-4008-bcc0-f4da7c3ae56a"
      },
      {
        "review_id": "aad48247-8c80-4296-b367-355d19666fc1",
        "comment": "But the seating area could be cleaner.",
        "subject_group": "seating area",
        "category": "experience",
        "attribute": "cleanliness",
        "sentiment": "negative",
        "attribute_impact": -0.0011330133281353127,
        "id": "4bb542ac-6521-46ab-b8fe-42f96deb0f62"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "9 months ago",
    "estimated_datetime": "2024-04-14T02:33:32",
    "profile_name": "Fabian Orner",
    "rating": 1,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSURELWFfX01nEAE",
    "review_text": "Horrible food, not even mediocre coffee - stay away!",
    "cumulative_rating": 4.396648044692737,
    "review_impact": -0.011622523817646169,
    "api_order": 178,
    "id": "8cbc4913-660e-40d7-9cd8-f55f9568b8e8",
    "analysis": [
      {
        "review_id": "8cbc4913-660e-40d7-9cd8-f55f9568b8e8",
        "comment": "Horrible food",
        "subject_group": "food",
        "category": "product",
        "attribute": "quality",
        "sentiment": "negative",
        "attribute_impact": -0.005811261908823084,
        "id": "055a3a7c-671a-4d6b-8576-d3275376f439"
      },
      {
        "review_id": "8cbc4913-660e-40d7-9cd8-f55f9568b8e8",
        "comment": "not even mediocre coffee",
        "subject_group": "coffee",
        "category": "product",
        "attribute": "quality",
        "sentiment": "negative",
        "attribute_impact": -0.005811261908823084,
        "id": "aa19e7ab-b345-45ac-8aaa-bbeec24613d8"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "9 months ago",
    "estimated_datetime": "2024-04-12T00:57:32",
    "profile_name": "Jennifer Neumüller",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUREMGZ5V1BREAE",
    "review_text": "Delicious.",
    "cumulative_rating": 4.415730337078652,
    "review_impact": 0.00236349016836801,
    "api_order": 177,
    "id": "a2e2f209-54be-4e61-b766-e8852bacab17",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "9 months ago",
    "estimated_datetime": "2024-04-09T23:21:32",
    "profile_name": "Michelle Sampson",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUREck8zRTZBRRAB",
    "review_text": "My teen son and I love this place. Everything we had was great. The salmon sandwich was especially good. My son's favorite was the Monte Cristo. Service was fast and efficient.",
    "cumulative_rating": 4.4124293785310735,
    "review_impact": 0.00236349016836801,
    "api_order": 176,
    "id": "cee96fb2-e09f-43be-9ff2-e51967151714",
    "analysis": [
      {
        "review_id": "cee96fb2-e09f-43be-9ff2-e51967151714",
        "comment": "My son's favorite was the Monte Cristo",
        "subject_group": "monte cristo",
        "category": "product",
        "attribute": "favoriteness",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "690ba9b2-ebf4-4ae2-9bad-97b68640903a"
      },
      {
        "review_id": "cee96fb2-e09f-43be-9ff2-e51967151714",
        "comment": "Service was fast and efficient",
        "subject_group": "service",
        "category": "service",
        "attribute": "speed",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "6d340e89-2270-4eec-8304-68abbb482472"
      },
      {
        "review_id": "cee96fb2-e09f-43be-9ff2-e51967151714",
        "comment": "My teen son and I love this place",
        "subject_group": "place",
        "category": "experience",
        "attribute": "love",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "b072ab57-b178-4f62-925a-d8d030c0e8a2"
      },
      {
        "review_id": "cee96fb2-e09f-43be-9ff2-e51967151714",
        "comment": "Service was fast and efficient",
        "subject_group": "service",
        "category": "service",
        "attribute": "efficiency",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "ca08dd83-881e-48e6-8d82-36afba6d3232"
      },
      {
        "review_id": "cee96fb2-e09f-43be-9ff2-e51967151714",
        "comment": "The salmon sandwich was especially good",
        "subject_group": "sandwich",
        "category": "product",
        "attribute": "goodness",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "d5f63b62-c4a6-4656-93ce-0ac0daee17ec"
      },
      {
        "review_id": "cee96fb2-e09f-43be-9ff2-e51967151714",
        "comment": "Everything we had was great",
        "subject_group": "everything",
        "category": "product",
        "attribute": "greatness",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "e21a9b9b-9ad4-46b6-9c83-51f394d124ff"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "9 months ago",
    "estimated_datetime": "2024-04-07T21:45:32",
    "profile_name": "Gina Frost",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUREeElfelBREAE",
    "review_text": "Crunchy amazing roast beef roll . These guys know what they are doing 😍",
    "cumulative_rating": 4.409090909090909,
    "review_impact": 0.00236349016836801,
    "api_order": 175,
    "id": "af45cd23-a6d2-4f0c-be4c-38062143580f",
    "analysis": [
      {
        "review_id": "af45cd23-a6d2-4f0c-be4c-38062143580f",
        "comment": "Crunchy amazing roast beef roll",
        "subject_group": "roll",
        "category": "product",
        "attribute": "crunchiness",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "3b7b1e75-c6a5-41d3-9aa3-25c25fa7cbbe"
      },
      {
        "review_id": "af45cd23-a6d2-4f0c-be4c-38062143580f",
        "comment": "Crunchy amazing roast beef roll",
        "subject_group": "roll",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "83da0d4a-7434-480a-9849-b5d314d7b6d2"
      },
      {
        "review_id": "af45cd23-a6d2-4f0c-be4c-38062143580f",
        "comment": "These guys know what they are doing",
        "subject_group": "guys",
        "category": "service",
        "attribute": "expertise",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "c5551cdf-7cc1-4933-96d2-1abdfb0a37d0"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "9 months ago",
    "estimated_datetime": "2024-04-05T20:09:32",
    "profile_name": "Kim Beccu",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUNEejQ2R3h3RRAB",
    "review_text": "Wauw, the food is wonderfull. Very kind staff. But be on time, otherwise all the places are taken. But you can also take-out offcours. All fresh and... not overpriced!!",
    "cumulative_rating": 4.405714285714286,
    "review_impact": 0.00236349016836801,
    "api_order": 174,
    "id": "fd2f2d96-6082-45c6-8f78-cc76c7ba48be",
    "analysis": [
      {
        "review_id": "fd2f2d96-6082-45c6-8f78-cc76c7ba48be",
        "comment": "all fresh",
        "subject_group": "food",
        "category": "product",
        "attribute": "freshness",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "a4274fd1-e8fd-4360-b4bd-ad6067f43520"
      },
      {
        "review_id": "fd2f2d96-6082-45c6-8f78-cc76c7ba48be",
        "comment": "Very kind staff",
        "subject_group": "staff",
        "category": "service",
        "attribute": "kindness",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "b10d2bbf-83f0-4a08-af68-ef293fca7908"
      },
      {
        "review_id": "fd2f2d96-6082-45c6-8f78-cc76c7ba48be",
        "comment": "the food is wonderfull",
        "subject_group": "food",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "c1699653-66af-4b6f-81c1-32a64705fd62"
      },
      {
        "review_id": "fd2f2d96-6082-45c6-8f78-cc76c7ba48be",
        "comment": "not overpriced",
        "subject_group": "price",
        "category": "product",
        "attribute": "value",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "f71a2764-6adf-45f7-a2bb-6d785fd58549"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "9 months ago",
    "estimated_datetime": "2024-04-03T18:33:32",
    "profile_name": "Raul Villarreal",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUNEaWF5cGtnRRAB",
    "review_text": "Absolutely delicious bakes!",
    "cumulative_rating": 4.402298850574713,
    "review_impact": 0.00236349016836801,
    "api_order": 173,
    "id": "a9c3381f-4330-4886-bb04-a7fe12653673",
    "analysis": [
      {
        "review_id": "a9c3381f-4330-4886-bb04-a7fe12653673",
        "comment": "Absolutely delicious bakes!",
        "subject_group": "bake",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.00236349016836801,
        "id": "67c159c3-739a-408b-ba6f-06f1814d55f5"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "9 months ago",
    "estimated_datetime": "2024-04-01T16:57:32",
    "profile_name": "T Sun",
    "rating": 4,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNEOGJDamJnEAE",
    "review_text": "There are seats at the bakery and coffee shop next to Trinity Church, but the seats are a bit crowded. There are many tourists after ten o'clock on Friday morning, so you need to wait.\nThe croissant tastes fresh, crispy and delicious. Croissants with stuffing in them will heat up.",
    "cumulative_rating": 4.398843930635838,
    "review_impact": -0.0011330133281353127,
    "api_order": 172,
    "id": "ea4e9488-44c8-47d0-b01c-7bc9293bef33",
    "analysis": [
      {
        "review_id": "ea4e9488-44c8-47d0-b01c-7bc9293bef33",
        "comment": "There are seats at the bakery and coffee shop next to Trinity Church, but the seats are a bit crowded.",
        "subject_group": "seat",
        "category": "experience",
        "attribute": "availability",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "cae037b0-7f91-47d6-91af-cae4ecd66cf2"
      },
      {
        "review_id": "ea4e9488-44c8-47d0-b01c-7bc9293bef33",
        "comment": "The croissant tastes fresh, crispy and delicious.",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "freshness",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "b3092b72-2337-4fd0-bcd1-9ddf26adb6ae"
      },
      {
        "review_id": "ea4e9488-44c8-47d0-b01c-7bc9293bef33",
        "comment": "The croissant tastes fresh, crispy and delicious.",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "41d771da-464f-4c2f-b6c3-c7357b860d1c"
      },
      {
        "review_id": "ea4e9488-44c8-47d0-b01c-7bc9293bef33",
        "comment": "There are seats at the bakery and coffee shop next to Trinity Church, but the seats are a bit crowded.",
        "subject_group": "seat",
        "category": "experience",
        "attribute": "crowding",
        "sentiment": "negative",
        "attribute_impact": -0.0011330133281353127,
        "id": "3d0970a0-fe7c-457e-b179-4f6b55b9aed7"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "9 months ago",
    "estimated_datetime": "2024-03-30T15:21:32",
    "profile_name": "Jhanvi Shah",
    "rating": 1,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNEcHJYQWVnEAE",
    "review_text": "The server was very rude and pushed me and my friend out of the line. The drink was terrible and warm for a ICED drink. I would not recommend anyone go there or bring their friends or family.",
    "cumulative_rating": 4.401162790697675,
    "review_impact": -0.011622523817646169,
    "api_order": 171,
    "id": "9d1f72bb-e353-4a82-a4dc-5a4dd9ca262d",
    "analysis": [
      {
        "review_id": "9d1f72bb-e353-4a82-a4dc-5a4dd9ca262d",
        "comment": "The drink was terrible and warm for a ICED drink.",
        "subject_group": "drink",
        "category": "product",
        "attribute": "quality",
        "sentiment": "negative",
        "attribute_impact": -0.002905630954411542,
        "id": "53848d0b-805c-46f4-be6b-4ee38f80087c"
      },
      {
        "review_id": "9d1f72bb-e353-4a82-a4dc-5a4dd9ca262d",
        "comment": "The server was very rude and pushed me and my friend out of the line.",
        "subject_group": "server",
        "category": "service",
        "attribute": "rudeness",
        "sentiment": "negative",
        "attribute_impact": -0.002905630954411542,
        "id": "78384233-521e-419b-a43f-74c3b6ab53c8"
      },
      {
        "review_id": "9d1f72bb-e353-4a82-a4dc-5a4dd9ca262d",
        "comment": "The drink was terrible and warm for a ICED drink.",
        "subject_group": "drink",
        "category": "product",
        "attribute": "temperature",
        "sentiment": "negative",
        "attribute_impact": -0.002905630954411542,
        "id": "c4ae29e6-e304-498a-834e-880dfb66a598"
      },
      {
        "review_id": "9d1f72bb-e353-4a82-a4dc-5a4dd9ca262d",
        "comment": "I would not recommend anyone go there or bring their friends or family.",
        "subject_group": "recommendation",
        "category": "experience",
        "attribute": "value",
        "sentiment": "negative",
        "attribute_impact": -0.002905630954411542,
        "id": "dc453bfd-98d4-4cf4-9293-53489a06a59a"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "9 months ago",
    "estimated_datetime": "2024-03-28T13:45:32",
    "profile_name": "Maria Del Capo",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUNEeG9qLW1RRRAB",
    "review_text": "Near the twin towers memorial, a really great place to have breakfast! Super fast and kind service",
    "cumulative_rating": 4.421052631578948,
    "review_impact": 0.00236349016836801,
    "api_order": 170,
    "id": "5a81cc47-741c-42df-94d0-e1e2f3e3100f",
    "analysis": [
      {
        "review_id": "5a81cc47-741c-42df-94d0-e1e2f3e3100f",
        "comment": "Near the twin towers memorial, a really great place to have breakfast!",
        "subject_group": "place",
        "category": "experience",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "4252aa72-bc19-4f7d-ada2-1a4755d5b57f"
      },
      {
        "review_id": "5a81cc47-741c-42df-94d0-e1e2f3e3100f",
        "comment": "Super fast and kind service",
        "subject_group": "service",
        "category": "service",
        "attribute": "speed",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "6b8b4346-f117-4b15-bfdd-7cad91701485"
      },
      {
        "review_id": "5a81cc47-741c-42df-94d0-e1e2f3e3100f",
        "comment": "Super fast and kind service",
        "subject_group": "service",
        "category": "service",
        "attribute": "kindness",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "a46c189c-095f-4e5e-a7f9-4f1f3c532f63"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "10 months ago",
    "estimated_datetime": "2024-03-24T15:21:32",
    "profile_name": "Dustin K. Hasley",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUQ5LW9tUXBRRRAB",
    "review_text": "Happened across Siena Bakehouse because it was downstairs from our hotel room this week, and we are very glad we found it! The coffee was comparably priced but better quality than that other coffee place you can find on every other corner. 😉 The food, though, was on a whole other level! Everything we had here (three visits I think) this week was great. Doughnuts, pastries, sausage egg and cheese croissant, all fantastic. The service was friendly and quick, and in a huge win for humanity there wasn’t even a suggestion of tipping on the checkout device, just a tip jar on the counter and a great staff doing great work! They were able to break down larger bills for me every time I asked. My only regret is not buying the maple bacon cronut as soon as I noticed it, because I never saw that in the case again. 😂 Go here if you get the chance.",
    "cumulative_rating": 4.41764705882353,
    "review_impact": 0.00236349016836801,
    "api_order": 169,
    "id": "d111a5a7-b6a8-48b6-afee-9510981fd08d",
    "analysis": [
      {
        "review_id": "d111a5a7-b6a8-48b6-afee-9510981fd08d",
        "comment": "The coffee was comparably priced but better quality than that other coffee place you can find on every other corner.",
        "subject_group": "coffee",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00023634901683680098,
        "id": "1d9c1549-4c23-41a6-9936-f4a1e36bb082"
      },
      {
        "review_id": "d111a5a7-b6a8-48b6-afee-9510981fd08d",
        "comment": "Doughnut, pastry, sausage egg and cheese croissant, all fantastic.",
        "subject_group": "pastry",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00023634901683680098,
        "id": "45232449-4edf-4149-8fdb-2aac8443c77d"
      },
      {
        "review_id": "d111a5a7-b6a8-48b6-afee-9510981fd08d",
        "comment": "The coffee was comparably priced but better quality than that other coffee place you can find on every other corner.",
        "subject_group": "coffee",
        "category": "product",
        "attribute": "price",
        "sentiment": "positive",
        "attribute_impact": 0.00023634901683680098,
        "id": "530b17be-183e-442f-a2b2-9e55f5d77fd5"
      },
      {
        "review_id": "d111a5a7-b6a8-48b6-afee-9510981fd08d",
        "comment": "Doughnut, pastry, sausage egg and cheese croissant, all fantastic.",
        "subject_group": "doughnut",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00023634901683680098,
        "id": "6966fa22-a01a-40ff-b55e-0efa77c1b1bd"
      },
      {
        "review_id": "d111a5a7-b6a8-48b6-afee-9510981fd08d",
        "comment": "They were able to break down larger bills for me every time I asked.",
        "subject_group": "service",
        "category": "service",
        "attribute": "helpfulness",
        "sentiment": "positive",
        "attribute_impact": 0.00023634901683680098,
        "id": "71b4bd46-410b-4df0-966e-aa8181995287"
      },
      {
        "review_id": "d111a5a7-b6a8-48b6-afee-9510981fd08d",
        "comment": "The food, though, was on a whole other level!",
        "subject_group": "food",
        "category": "product",
        "attribute": "level",
        "sentiment": "positive",
        "attribute_impact": 0.00023634901683680098,
        "id": "79f6792d-5e19-483c-ac0d-36afcff8ad20"
      },
      {
        "review_id": "d111a5a7-b6a8-48b6-afee-9510981fd08d",
        "comment": "The service was friendly and quick.",
        "subject_group": "service",
        "category": "service",
        "attribute": "speed",
        "sentiment": "positive",
        "attribute_impact": 0.00023634901683680098,
        "id": "830113ba-44a5-4fd6-b755-6342e2a7a423"
      },
      {
        "review_id": "d111a5a7-b6a8-48b6-afee-9510981fd08d",
        "comment": "The service was friendly and quick.",
        "subject_group": "service",
        "category": "service",
        "attribute": "friendliness",
        "sentiment": "positive",
        "attribute_impact": 0.00023634901683680098,
        "id": "8626cb89-96e1-460a-826d-311a362437a8"
      },
      {
        "review_id": "d111a5a7-b6a8-48b6-afee-9510981fd08d",
        "comment": "Everything we had here (three visits I think) this week was great.",
        "subject_group": "experience",
        "category": "experience",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00023634901683680098,
        "id": "9b45b908-a58d-4bfb-a836-0e83c5174369"
      },
      {
        "review_id": "d111a5a7-b6a8-48b6-afee-9510981fd08d",
        "comment": "Doughnut, pastry, sausage egg and cheese croissant, all fantastic.",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00023634901683680098,
        "id": "d13738a1-d814-46d9-8b00-5f0ba4ca8b54"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "10 months ago",
    "estimated_datetime": "2024-03-18T20:09:32",
    "profile_name": "Blake West",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUQ5NHZtVWZnEAE",
    "review_text": "All food amazing!  Croissants, bagels, Monte Cristo sandwiches, etc.  Best breakfast ever.  We ate there every morning even on Thanksgiving.  Everyone was super friendly.  Very clean.",
    "cumulative_rating": 4.414201183431953,
    "review_impact": 0.00236349016836801,
    "api_order": 168,
    "id": "4932a59a-93f1-42cf-8d27-6485805a4e49",
    "analysis": [
      {
        "review_id": "4932a59a-93f1-42cf-8d27-6485805a4e49",
        "comment": "Everyone was super friendly.",
        "subject_group": "staff",
        "category": "service",
        "attribute": "friendliness",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "1505a983-b671-4cbf-9017-57d48f8ea92d"
      },
      {
        "review_id": "4932a59a-93f1-42cf-8d27-6485805a4e49",
        "comment": "Best breakfast ever.",
        "subject_group": "breakfast",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "3ba2ffa1-beb4-43e7-bf15-bdf5bfd347f1"
      },
      {
        "review_id": "4932a59a-93f1-42cf-8d27-6485805a4e49",
        "comment": "All food amazing!",
        "subject_group": "food",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "63eff0e2-503c-4c81-83ca-40669d108dbf"
      },
      {
        "review_id": "4932a59a-93f1-42cf-8d27-6485805a4e49",
        "comment": "Very clean.",
        "subject_group": "environment",
        "category": "experience",
        "attribute": "cleanliness",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "b2750cdf-adc6-4258-a128-3f01fa42c4b7"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "10 months ago",
    "estimated_datetime": "2024-03-13T00:57:32",
    "profile_name": "ciara healy",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUQ5M0pDYWlnRRAB",
    "review_text": null,
    "cumulative_rating": 4.410714285714286,
    "review_impact": 0.00236349016836801,
    "api_order": 167,
    "id": "684777f9-516b-45cb-bc81-5cddbca28990",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "10 months ago",
    "estimated_datetime": "2024-03-07T05:45:32",
    "profile_name": "Anne Smith",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSURkNzliRHh3RRAB",
    "review_text": "The sandwiches tasted amazing! We split ours between two people and enjoyed every bite.",
    "cumulative_rating": 4.407185628742515,
    "review_impact": 0.00236349016836801,
    "api_order": 166,
    "id": "e7c6aad6-49d9-4b3d-b3d6-312faf6d79d7",
    "analysis": [
      {
        "review_id": "e7c6aad6-49d9-4b3d-b3d6-312faf6d79d7",
        "comment": "We split ours between two people and enjoyed every bite.",
        "subject_group": "experience",
        "category": "experience",
        "attribute": "enjoyment",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "aaeb5ce9-7929-428a-babe-e0eb2e05ec14"
      },
      {
        "review_id": "e7c6aad6-49d9-4b3d-b3d6-312faf6d79d7",
        "comment": "The sandwiches tasted amazing!",
        "subject_group": "sandwich",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "e74ed647-9ce9-4022-a10a-f7c0d570c4bb"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "10 months ago",
    "estimated_datetime": "2024-03-01T10:33:32",
    "profile_name": "Pete Deserto",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUNoNE8tQXlRRRAB",
    "review_text": "A little slice of Florence in lower Manhattan. Best homemade croissants, sandwiches, and donuts in the city.",
    "cumulative_rating": 4.403614457831325,
    "review_impact": 0.00236349016836801,
    "api_order": 165,
    "id": "57e7eec1-6ca9-42e3-8440-b98057f28c95",
    "analysis": [
      {
        "review_id": "57e7eec1-6ca9-42e3-8440-b98057f28c95",
        "comment": "Best homemade croissants, sandwiches, and donuts in the city.",
        "subject_group": "sandwich",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "7dcc01f6-d668-48d2-8b0f-05ea97be2ec4"
      },
      {
        "review_id": "57e7eec1-6ca9-42e3-8440-b98057f28c95",
        "comment": "Best homemade croissants, sandwiches, and donuts in the city.",
        "subject_group": "donut",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "ba74dc48-b48c-4f97-82fc-b1f4f06becc5"
      },
      {
        "review_id": "57e7eec1-6ca9-42e3-8440-b98057f28c95",
        "comment": "Best homemade croissants, sandwiches, and donuts in the city.",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "c970b9f9-786b-4521-86aa-3beb5bf2cbd4"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "11 months ago",
    "estimated_datetime": "2024-02-25T19:37:32",
    "profile_name": "Stéphanie S",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSURkeVl5ZkVREAE",
    "review_text": "Nice little place for a quick lunch. Salad, sandwich, croque Mr, dessert. Very good.",
    "cumulative_rating": 4.4,
    "review_impact": 0.00236349016836801,
    "api_order": 164,
    "id": "9be6cbdc-1ad7-4756-9fef-e5e43900fb31",
    "analysis": [
      {
        "review_id": "9be6cbdc-1ad7-4756-9fef-e5e43900fb31",
        "comment": "Salad, sandwich, croque Mr, dessert",
        "subject_group": "salad",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "1d819b83-c1f9-48cc-b96d-2787f31669c6"
      },
      {
        "review_id": "9be6cbdc-1ad7-4756-9fef-e5e43900fb31",
        "comment": "Nice little place for a quick lunch",
        "subject_group": "place",
        "category": "experience",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "5879ed9c-05a1-43be-941a-c96d22b50a0c"
      },
      {
        "review_id": "9be6cbdc-1ad7-4756-9fef-e5e43900fb31",
        "comment": "Very good",
        "subject_group": "quality",
        "category": "experience",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "92f420bf-a2a5-49a4-951f-d2cbd53a306e"
      },
      {
        "review_id": "9be6cbdc-1ad7-4756-9fef-e5e43900fb31",
        "comment": "Salad, sandwich, croque Mr, dessert",
        "subject_group": "dessert",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "cc9d89e8-ffaf-4042-9a00-e74e7ceeef9e"
      },
      {
        "review_id": "9be6cbdc-1ad7-4756-9fef-e5e43900fb31",
        "comment": "Salad, sandwich, croque Mr, dessert",
        "subject_group": "croque mr",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "ddcf74a5-50f9-4eb3-8b0a-7301bc629eb0"
      },
      {
        "review_id": "9be6cbdc-1ad7-4756-9fef-e5e43900fb31",
        "comment": "Salad, sandwich, croque Mr, dessert",
        "subject_group": "sandwich",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "e1d16c7a-4b78-4cd7-82ec-fc804ce64701"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "11 months ago",
    "estimated_datetime": "2024-02-22T08:57:32",
    "profile_name": "Majorlunar",
    "rating": 1,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSURkLXZyOUl3EAE",
    "review_text": null,
    "cumulative_rating": 4.396341463414634,
    "review_impact": -0.011622523817646169,
    "api_order": 163,
    "id": "52ebe65f-a631-4780-896a-4a940307e6d8",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "11 months ago",
    "estimated_datetime": "2024-02-18T22:17:32",
    "profile_name": "Sam Martirosian",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSURkLUxqaWpnRRAB",
    "review_text": "Amazing place, delicious cheesecake and…\nMusic was great\nVery chill environment.",
    "cumulative_rating": 4.41717791411043,
    "review_impact": 0.00236349016836801,
    "api_order": 162,
    "id": "c1ccc660-06ad-4d5f-9105-dbe2039c8a0f",
    "analysis": [
      {
        "review_id": "c1ccc660-06ad-4d5f-9105-dbe2039c8a0f",
        "comment": "Amazing place, delicious cheesecake",
        "subject_group": "cheesecake",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "a4558a71-b80d-4c19-a49a-6a181ebfa54e"
      },
      {
        "review_id": "c1ccc660-06ad-4d5f-9105-dbe2039c8a0f",
        "comment": "Music was great",
        "subject_group": "music",
        "category": "experience",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "b62f35be-48f7-47c9-b65e-28af7579b15b"
      },
      {
        "review_id": "c1ccc660-06ad-4d5f-9105-dbe2039c8a0f",
        "comment": "Amazing place, delicious cheesecake",
        "subject_group": "place",
        "category": "experience",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "b9724608-ce53-4b8f-b6e8-0c030fcaaab8"
      },
      {
        "review_id": "c1ccc660-06ad-4d5f-9105-dbe2039c8a0f",
        "comment": "Very chill environment",
        "subject_group": "environment",
        "category": "experience",
        "attribute": "atmosphere",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "e880e14f-9f32-4304-847e-0160236b6c7d"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "11 months ago",
    "estimated_datetime": "2024-02-15T11:37:32",
    "profile_name": "bansi1",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUNkOS02em53RRAB",
    "review_text": "A lovely place to grab a sandwich and a donut for lunch as we did when walking though. We had a Beef sandwich-which was amazing-and a pistachio and an everything donuts. They were delicious!",
    "cumulative_rating": 4.41358024691358,
    "review_impact": 0.00236349016836801,
    "api_order": 161,
    "id": "11706e9f-248f-4343-8846-7cc85eb72da4",
    "analysis": [
      {
        "review_id": "11706e9f-248f-4343-8846-7cc85eb72da4",
        "comment": "We had a Beef sandwich-which was amazing-and a pistachio and an everything donuts.",
        "subject_group": "sandwich",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "05aa369a-435f-4482-8f88-6c91d6068325"
      },
      {
        "review_id": "11706e9f-248f-4343-8846-7cc85eb72da4",
        "comment": "They were delicious!",
        "subject_group": "donut",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "c0f146bb-9d0e-48b3-ad21-f9eb68acddca"
      },
      {
        "review_id": "11706e9f-248f-4343-8846-7cc85eb72da4",
        "comment": "A lovely place to grab a sandwich and a donut for lunch as we did when walking though.",
        "subject_group": "place",
        "category": "experience",
        "attribute": "loveliness",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "d4746bd6-65b1-4cad-8edb-88f00222bd42"
      },
      {
        "review_id": "11706e9f-248f-4343-8846-7cc85eb72da4",
        "comment": "We had a Beef sandwich-which was amazing-and a pistachio and an everything donuts.",
        "subject_group": "donut",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "e0618383-66a1-428a-bc8b-da1790de9953"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "11 months ago",
    "estimated_datetime": "2024-02-12T00:57:32",
    "profile_name": "Sheldon",
    "rating": 4,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNkNklyX0pREAE",
    "review_text": "Good bagels, decent coffee",
    "cumulative_rating": 4.409937888198757,
    "review_impact": -0.0011330133281353127,
    "api_order": 160,
    "id": "f4edbcdf-8e97-446d-aa20-ac418e21e357",
    "analysis": [
      {
        "review_id": "f4edbcdf-8e97-446d-aa20-ac418e21e357",
        "comment": "Good bagels",
        "subject_group": "bagel",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "bb3e1d63-d91e-44cd-9123-e74f49372b9e"
      },
      {
        "review_id": "f4edbcdf-8e97-446d-aa20-ac418e21e357",
        "comment": "decent coffee",
        "subject_group": "coffee",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "686dffee-5add-459e-bfea-7a0527c30a73"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "11 months ago",
    "estimated_datetime": "2024-02-08T14:17:32",
    "profile_name": "Pablo J.",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUNkeUphSTJRRRAB",
    "review_text": "Good, cofre and dessert was great!",
    "cumulative_rating": 4.4125,
    "review_impact": 0.00236349016836801,
    "api_order": 159,
    "id": "30a679a4-0b3c-42bb-8fa7-afea6edfbbba",
    "analysis": [
      {
        "review_id": "30a679a4-0b3c-42bb-8fa7-afea6edfbbba",
        "comment": "dessert was great",
        "subject_group": "dessert",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "54ddf02f-5b49-4c77-80ed-f297bbacb402"
      },
      {
        "review_id": "30a679a4-0b3c-42bb-8fa7-afea6edfbbba",
        "comment": "Good",
        "subject_group": "cofre",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "f979be1c-b803-40d8-abd8-0644f1ecafcf"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "11 months ago",
    "estimated_datetime": "2024-02-05T03:37:32",
    "profile_name": "Marion",
    "rating": 4,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUR0a18zVjZBRRAB",
    "review_text": "Love their sister pizza place, Siena Pizza, and their bake shop is just as good. Loved the everything donut while the crème brûlée one was good but I wish it had more depth of flavor. The other pastries looked interesting too. Price is a bit steep and comparable even with higher end options (La Mercerie, T Bakerie, Frenchette) but overall still good.",
    "cumulative_rating": 4.408805031446541,
    "review_impact": -0.0011330133281353127,
    "api_order": 158,
    "id": "4c39648a-0194-4fa7-ad8d-44869e47c4d4",
    "analysis": [
      {
        "review_id": "4c39648a-0194-4fa7-ad8d-44869e47c4d4",
        "comment": "Love their sister pizza place, Siena Pizza, and their bake shop is just as good.",
        "subject_group": "bake shop",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "ef7e01d1-8e10-4738-9aad-2ea0da3ca50f"
      },
      {
        "review_id": "4c39648a-0194-4fa7-ad8d-44869e47c4d4",
        "comment": "Loved the everything donut while the crème brûlée one was good but I wish it had more depth of flavor.",
        "subject_group": "donut",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "e02ec29e-0fad-4a91-966e-80fdc457730a"
      },
      {
        "review_id": "4c39648a-0194-4fa7-ad8d-44869e47c4d4",
        "comment": "Price is a bit steep and comparable even with higher end options (La Mercerie, T Bakerie, Frenchette) but overall still good.",
        "subject_group": "price",
        "category": "product",
        "attribute": "value",
        "sentiment": "negative",
        "attribute_impact": -0.0005665066640676564,
        "id": "a2a8ca4d-6745-4a84-91c7-ddc81c8570a3"
      },
      {
        "review_id": "4c39648a-0194-4fa7-ad8d-44869e47c4d4",
        "comment": "Loved the everything donut while the crème brûlée one was good but I wish it had more depth of flavor.",
        "subject_group": "crème brûlée",
        "category": "product",
        "attribute": "taste",
        "sentiment": "negative",
        "attribute_impact": -0.0005665066640676564,
        "id": "a5173020-fd2b-4680-b894-e536b1cc8d83"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "11 months ago",
    "estimated_datetime": "2024-02-01T16:57:32",
    "profile_name": "Layla 26",
    "rating": 4,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUR0dzhpZjZRRRAB",
    "review_text": null,
    "cumulative_rating": 4.4113924050632916,
    "review_impact": -0.0011330133281353127,
    "api_order": 157,
    "id": "6d664c70-20e8-40e6-95b4-a24874a49e1b",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "11 months ago",
    "estimated_datetime": "2024-01-29T06:17:32",
    "profile_name": "Ian McArdle",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUR0Z2FySW53RRAB",
    "review_text": "Great coffee and a good selection of fresh sweet and savoury treats only a short walk from the World Trade Centre and 9/11 memorial.",
    "cumulative_rating": 4.414012738853503,
    "review_impact": 0.00236349016836801,
    "api_order": 156,
    "id": "dfe3fec6-cdff-4155-a30d-ba664501562a",
    "analysis": [
      {
        "review_id": "dfe3fec6-cdff-4155-a30d-ba664501562a",
        "comment": "a good selection of fresh sweet and savoury treats",
        "subject_group": "treat",
        "category": "product",
        "attribute": "variety",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "27250382-1037-4eac-a533-6c84d169a2ee"
      },
      {
        "review_id": "dfe3fec6-cdff-4155-a30d-ba664501562a",
        "comment": "Great coffee",
        "subject_group": "coffee",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "53a1924c-230a-474d-9c6e-1458e39a0fe7"
      },
      {
        "review_id": "dfe3fec6-cdff-4155-a30d-ba664501562a",
        "comment": "a good selection of fresh sweet and savoury treats",
        "subject_group": "treat",
        "category": "product",
        "attribute": "freshness",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "75b3d922-5992-4339-bd94-b58a8c130b76"
      },
      {
        "review_id": "dfe3fec6-cdff-4155-a30d-ba664501562a",
        "comment": "only a short walk from the World Trade Centre and 9/11 memorial",
        "subject_group": "location",
        "category": "experience",
        "attribute": "accessibility",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "86c626be-813d-49a5-a2f3-6b912a977c9b"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2024-01-26T07:45:32",
    "profile_name": "phi laforgue",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNOcDRXSUV3EAE",
    "review_text": "Great place !!",
    "cumulative_rating": 4.410256410256411,
    "review_impact": 0.00236349016836801,
    "api_order": 155,
    "id": "e5c89f3a-7cdc-473b-ab6d-9f3091cf9bdf",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2024-01-23T21:21:32",
    "profile_name": "Anika Sumush",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUNOcTdpSm5BRRAB",
    "review_text": null,
    "cumulative_rating": 4.406451612903226,
    "review_impact": 0.00236349016836801,
    "api_order": 154,
    "id": "9aac51a2-d1e5-48ee-a9b6-352658c18798",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2024-01-21T10:57:32",
    "profile_name": "Elizabeth",
    "rating": 4,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUNOX3Z1MnNBRRAB",
    "review_text": "I love anything pink and ventured out to this nice bakery after searching for a nice little cafe for breakfast. Found this place right next to my hotel and decided to check it out. Although it is on the pricey end, I did enjoy my White Mocha and Breakfast Sandwich on a Brioche Bun.\n\nI really did not enjoy the slice of carrot cake and my son felt like the Bacon, Egg, and Cheese Croissant was a bit dry and hard. Overall, I wouldn’t mind coming back to this quaint place.",
    "cumulative_rating": 4.402597402597403,
    "review_impact": -0.0011330133281353127,
    "api_order": 153,
    "id": "3c5b9d26-edaa-40cd-b8ff-de9813c0da3c",
    "analysis": [
      {
        "review_id": "3c5b9d26-edaa-40cd-b8ff-de9813c0da3c",
        "comment": "Although it is on the pricey end, I did enjoy my White Mocha and Breakfast Sandwich on a Brioche Bun",
        "subject_group": "white mocha",
        "category": "product",
        "attribute": "enjoyment",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "5682175f-48c0-437f-bed8-563cc6cd65b1"
      },
      {
        "review_id": "3c5b9d26-edaa-40cd-b8ff-de9813c0da3c",
        "comment": "Although it is on the pricey end, I did enjoy my White Mocha and Breakfast Sandwich on a Brioche Bun",
        "subject_group": "breakfast sandwich",
        "category": "product",
        "attribute": "enjoyment",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "5abb3964-dff0-454e-b4ba-df790b38d277"
      },
      {
        "review_id": "3c5b9d26-edaa-40cd-b8ff-de9813c0da3c",
        "comment": "I really did not enjoy the slice of carrot cake",
        "subject_group": "carrot cake",
        "category": "product",
        "attribute": "enjoyment",
        "sentiment": "negative",
        "attribute_impact": -0.0005665066640676564,
        "id": "5b4896e7-4451-4eb8-9868-62e14373cd5e"
      },
      {
        "review_id": "3c5b9d26-edaa-40cd-b8ff-de9813c0da3c",
        "comment": "my son felt like the Bacon, Egg, and Cheese Croissant was a bit dry and hard",
        "subject_group": "bacon, egg, and cheese croissant",
        "category": "product",
        "attribute": "texture",
        "sentiment": "negative",
        "attribute_impact": -0.0005665066640676564,
        "id": "858d0b53-d753-46b2-af78-21ab4684d5ea"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2024-01-19T00:33:32",
    "profile_name": "Felice Caccamo",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUQxMjhlTk5nEAE",
    "review_text": "My favourite breakfast place when I am in NY for work! love all their products - the pastries are so flakey and crunchy, the supremes really delicious and the overnight oats superb! They make really good coffee, too. Also they have a pizzeria next door, which serves great pizza imo. Lovely atmosphere",
    "cumulative_rating": 4.405228758169935,
    "review_impact": 0.00236349016836801,
    "api_order": 152,
    "id": "a2ba868d-f4a7-4508-980b-06732101c1a1",
    "analysis": [
      {
        "review_id": "a2ba868d-f4a7-4508-980b-06732101c1a1",
        "comment": "Lovely atmosphere",
        "subject_group": "atmosphere",
        "category": "experience",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0003376414526240014,
        "id": "390afd8b-3210-436a-8993-8a0e45aa48f2"
      },
      {
        "review_id": "a2ba868d-f4a7-4508-980b-06732101c1a1",
        "comment": "the pastries are so flakey and crunchy",
        "subject_group": "pastry",
        "category": "product",
        "attribute": "texture",
        "sentiment": "positive",
        "attribute_impact": 0.0003376414526240014,
        "id": "8467758c-a229-4c31-9b1f-67a32b40ea3c"
      },
      {
        "review_id": "a2ba868d-f4a7-4508-980b-06732101c1a1",
        "comment": "love all their products",
        "subject_group": "product",
        "category": "product",
        "attribute": "variety",
        "sentiment": "positive",
        "attribute_impact": 0.0003376414526240014,
        "id": "ab80ed38-0e7f-4c2e-bd53-fddff212ace1"
      },
      {
        "review_id": "a2ba868d-f4a7-4508-980b-06732101c1a1",
        "comment": "They make really good coffee, too",
        "subject_group": "coffee",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0003376414526240014,
        "id": "b2e453ed-002e-4830-82a0-d1424ad5a7ca"
      },
      {
        "review_id": "a2ba868d-f4a7-4508-980b-06732101c1a1",
        "comment": "they have a pizzeria next door, which serves great pizza imo",
        "subject_group": "pizza",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.0003376414526240014,
        "id": "e355f820-a453-4662-b929-2927279ce41f"
      },
      {
        "review_id": "a2ba868d-f4a7-4508-980b-06732101c1a1",
        "comment": "the overnight oats superb",
        "subject_group": "oat",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0003376414526240014,
        "id": "e9b6397c-bf74-465e-a4a6-85501ac60683"
      },
      {
        "review_id": "a2ba868d-f4a7-4508-980b-06732101c1a1",
        "comment": "the supremes really delicious",
        "subject_group": "supreme",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.0003376414526240014,
        "id": "f9d66aa8-7a2f-491f-9bf5-023aeb618bdb"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2024-01-16T14:09:32",
    "profile_name": "Sheiry Hernández",
    "rating": 1,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUQxeGFfWWhRRRAB",
    "review_text": "The super annoying person to deal with the angry customer was a man who was serving them, they need customer service training",
    "cumulative_rating": 4.401315789473684,
    "review_impact": -0.011622523817646169,
    "api_order": 151,
    "id": "15b7f372-212a-4e98-8e3b-99f0708282b9",
    "analysis": [
      {
        "review_id": "15b7f372-212a-4e98-8e3b-99f0708282b9",
        "comment": "The super annoying person to deal with the angry customer was a man who was serving them",
        "subject_group": "man",
        "category": "service",
        "attribute": "training",
        "sentiment": "negative",
        "attribute_impact": -0.011622523817646169,
        "id": "7fdf300d-f898-459e-bc5b-88ee8ec58b1a"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2024-01-14T03:45:32",
    "profile_name": "kassandra schengili",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUMxeTg3TzJBRRAB",
    "review_text": "As a French person living in NYC, this was by far one of the best pain au chocolat (chocolate croissant) I have had in the city. An unexpected gem",
    "cumulative_rating": 4.423841059602649,
    "review_impact": 0.00236349016836801,
    "api_order": 150,
    "id": "31b9847c-b847-40ab-8be1-a2d676541b4e",
    "analysis": [
      {
        "review_id": "31b9847c-b847-40ab-8be1-a2d676541b4e",
        "comment": "this was by far one of the best pain au chocolat (chocolate croissant) I have had in the city",
        "subject_group": "pain au chocolat",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "c0604ea3-8780-4149-a422-875e58bf1817"
      },
      {
        "review_id": "31b9847c-b847-40ab-8be1-a2d676541b4e",
        "comment": "An unexpected gem",
        "subject_group": "gem",
        "category": "experience",
        "attribute": "surprise",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "f82f9d10-8d76-406c-b540-758687448475"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2024-01-11T17:21:32",
    "profile_name": "Carmel Kinging",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUMxaG9iaGhBRRAB",
    "review_text": "Arrived late in NYC bought cafe latte was so good. In the morning ordered plain croissant with coffee…the best croissant I’ve eaten !",
    "cumulative_rating": 4.42,
    "review_impact": 0.00236349016836801,
    "api_order": 149,
    "id": "7b8ce62d-a24d-4865-a225-573fed3d47af",
    "analysis": [
      {
        "review_id": "7b8ce62d-a24d-4865-a225-573fed3d47af",
        "comment": "In the morning ordered plain croissant with coffee…the best croissant I’ve eaten !",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "36c690f9-0911-49cc-8eba-f0e60f40898b"
      },
      {
        "review_id": "7b8ce62d-a24d-4865-a225-573fed3d47af",
        "comment": "Arrived late in NYC bought cafe latte was so good",
        "subject_group": "latte",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "e9ce84b3-6033-4aca-a2ab-26345deff1cd"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2024-01-09T06:57:32",
    "profile_name": "Alondra Ayon",
    "rating": 4,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUMxLXZma093EAE",
    "review_text": "The place is very cozy and for a quick breakfast it is very good, I give the coffee a 7 out of 10 but it is acceptable. We only tried a Greek yogurt and an almond bread filled with cream which we found exciting. I will definitely return for something else in total. For two coffees, bread and yogurt, it was 25.20.",
    "cumulative_rating": 4.416107382550336,
    "review_impact": -0.0011330133281353127,
    "api_order": 148,
    "id": "fb6920de-8cc7-4587-8141-76c7a4678812",
    "analysis": [
      {
        "review_id": "fb6920de-8cc7-4587-8141-76c7a4678812",
        "comment": "The place is very cozy",
        "subject_group": "place",
        "category": "experience",
        "attribute": "coziness",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "741d0bf5-e31f-485a-84ae-7f07244f01e8"
      },
      {
        "review_id": "fb6920de-8cc7-4587-8141-76c7a4678812",
        "comment": "for a quick breakfast it is very good",
        "subject_group": "breakfast",
        "category": "experience",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "137cf61d-fd46-4c22-aa9e-40b85f030b1b"
      },
      {
        "review_id": "fb6920de-8cc7-4587-8141-76c7a4678812",
        "comment": "I give the coffee a 7 out of 10 but it is acceptable",
        "subject_group": "coffee",
        "category": "product",
        "attribute": "rating",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "315bbc46-f4a4-4866-b322-3985dee35a6c"
      },
      {
        "review_id": "fb6920de-8cc7-4587-8141-76c7a4678812",
        "comment": "I give the coffee a 7 out of 10 but it is acceptable",
        "subject_group": "coffee",
        "category": "product",
        "attribute": "acceptability",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "6c389dff-10a0-4934-be50-1661363e8b21"
      },
      {
        "review_id": "fb6920de-8cc7-4587-8141-76c7a4678812",
        "comment": "we only tried a Greek yogurt and an almond bread filled with cream which we found exciting",
        "subject_group": "yogurt",
        "category": "product",
        "attribute": "excitement",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "992079e1-bc7d-4d51-b4ba-65f6b80b34bb"
      },
      {
        "review_id": "fb6920de-8cc7-4587-8141-76c7a4678812",
        "comment": "we only tried a Greek yogurt and an almond bread filled with cream which we found exciting",
        "subject_group": "bread",
        "category": "product",
        "attribute": "excitement",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "9c4170ce-b5e3-4167-afa6-9977b7b9fcda"
      },
      {
        "review_id": "fb6920de-8cc7-4587-8141-76c7a4678812",
        "comment": "it was 25.20",
        "subject_group": "price",
        "category": "product",
        "attribute": "value",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "e5a903c9-1f2f-4946-9b8f-79207669b120"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2024-01-06T20:33:32",
    "profile_name": "The Random Channel",
    "rating": 4,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUNSamZXb2x3RRAB",
    "review_text": "What to get/why it's a good place.\n\nFantastic place with lots of variety. Went with my family. We got a bunch of different croissants which were great. My favorite thing, though, was the Nutella croissant. It was messy but so good! We also got a cheese danish which was very good.\n\nWhat not to get:\nSadly, the almond croissant had over liquidy almond paste. Coffee was decent. This one croissant called the cheesecake croissant was overly sweet, but the taste of it was alright.",
    "cumulative_rating": 4.418918918918919,
    "review_impact": -0.0011330133281353127,
    "api_order": 147,
    "id": "ea218b12-53e3-40ba-834d-fc382407b47d",
    "analysis": [
      {
        "review_id": "ea218b12-53e3-40ba-834d-fc382407b47d",
        "comment": "Fantastic place with lots of variety",
        "subject_group": "place",
        "category": "experience",
        "attribute": "variety",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "dd79e9e9-db3d-47b4-b6e4-5d070f2fae9e"
      },
      {
        "review_id": "ea218b12-53e3-40ba-834d-fc382407b47d",
        "comment": "We got a bunch of different croissants which were great",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "9eb26694-898c-4f2c-b7d4-d62127101bdd"
      },
      {
        "review_id": "ea218b12-53e3-40ba-834d-fc382407b47d",
        "comment": "My favorite thing, though, was the Nutella croissant",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "preference",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "ee49d883-a95b-4acd-8175-2881cf5e683e"
      },
      {
        "review_id": "ea218b12-53e3-40ba-834d-fc382407b47d",
        "comment": "It was messy but so good",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "00e3dae9-798a-468d-a6ee-7a5b26d45a9c"
      },
      {
        "review_id": "ea218b12-53e3-40ba-834d-fc382407b47d",
        "comment": "We also got a cheese danish which was very good",
        "subject_group": "danish",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "b468f52b-78c9-4fec-be63-fabab1d35213"
      },
      {
        "review_id": "ea218b12-53e3-40ba-834d-fc382407b47d",
        "comment": "but the taste of it was alright",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "4e96deea-0475-45b2-ae7b-3cdf46c3dafc"
      },
      {
        "review_id": "ea218b12-53e3-40ba-834d-fc382407b47d",
        "comment": "Sadly, the almond croissant had over liquidy almond paste",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "texture",
        "sentiment": "negative",
        "attribute_impact": -0.0002832533320338282,
        "id": "b468f55b-dc59-4506-a0af-0c12f34e2c8b"
      },
      {
        "review_id": "ea218b12-53e3-40ba-834d-fc382407b47d",
        "comment": "Coffee was decent",
        "subject_group": "coffee",
        "category": "product",
        "attribute": "quality",
        "sentiment": "negative",
        "attribute_impact": -0.0002832533320338282,
        "id": "bf1bc73d-14f5-4b25-a992-bccdad317c04"
      },
      {
        "review_id": "ea218b12-53e3-40ba-834d-fc382407b47d",
        "comment": "It was messy but so good",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "messiness",
        "sentiment": "negative",
        "attribute_impact": -0.0002832533320338282,
        "id": "eadc16fe-7532-4d90-b328-ef3035a72bf8"
      },
      {
        "review_id": "ea218b12-53e3-40ba-834d-fc382407b47d",
        "comment": "This one croissant called the cheesecake croissant was overly sweet",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "sweetness",
        "sentiment": "negative",
        "attribute_impact": -0.0002832533320338282,
        "id": "f492517c-1b10-4384-99f0-3d336d6f3d41"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2024-01-04T10:09:32",
    "profile_name": "Polina Anisova",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUMxc3Fpa29RRRAB",
    "review_text": "Croissants with scramble and bacon/raspberry cronuts are sooo delicious",
    "cumulative_rating": 4.421768707482993,
    "review_impact": 0.00236349016836801,
    "api_order": 146,
    "id": "833d44dd-db1c-40ee-86ae-84d32bfe42f9",
    "analysis": [
      {
        "review_id": "833d44dd-db1c-40ee-86ae-84d32bfe42f9",
        "comment": "raspberry cronuts are sooo delicious",
        "subject_group": "cronut",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "14df9435-860b-43a1-805b-75d8dacd6f23"
      },
      {
        "review_id": "833d44dd-db1c-40ee-86ae-84d32bfe42f9",
        "comment": "Croissants with scramble and bacon",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "fd4f3946-8ba7-4c7d-b8a8-1b638dc9dc99"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2024-01-01T23:45:32",
    "profile_name": "Impressive Stuff",
    "rating": 3,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUMxZ3ZuMkVREAE",
    "review_text": null,
    "cumulative_rating": 4.417808219178082,
    "review_impact": -0.004629516824638635,
    "api_order": 145,
    "id": "01f41bea-99a5-411c-b48a-125b6d757cdf",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-12-30T13:21:32",
    "profile_name": "Patricia Uribe",
    "rating": 1,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUMxaE1xcEVBEAE",
    "review_text": "Sooooo bad service and racism.! From the cashier",
    "cumulative_rating": 4.427586206896552,
    "review_impact": -0.011622523817646169,
    "api_order": 144,
    "id": "3d79c89c-7e65-46df-af92-64d4cc19e8d7",
    "analysis": [
      {
        "review_id": "3d79c89c-7e65-46df-af92-64d4cc19e8d7",
        "comment": "From the cashier.",
        "subject_group": "cashier",
        "category": "service",
        "attribute": "behavior",
        "sentiment": "negative",
        "attribute_impact": -0.003874174605882056,
        "id": "8da5953d-fe87-4a88-9967-b74178d96c01"
      },
      {
        "review_id": "3d79c89c-7e65-46df-af92-64d4cc19e8d7",
        "comment": "Sooooo bad service and racism.",
        "subject_group": "service",
        "category": "service",
        "attribute": "quality",
        "sentiment": "negative",
        "attribute_impact": -0.003874174605882056,
        "id": "acacc161-ff05-43c3-9900-9a3999eba0da"
      },
      {
        "review_id": "3d79c89c-7e65-46df-af92-64d4cc19e8d7",
        "comment": "Sooooo bad service and racism.",
        "subject_group": "racism",
        "category": "experience",
        "attribute": "behavior",
        "sentiment": "negative",
        "attribute_impact": -0.003874174605882056,
        "id": "adffebd3-b725-4463-8cc9-a00b7c887abd"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-12-28T02:57:32",
    "profile_name": "Laura Mendez",
    "rating": 1,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUMxaEtLaldnEAE",
    "review_text": "Poor Customer service from front desk, bad attitude, not respectful",
    "cumulative_rating": 4.451388888888889,
    "review_impact": -0.011622523817646169,
    "api_order": 143,
    "id": "dc1d7566-6750-4453-aa61-8fc41b8a1b6e",
    "analysis": [
      {
        "review_id": "dc1d7566-6750-4453-aa61-8fc41b8a1b6e",
        "comment": "Poor Customer service from front desk",
        "subject_group": "service",
        "category": "service",
        "attribute": "quality",
        "sentiment": "negative",
        "attribute_impact": -0.003874174605882056,
        "id": "46d3380d-9c52-4218-ac33-1abddcbaee95"
      },
      {
        "review_id": "dc1d7566-6750-4453-aa61-8fc41b8a1b6e",
        "comment": "not respectful",
        "subject_group": "respect",
        "category": "service",
        "attribute": "quality",
        "sentiment": "negative",
        "attribute_impact": -0.003874174605882056,
        "id": "6a7dd35b-bbda-4ad7-8e61-510205aa16cb"
      },
      {
        "review_id": "dc1d7566-6750-4453-aa61-8fc41b8a1b6e",
        "comment": "bad attitude",
        "subject_group": "attitude",
        "category": "service",
        "attribute": "quality",
        "sentiment": "negative",
        "attribute_impact": -0.003874174605882056,
        "id": "8c85f35a-1578-4013-8a03-d9464aee9bc0"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-12-25T16:33:32",
    "profile_name": "Tom Hutchings",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSURWMVlpQmlnRRAB",
    "review_text": "Visited from the UK.  Their Nutella croissants were really tasty and our two boys enjoyed their breakfast rolls.  Lovely Christmas atmosphere and staff were super friendly and helpful.  Great pit stop before hitting the tourist spots!",
    "cumulative_rating": 4.475524475524476,
    "review_impact": 0.00236349016836801,
    "api_order": 142,
    "id": "b007f44b-079d-427d-a3e0-7f68144a873c",
    "analysis": [
      {
        "review_id": "b007f44b-079d-427d-a3e0-7f68144a873c",
        "comment": "our two boys enjoyed their breakfast rolls",
        "subject_group": "roll",
        "category": "product",
        "attribute": "enjoyment",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "34223bfb-7a52-4f74-8f12-209a089b956e"
      },
      {
        "review_id": "b007f44b-079d-427d-a3e0-7f68144a873c",
        "comment": "staff were super friendly and helpful",
        "subject_group": "staff",
        "category": "service",
        "attribute": "friendliness",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "3a1aed2d-f5f3-43fd-b321-8e61c6ecec29"
      },
      {
        "review_id": "b007f44b-079d-427d-a3e0-7f68144a873c",
        "comment": "Great pit stop before hitting the tourist spots",
        "subject_group": "pit stop",
        "category": "experience",
        "attribute": "greatness",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "496be8df-262b-41cb-82be-3795a3c04283"
      },
      {
        "review_id": "b007f44b-079d-427d-a3e0-7f68144a873c",
        "comment": "Their Nutella croissants were really tasty",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "71b66c99-4072-4591-b00c-31cdb7dd6096"
      },
      {
        "review_id": "b007f44b-079d-427d-a3e0-7f68144a873c",
        "comment": "Lovely Christmas atmosphere",
        "subject_group": "atmosphere",
        "category": "experience",
        "attribute": "loveliness",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "7a7e7519-2eb8-4937-ad35-cca6daa4753e"
      },
      {
        "review_id": "b007f44b-079d-427d-a3e0-7f68144a873c",
        "comment": "staff were super friendly and helpful",
        "subject_group": "staff",
        "category": "service",
        "attribute": "helpfulness",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "f28fa7cd-6922-4cc8-8970-ade29d075ff5"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-12-23T06:09:32",
    "profile_name": "Winfried Schumann",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSURWOGRydFhBEAE",
    "review_text": null,
    "cumulative_rating": 4.471830985915493,
    "review_impact": 0.00236349016836801,
    "api_order": 141,
    "id": "61d0e3c2-b31f-4105-890e-2693a1ad14bf",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-12-20T19:45:32",
    "profile_name": "Yeamen S. Ali",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSURWcHNDSTdRRRAB",
    "review_text": "This place has many great options to explore! I initially went there for their supreme croissants specifically their pistachio flavored one but I was too late! I ended up getting their Nutella supreme croissant, which was amazing!! Definitely go early for the other flavors! But I also couldn’t resist myself from getting their brioche donuts. I got their Nutella, raspberry jam and everything cream cheese donuts. Each one was different but very delicious! If you have a sweet tooth then this place is definitely worth the visit! I’d love to come back to try their savory options!",
    "cumulative_rating": 4.468085106382978,
    "review_impact": 0.00236349016836801,
    "api_order": 140,
    "id": "ced82cbc-691f-4f1e-a47c-4a0d3934db92",
    "analysis": [
      {
        "review_id": "ced82cbc-691f-4f1e-a47c-4a0d3934db92",
        "comment": "I ended up getting their Nutella supreme croissant, which was amazing!!",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "6e54cd41-06f3-4287-b768-2705fab6cbd4"
      },
      {
        "review_id": "ced82cbc-691f-4f1e-a47c-4a0d3934db92",
        "comment": "I initially went there for their supreme croissant specifically their pistachio flavored one but I was too late!",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "flavor",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "87f7d793-dd6f-4228-be73-5fd89d4945bb"
      },
      {
        "review_id": "ced82cbc-691f-4f1e-a47c-4a0d3934db92",
        "comment": "Each one was different but very delicious!",
        "subject_group": "donut",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "9e82315c-95dc-42ee-bdb8-c5522f048de5"
      },
      {
        "review_id": "ced82cbc-691f-4f1e-a47c-4a0d3934db92",
        "comment": "I got their Nutella, raspberry jam and everything cream cheese donuts.",
        "subject_group": "donut",
        "category": "product",
        "attribute": "variety",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "e5c13ac2-1eac-4662-bf5d-55b4516292fd"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-12-18T09:21:32",
    "profile_name": "Lime Islami",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSURGdzRiM2pRRRAB",
    "review_text": "Our hotel was near Siena Bakehouse, we went every morning and had breakfast there!\nTheir croissants are amazing!!",
    "cumulative_rating": 4.464285714285714,
    "review_impact": 0.00236349016836801,
    "api_order": 139,
    "id": "189ad36a-9b8b-403e-9226-c83a6de9bd17",
    "analysis": [
      {
        "review_id": "189ad36a-9b8b-403e-9226-c83a6de9bd17",
        "comment": "Their croissants are amazing",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00236349016836801,
        "id": "535738c8-12b5-466d-a091-44a770c32b62"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-12-15T22:57:32",
    "profile_name": "DJ P",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUNWNGY2bDlBRRAB",
    "review_text": "Delicious Nutella stuffed croissant! Beautiful decor and friendly atmosphere.  Love it!",
    "cumulative_rating": 4.460431654676259,
    "review_impact": 0.00236349016836801,
    "api_order": 138,
    "id": "6bb42c51-3d4f-461c-b736-f16dba3da5f5",
    "analysis": [
      {
        "review_id": "6bb42c51-3d4f-461c-b736-f16dba3da5f5",
        "comment": "Beautiful decor and friendly atmosphere.",
        "subject_group": "decor",
        "category": "experience",
        "attribute": "aesthetic",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "24852163-121b-4a7b-8227-2ebfdbbbc0d7"
      },
      {
        "review_id": "6bb42c51-3d4f-461c-b736-f16dba3da5f5",
        "comment": "Delicious Nutella stuffed croissant!",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "a5304981-45ec-44d6-ba4f-33cc88f6271a"
      },
      {
        "review_id": "6bb42c51-3d4f-461c-b736-f16dba3da5f5",
        "comment": "Beautiful decor and friendly atmosphere.",
        "subject_group": "atmosphere",
        "category": "experience",
        "attribute": "friendliness",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "a723adae-3cc5-4873-b6c0-7eee0426b083"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-12-13T12:33:32",
    "profile_name": "B Alice",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUNWdXQtY2dRRRAB",
    "review_text": "We were here several times during our stay in New York. The staff is very friendly and we can only recommend both the sweet and savory snacks, rolls etc.\nThere is a customer toilet (code must be requested).",
    "cumulative_rating": 4.456521739130435,
    "review_impact": 0.00236349016836801,
    "api_order": 137,
    "id": "caf47e0b-a779-4d6c-8ef8-c0d7e9346c58",
    "analysis": [
      {
        "review_id": "caf47e0b-a779-4d6c-8ef8-c0d7e9346c58",
        "comment": "we can only recommend both the sweet and savory snacks",
        "subject_group": "snack",
        "category": "product",
        "attribute": "recommendation",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "201ca441-d1e6-490d-abb0-bc03f992abe5"
      },
      {
        "review_id": "caf47e0b-a779-4d6c-8ef8-c0d7e9346c58",
        "comment": "The staff is very friendly",
        "subject_group": "staff",
        "category": "service",
        "attribute": "friendliness",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "ca371908-27bf-4775-8fef-f12d2ce92f0e"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-12-11T02:09:32",
    "profile_name": "Nicolas Sardella",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUNWM09iend3RRAB",
    "review_text": null,
    "cumulative_rating": 4.452554744525547,
    "review_impact": 0.00236349016836801,
    "api_order": 136,
    "id": "9b280f42-66b2-4c66-80a0-22260b85fc9d",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-12-08T15:45:32",
    "profile_name": "Desiree V",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSURscVliUGd3RRAB",
    "review_text": "Delicious coffee! We had breakfast here every day during our holiday. Delicious pastries, beagels, fruit & oat. Fast service and you'll be back outside within half an hour!! Tegek!",
    "cumulative_rating": 4.448529411764706,
    "review_impact": 0.00236349016836801,
    "api_order": 135,
    "id": "89e37da1-36a4-416d-82a0-60800232af72",
    "analysis": [
      {
        "review_id": "89e37da1-36a4-416d-82a0-60800232af72",
        "comment": "Delicious pastries, beagels, fruit & oat.",
        "subject_group": "beagel",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "03f8ac57-b9a8-4da0-ba5a-89e638360dba"
      },
      {
        "review_id": "89e37da1-36a4-416d-82a0-60800232af72",
        "comment": "Delicious coffee!",
        "subject_group": "coffee",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "2cced68b-c4ae-46ea-a024-c6cd485c4193"
      },
      {
        "review_id": "89e37da1-36a4-416d-82a0-60800232af72",
        "comment": "Fast service and you'll be back outside within half an hour!!",
        "subject_group": "service",
        "category": "service",
        "attribute": "speed",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "3c2f0522-532e-478b-b1b5-9cbd32fce7b8"
      },
      {
        "review_id": "89e37da1-36a4-416d-82a0-60800232af72",
        "comment": "Delicious pastries, beagels, fruit & oat.",
        "subject_group": "fruit",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "6105164a-906e-4971-93e7-5f2bcdb3e3cf"
      },
      {
        "review_id": "89e37da1-36a4-416d-82a0-60800232af72",
        "comment": "Delicious pastries, beagels, fruit & oat.",
        "subject_group": "oat",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "a0a89ed7-8f4f-4ee4-b387-6e5905e5a114"
      },
      {
        "review_id": "89e37da1-36a4-416d-82a0-60800232af72",
        "comment": "Delicious pastries, beagels, fruit & oat.",
        "subject_group": "pastry",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "a16761b2-a33e-4512-9a91-4daa54a173af"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-12-06T05:21:32",
    "profile_name": "P K",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNsazhfS0pBEAE",
    "review_text": "Paloma is the soul of this cafe. On the second day she knew by heart what we were drinking 🤩🫶🏼 The croissants are so delicious and crispy, The ham/cheese toast was also very tasty. We will definitely come back on the next trip.",
    "cumulative_rating": 4.444444444444445,
    "review_impact": 0.00236349016836801,
    "api_order": 134,
    "id": "24f94f65-fb0a-4c60-abad-473dcfc0faf1",
    "analysis": [
      {
        "review_id": "24f94f65-fb0a-4c60-abad-473dcfc0faf1",
        "comment": "The ham/cheese toast was also very tasty.",
        "subject_group": "toast",
        "category": "product",
        "attribute": "tastiness",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "2d712947-9559-4392-80ee-db61e161a175"
      },
      {
        "review_id": "24f94f65-fb0a-4c60-abad-473dcfc0faf1",
        "comment": "Paloma is the soul of this cafe.",
        "subject_group": "paloma",
        "category": "service",
        "attribute": "soul",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "3ee40c3e-7918-4eeb-8a82-c400b11d9302"
      },
      {
        "review_id": "24f94f65-fb0a-4c60-abad-473dcfc0faf1",
        "comment": "We will definitely come back on the next trip.",
        "subject_group": "we",
        "category": "experience",
        "attribute": "return",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "75e9f512-8000-4744-8e11-02eadccb191e"
      },
      {
        "review_id": "24f94f65-fb0a-4c60-abad-473dcfc0faf1",
        "comment": "The croissants are so delicious and crispy.",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "deliciousness",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "99640b57-1f3f-4fff-8328-099e51172f9e"
      },
      {
        "review_id": "24f94f65-fb0a-4c60-abad-473dcfc0faf1",
        "comment": "On the second day she knew by heart what we were drinking.",
        "subject_group": "she",
        "category": "service",
        "attribute": "knowledge",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "de794183-04fe-425d-8a6a-f5d264e013cc"
      },
      {
        "review_id": "24f94f65-fb0a-4c60-abad-473dcfc0faf1",
        "comment": "The croissants are so delicious and crispy.",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "crispiness",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "f042145f-8b7a-4957-8d1b-520d017b9a96"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-12-03T18:57:32",
    "profile_name": "W St",
    "rating": 4,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNsazZyMEJBEAE",
    "review_text": "Like everything in New York, everything is very expensive.",
    "cumulative_rating": 4.440298507462686,
    "review_impact": -0.0011330133281353127,
    "api_order": 133,
    "id": "44e0e0ce-476f-4811-a927-df0fa4390eaf",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-12-01T08:33:32",
    "profile_name": "Benedetto Dionisi",
    "rating": 4,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNsb19PUlVBEAE",
    "review_text": "Wide choice of both sweet and savory food. Prices are a little high for the Italian average but in line with those of New York. The cheesecakes are good. The staff was very kind and helpful to us even though the place was full of customers. The location is strategic if you are visiting Battery Park, the WTC and the stock exchange.",
    "cumulative_rating": 4.443609022556391,
    "review_impact": -0.0011330133281353127,
    "api_order": 132,
    "id": "373e69a6-acbe-4f4c-acf2-5c6a0f502838",
    "analysis": [
      {
        "review_id": "373e69a6-acbe-4f4c-acf2-5c6a0f502838",
        "comment": "Wide choice of both sweet and savory food",
        "subject_group": "food",
        "category": "product",
        "attribute": "choice",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "4cd0b5cc-53a2-4a59-a469-62352ccb0b1f"
      },
      {
        "review_id": "373e69a6-acbe-4f4c-acf2-5c6a0f502838",
        "comment": "Prices are a little high for the Italian average but in line with those of New York",
        "subject_group": "price",
        "category": "product",
        "attribute": "line",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "a10309a4-5162-42e0-9669-9db4904f64eb"
      },
      {
        "review_id": "373e69a6-acbe-4f4c-acf2-5c6a0f502838",
        "comment": "The cheesecakes are good",
        "subject_group": "cheesecake",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "e3e863cf-070a-46c2-86cd-04d949a783d6"
      },
      {
        "review_id": "373e69a6-acbe-4f4c-acf2-5c6a0f502838",
        "comment": "The staff was very kind and helpful to us even though the place was full of customers",
        "subject_group": "staff",
        "category": "service",
        "attribute": "kindness",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "2f42e22d-f88e-4314-9335-0db447a59579"
      },
      {
        "review_id": "373e69a6-acbe-4f4c-acf2-5c6a0f502838",
        "comment": "The staff was very kind and helpful to us even though the place was full of customers",
        "subject_group": "staff",
        "category": "service",
        "attribute": "helpfulness",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "3908c1c2-6e7d-4eb6-b5fd-6f2409b45560"
      },
      {
        "review_id": "373e69a6-acbe-4f4c-acf2-5c6a0f502838",
        "comment": "The location is strategic if you are visiting Battery Park, the WTC and the stock exchange",
        "subject_group": "location",
        "category": "experience",
        "attribute": "strategic",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "d03b53c3-f6ec-4d58-9b8e-9d5e34b60ae7"
      },
      {
        "review_id": "373e69a6-acbe-4f4c-acf2-5c6a0f502838",
        "comment": "Prices are a little high for the Italian average but in line with those of New York",
        "subject_group": "price",
        "category": "product",
        "attribute": "high",
        "sentiment": "negative",
        "attribute_impact": -0.0011330133281353127,
        "id": "c432bc5d-cc0e-48d7-840a-b493d5eb0632"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-11-28T22:09:32",
    "profile_name": "Mário Granja",
    "rating": 4,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUNsNWJDenNBRRAB",
    "review_text": null,
    "cumulative_rating": 4.446969696969697,
    "review_impact": -0.0011330133281353127,
    "api_order": 131,
    "id": "c192e123-86ff-4aaa-9f13-17a352f2f809",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-11-26T11:45:32",
    "profile_name": "Danielle Violante",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNsenFQcWN3EAE",
    "review_text": "Hands down best croissant in NYC (so surprising). It’s crispy/flakey on outside and great inside texture. Smoked salmon everything croissant sandwich is also insanely good.",
    "cumulative_rating": 4.450381679389313,
    "review_impact": 0.00236349016836801,
    "api_order": 130,
    "id": "26075497-4d08-49df-ba96-91af4b7715a1",
    "analysis": [
      {
        "review_id": "26075497-4d08-49df-ba96-91af4b7715a1",
        "comment": "It’s crispy/flakey on outside and great inside texture",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "crispiness",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "153d6543-7f35-4bd9-9d47-e90b523a53b4"
      },
      {
        "review_id": "26075497-4d08-49df-ba96-91af4b7715a1",
        "comment": "Smoked salmon everything croissant sandwich is also insanely good",
        "subject_group": "sandwich",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "58d44c17-7a3a-4c2d-bd98-71e40835583f"
      },
      {
        "review_id": "26075497-4d08-49df-ba96-91af4b7715a1",
        "comment": "It’s crispy/flakey on outside and great inside texture",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "texture",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "9939542d-7fbf-4278-9b3c-7757b044850a"
      },
      {
        "review_id": "26075497-4d08-49df-ba96-91af4b7715a1",
        "comment": "Hands down best croissant in NYC (so surprising)",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "b1edde7f-50f5-47c3-b906-fd1754c9920d"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-11-24T01:21:32",
    "profile_name": "Rosemari Martinez",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSURGbl9XUHV3RRAB",
    "review_text": "Delicious. Everything Delicious!",
    "cumulative_rating": 4.446153846153846,
    "review_impact": 0.00236349016836801,
    "api_order": 129,
    "id": "4f8b01d0-5ab1-435f-8c21-19103418cb80",
    "analysis": [
      {
        "review_id": "4f8b01d0-5ab1-435f-8c21-19103418cb80",
        "comment": "Everything Delicious!",
        "subject_group": "product",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "0ce5cc99-483b-484d-a948-3692182d8b08"
      },
      {
        "review_id": "4f8b01d0-5ab1-435f-8c21-19103418cb80",
        "comment": "Delicious.",
        "subject_group": "product",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "98048d56-c673-453a-9259-51e8081cd689"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-11-21T14:57:32",
    "profile_name": "Orna Is",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSURGX2ZueUN3EAE",
    "review_text": "Their almond croissant is life changing. It's become an addiction to get one for breakfast when I'm working downtown. Probably the best almond crossaint I've ever had.",
    "cumulative_rating": 4.441860465116279,
    "review_impact": 0.00236349016836801,
    "api_order": 128,
    "id": "4c8c36d3-2a70-4a4b-b180-a5cc2f3e2fd6",
    "analysis": [
      {
        "review_id": "4c8c36d3-2a70-4a4b-b180-a5cc2f3e2fd6",
        "comment": "It's become an addiction to get one for breakfast when I'm working downtown",
        "subject_group": "breakfast",
        "category": "experience",
        "attribute": "habit",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "4a37bb60-9d06-4c8a-9ec6-2eb2d588a35b"
      },
      {
        "review_id": "4c8c36d3-2a70-4a4b-b180-a5cc2f3e2fd6",
        "comment": "Probably the best almond croissant I've ever had",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "73390fa7-1b8e-443d-b742-49b4ff6996b3"
      },
      {
        "review_id": "4c8c36d3-2a70-4a4b-b180-a5cc2f3e2fd6",
        "comment": "Their almond croissant is life changing",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "dc628d83-30f6-4e67-976f-4084be886dac"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-11-19T04:33:32",
    "profile_name": "Ye Y",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSURGdnNIRDR3RRAB",
    "review_text": "Amazing croissants",
    "cumulative_rating": 4.4375,
    "review_impact": 0.00236349016836801,
    "api_order": 127,
    "id": "a36b5d03-f197-4d0e-8dac-6e0739302bb1",
    "analysis": [
      {
        "review_id": "a36b5d03-f197-4d0e-8dac-6e0739302bb1",
        "comment": "Amazing croissants",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00236349016836801,
        "id": "b86bbb85-f5d1-430f-9ff7-a43354b7f756"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-11-16T18:09:32",
    "profile_name": "Verdugote@gmail.com Goldo27",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSURGcG9uU0FnEAE",
    "review_text": null,
    "cumulative_rating": 4.433070866141732,
    "review_impact": 0.00236349016836801,
    "api_order": 126,
    "id": "1bbc5654-97cd-4afa-9233-62e59a200686",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-11-14T07:45:32",
    "profile_name": "Florentino Júnio",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSURGNkthSDdnRRAB",
    "review_text": "The best!",
    "cumulative_rating": 4.428571428571429,
    "review_impact": 0.00236349016836801,
    "api_order": 125,
    "id": "3cc6cc55-abbe-44c5-ae51-531621df6fa3",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-11-11T21:21:32",
    "profile_name": "Sam Grone",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUNGdjRmbjJBRRAB",
    "review_text": "Great baked goods, very fast service",
    "cumulative_rating": 4.424,
    "review_impact": 0.00236349016836801,
    "api_order": 124,
    "id": "5be0d95a-9f0e-493e-b900-f967f2bdf97e",
    "analysis": [
      {
        "review_id": "5be0d95a-9f0e-493e-b900-f967f2bdf97e",
        "comment": "Great baked goods",
        "subject_group": "good",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "3630dff2-1ca2-4baa-9051-ffbf8815bb55"
      },
      {
        "review_id": "5be0d95a-9f0e-493e-b900-f967f2bdf97e",
        "comment": "very fast service",
        "subject_group": "service",
        "category": "service",
        "attribute": "speed",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "52ba8034-ee04-426e-af11-10dfb9b218b3"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-11-09T10:57:32",
    "profile_name": "MEDT",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUNGNTg2eHJnRRAB",
    "review_text": "Very nice spot. Clean, friendly, and delicious food. I went for lunch as I work a block away. I had the tuna for the second time, tasted even more delicious this time but it's always delicious. Seen allot of tourists come here. You will pay Manhattan prices but definitely worth it.",
    "cumulative_rating": 4.419354838709677,
    "review_impact": 0.00236349016836801,
    "api_order": 123,
    "id": "bedcf511-f192-4aed-a639-d861520625cf",
    "analysis": [
      {
        "review_id": "bedcf511-f192-4aed-a639-d861520625cf",
        "comment": "I had the tuna for the second time, tasted even more delicious this time but it's always delicious",
        "subject_group": "tuna",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.00047269803367360196,
        "id": "13b3931e-9792-429c-be53-ee3b6d0d3e06"
      },
      {
        "review_id": "bedcf511-f192-4aed-a639-d861520625cf",
        "comment": "You will pay Manhattan prices but definitely worth it",
        "subject_group": "price",
        "category": "product",
        "attribute": "value",
        "sentiment": "positive",
        "attribute_impact": 0.00047269803367360196,
        "id": "50631cb9-4857-40bd-9eaa-2d53288fc80c"
      },
      {
        "review_id": "bedcf511-f192-4aed-a639-d861520625cf",
        "comment": "Clean, friendly, and delicious food",
        "subject_group": "food",
        "category": "product",
        "attribute": "cleanliness",
        "sentiment": "positive",
        "attribute_impact": 0.00047269803367360196,
        "id": "d45cecae-51b0-4714-9694-d9b14adc6ede"
      },
      {
        "review_id": "bedcf511-f192-4aed-a639-d861520625cf",
        "comment": "Clean, friendly, and delicious food",
        "subject_group": "food",
        "category": "product",
        "attribute": "friendliness",
        "sentiment": "positive",
        "attribute_impact": 0.00047269803367360196,
        "id": "eaf64691-3af2-4137-8cbf-246108814d8e"
      },
      {
        "review_id": "bedcf511-f192-4aed-a639-d861520625cf",
        "comment": "Clean, friendly, and delicious food",
        "subject_group": "food",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.00047269803367360196,
        "id": "ffbec3da-d46a-4663-ac24-dcbda425ea6b"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-11-07T00:33:32",
    "profile_name": "Anthony Lawrence",
    "rating": 4,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNGczY3QkFnEAE",
    "review_text": "Food was amazing, presentation of the shop was 5 star, well priced.",
    "cumulative_rating": 4.414634146341464,
    "review_impact": -0.0011330133281353127,
    "api_order": 122,
    "id": "559315c9-1cb5-4435-aa56-cee0156cb2b1",
    "analysis": [
      {
        "review_id": "559315c9-1cb5-4435-aa56-cee0156cb2b1",
        "comment": "Food was amazing",
        "subject_group": "food",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "fc0b0681-fdd4-4fac-ad50-28f32375f383"
      },
      {
        "review_id": "559315c9-1cb5-4435-aa56-cee0156cb2b1",
        "comment": "presentation of the shop was 5 star",
        "subject_group": "presentation",
        "category": "experience",
        "attribute": "rating",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "53c371f5-e9e5-4783-be48-26a1178153db"
      },
      {
        "review_id": "559315c9-1cb5-4435-aa56-cee0156cb2b1",
        "comment": "well priced",
        "subject_group": "price",
        "category": "product",
        "attribute": "value",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "7d152052-db41-4402-bb11-0be371b819eb"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-11-04T14:09:32",
    "profile_name": "Micha",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNGN2Y2M2JnEAE",
    "review_text": "Large selection, delicious food, you can have a really good breakfast",
    "cumulative_rating": 4.418032786885246,
    "review_impact": 0.00236349016836801,
    "api_order": 121,
    "id": "64cc2423-3d54-430d-9c0a-cc522331ba4e",
    "analysis": [
      {
        "review_id": "64cc2423-3d54-430d-9c0a-cc522331ba4e",
        "comment": "you can have a really good breakfast",
        "subject_group": "breakfast",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "4ba3256e-eaa5-4070-967d-631ccb617926"
      },
      {
        "review_id": "64cc2423-3d54-430d-9c0a-cc522331ba4e",
        "comment": "Large selection",
        "subject_group": "selection",
        "category": "product",
        "attribute": "variety",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "552dfd38-2e91-486c-9207-d9dd98b27822"
      },
      {
        "review_id": "64cc2423-3d54-430d-9c0a-cc522331ba4e",
        "comment": "delicious food",
        "subject_group": "food",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "d045cd22-d8c2-4f15-8bba-c697dee62f90"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-11-02T03:45:32",
    "profile_name": "Douglas Russell",
    "rating": 4,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUNGb2ZqaDZ3RRAB",
    "review_text": "Croissants were good for the US, but despite being asked what type of milk we wanted for our hot chocolate, it was made with hot water instead. Their prices are quite high which was somewhat warranted for the croissants, but for the hot chocolate it's inexcusable.",
    "cumulative_rating": 4.413223140495868,
    "review_impact": -0.0011330133281353127,
    "api_order": 120,
    "id": "661d3c20-6c32-4bbd-a058-a11dcda0c69b",
    "analysis": [
      {
        "review_id": "661d3c20-6c32-4bbd-a058-a11dcda0c69b",
        "comment": "Croissants were good for the US",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "47f628d4-9f0a-4fa7-b7e1-400d0b275f26"
      },
      {
        "review_id": "661d3c20-6c32-4bbd-a058-a11dcda0c69b",
        "comment": "which was somewhat warranted for the croissants",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "value",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "1996aae1-603c-432c-b595-e876cefed0af"
      },
      {
        "review_id": "661d3c20-6c32-4bbd-a058-a11dcda0c69b",
        "comment": "but for the hot chocolate it's inexcusable",
        "subject_group": "hot chocolate",
        "category": "product",
        "attribute": "value",
        "sentiment": "negative",
        "attribute_impact": -0.00037767110937843756,
        "id": "8beb73cb-0036-4fee-9c87-55008fea8c1f"
      },
      {
        "review_id": "661d3c20-6c32-4bbd-a058-a11dcda0c69b",
        "comment": "Their prices are quite high",
        "subject_group": "price",
        "category": "product",
        "attribute": "value",
        "sentiment": "negative",
        "attribute_impact": -0.00037767110937843756,
        "id": "da5117ed-f641-4b8b-a5c2-f611945da30a"
      },
      {
        "review_id": "661d3c20-6c32-4bbd-a058-a11dcda0c69b",
        "comment": "it was made with hot water instead",
        "subject_group": "hot chocolate",
        "category": "product",
        "attribute": "preparation",
        "sentiment": "negative",
        "attribute_impact": -0.00037767110937843756,
        "id": "fe9836bb-8bd7-40e2-9fa1-0b58449dc313"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-10-30T17:21:32",
    "profile_name": "Daniel Calzadilla",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUNGOUxQQjRBRRAB",
    "review_text": "*not pictured* Chocolate chip cookie, it was that good.",
    "cumulative_rating": 4.416666666666667,
    "review_impact": 0.00236349016836801,
    "api_order": 119,
    "id": "a6798170-2dfd-4c08-93e3-faeee40648db",
    "analysis": [
      {
        "review_id": "a6798170-2dfd-4c08-93e3-faeee40648db",
        "comment": "Chocolate chip cookie, it was that good.",
        "subject_group": "cookie",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.00236349016836801,
        "id": "bd3d6265-ce5e-4222-89a3-b3a9b6bc4428"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-10-28T06:57:32",
    "profile_name": "László Gálfi",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUQ1MFliRnpBRRAB",
    "review_text": null,
    "cumulative_rating": 4.411764705882353,
    "review_impact": 0.00236349016836801,
    "api_order": 118,
    "id": "d56d6804-cfd6-441c-a564-16a79e501519",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-10-25T20:33:32",
    "profile_name": "Torsten Winkler",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUQ1b2U3Q1FBEAE",
    "review_text": "Good baked goods, coffee tastes good.\nStaff friendly",
    "cumulative_rating": 4.406779661016949,
    "review_impact": 0.00236349016836801,
    "api_order": 117,
    "id": "933b4146-bf9b-4fba-b748-610bb3acbc9b",
    "analysis": [
      {
        "review_id": "933b4146-bf9b-4fba-b748-610bb3acbc9b",
        "comment": "coffee tastes good",
        "subject_group": "coffee",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "6bec8963-ae30-4dad-a47f-fc168c0b60d2"
      },
      {
        "review_id": "933b4146-bf9b-4fba-b748-610bb3acbc9b",
        "comment": "Staff friendly",
        "subject_group": "staff",
        "category": "service",
        "attribute": "friendliness",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "b6182440-e231-486c-a8e7-754a7beaa422"
      },
      {
        "review_id": "933b4146-bf9b-4fba-b748-610bb3acbc9b",
        "comment": "Good baked goods",
        "subject_group": "good",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "b9e22d4f-5860-4457-b1c7-4fff276fdfd0"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-10-23T10:09:32",
    "profile_name": "Crystal Braunbeck",
    "rating": 1,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUQ1aHZYNGhnRRAB",
    "review_text": "For the price of my bagel the quality does not match.  Better off going to Liberty bagels or Leo's.  They are overpriced and you don't get your money worth.  My comment isn't biased, my cinnamon raisin bagel tasted like onions.  I've been in the establishment once before and I wasn't impressed then either.  To be honest you all cost too damn much.",
    "cumulative_rating": 4.401709401709402,
    "review_impact": -0.011622523817646169,
    "api_order": 116,
    "id": "093c80fa-bf3d-4f45-a7f8-601485a06225",
    "analysis": [
      {
        "review_id": "093c80fa-bf3d-4f45-a7f8-601485a06225",
        "comment": "My cinnamon raisin bagel tasted like onions.",
        "subject_group": "bagel",
        "category": "product",
        "attribute": "taste",
        "sentiment": "negative",
        "attribute_impact": -0.001937087302941028,
        "id": "16cb7b62-678f-4345-bf3b-6319a6fb4e98"
      },
      {
        "review_id": "093c80fa-bf3d-4f45-a7f8-601485a06225",
        "comment": "For the price of my bagel the quality does not match.",
        "subject_group": "bagel",
        "category": "product",
        "attribute": "price",
        "sentiment": "negative",
        "attribute_impact": -0.001937087302941028,
        "id": "2a8442cf-e76b-46fb-95ac-d5b80f50df89"
      },
      {
        "review_id": "093c80fa-bf3d-4f45-a7f8-601485a06225",
        "comment": "I've been in the establishment once before and I wasn't impressed then either.",
        "subject_group": "establishment",
        "category": "experience",
        "attribute": "impression",
        "sentiment": "negative",
        "attribute_impact": -0.001937087302941028,
        "id": "6aea1ac9-3be6-4d6d-88f2-e10258ddbf8f"
      },
      {
        "review_id": "093c80fa-bf3d-4f45-a7f8-601485a06225",
        "comment": "To be honest you all cost too damn much.",
        "subject_group": "price",
        "category": "product",
        "attribute": "cost",
        "sentiment": "negative",
        "attribute_impact": -0.001937087302941028,
        "id": "b5e3ad8b-aa99-4132-a7e0-b533c203a83d"
      },
      {
        "review_id": "093c80fa-bf3d-4f45-a7f8-601485a06225",
        "comment": "They are overpriced and you don't get your money worth.",
        "subject_group": "price",
        "category": "product",
        "attribute": "value",
        "sentiment": "negative",
        "attribute_impact": -0.001937087302941028,
        "id": "c38ce6a9-65a5-48d0-bc5e-61328ed7c717"
      },
      {
        "review_id": "093c80fa-bf3d-4f45-a7f8-601485a06225",
        "comment": "For the price of my bagel the quality does not match.",
        "subject_group": "bagel",
        "category": "product",
        "attribute": "quality",
        "sentiment": "negative",
        "attribute_impact": -0.001937087302941028,
        "id": "f91b7005-a5d6-43bb-92a6-6af0313b9603"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-10-20T23:45:32",
    "profile_name": "Simone",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUQ1aXJQZUx3EAE",
    "review_text": "Cute little bakery that we had breakfast at during our NY visit. The croissants were beautifully laminated and there was a good variety of options.",
    "cumulative_rating": 4.431034482758621,
    "review_impact": 0.00236349016836801,
    "api_order": 115,
    "id": "a4d067e4-5fa0-4c6c-b8ff-c87a7b67b3d7",
    "analysis": [
      {
        "review_id": "a4d067e4-5fa0-4c6c-b8ff-c87a7b67b3d7",
        "comment": "The croissants were beautifully laminated",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "lamination",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "0bbf04e9-54ad-4630-95ee-23670ad9e418"
      },
      {
        "review_id": "a4d067e4-5fa0-4c6c-b8ff-c87a7b67b3d7",
        "comment": "there was a good variety of options",
        "subject_group": "variety",
        "category": "product",
        "attribute": "selection",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "0cfc2b6a-f609-41a8-9e58-6f6df9c79e6e"
      },
      {
        "review_id": "a4d067e4-5fa0-4c6c-b8ff-c87a7b67b3d7",
        "comment": "Cute little bakery that we had breakfast at during our NY visit",
        "subject_group": "bakery",
        "category": "experience",
        "attribute": "charm",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "ff1595c1-1f83-49b8-bacc-ebf3b66baa5c"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-10-18T13:21:32",
    "profile_name": "L MLA",
    "rating": 3,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUQ1c09TWDBRRRAB",
    "review_text": "The breakfast sandwiches and bagels are premade, so they just warmed them up for you. In my opinion, everything was overpriced.  For 3 coffees, 1 filled croissant I believed it was a raspberry one, 1 bagel with bacon, egg and cheese and 1 croissant with bacon, egg and cheese it was about $48! It was good but not that good for that price.",
    "cumulative_rating": 4.426086956521739,
    "review_impact": -0.004629516824638635,
    "api_order": 114,
    "id": "02134107-3948-42d6-8273-b8311bc1a9e5",
    "analysis": [
      {
        "review_id": "02134107-3948-42d6-8273-b8311bc1a9e5",
        "comment": "It was good but not that good for that price.",
        "subject_group": "food",
        "category": "experience",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "bb02e1b9-dbe6-4e8f-93b6-9d827515f930"
      },
      {
        "review_id": "02134107-3948-42d6-8273-b8311bc1a9e5",
        "comment": "In my opinion, everything was overpriced.",
        "subject_group": "price",
        "category": "experience",
        "attribute": "value",
        "sentiment": "negative",
        "attribute_impact": -0.0011573792061596588,
        "id": "50dc91d5-30ea-4c34-b0e4-daad9580e67e"
      },
      {
        "review_id": "02134107-3948-42d6-8273-b8311bc1a9e5",
        "comment": "The breakfast sandwiches and bagels are premade, so they just warmed them up for you.",
        "subject_group": "sandwich",
        "category": "product",
        "attribute": "preparation",
        "sentiment": "negative",
        "attribute_impact": -0.0011573792061596588,
        "id": "588cfd7f-6065-4a92-8521-1496611af234"
      },
      {
        "review_id": "02134107-3948-42d6-8273-b8311bc1a9e5",
        "comment": "The breakfast sandwiches and bagels are premade, so they just warmed them up for you.",
        "subject_group": "bagel",
        "category": "product",
        "attribute": "preparation",
        "sentiment": "negative",
        "attribute_impact": -0.0011573792061596588,
        "id": "6ace96c0-7226-4b52-af0d-54c920d3aef7"
      },
      {
        "review_id": "02134107-3948-42d6-8273-b8311bc1a9e5",
        "comment": "It was good but not that good for that price.",
        "subject_group": "food",
        "category": "experience",
        "attribute": "value",
        "sentiment": "negative",
        "attribute_impact": -0.0011573792061596588,
        "id": "b6cad5ff-7c55-4d54-bd36-3adb7b63a7e4"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-10-16T02:57:32",
    "profile_name": "Jada Cox",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUM1eDgtMjh3RRAB",
    "review_text": "Really nice bakery in downtown Manhattan located right next to The World Trade Center. Customer service was great/friendly and quick. Matcha latte was delicious and refreshing and the Pumpkin Spice Crescent was tasty. My husband ordered a pastry that I can’t recall the name of but it was similar to a jelly filled donut with crunchy icing glazed over the top. He enjoyed it!",
    "cumulative_rating": 4.43859649122807,
    "review_impact": 0.00236349016836801,
    "api_order": 113,
    "id": "af457184-43ce-4ea0-a1e1-ad4d4694a0a0",
    "analysis": [
      {
        "review_id": "af457184-43ce-4ea0-a1e1-ad4d4694a0a0",
        "comment": "Matcha latte was delicious and refreshing.",
        "subject_group": "latte",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.00047269803367360196,
        "id": "1da73ff5-c102-4524-bf10-3db2b99f5cbe"
      },
      {
        "review_id": "af457184-43ce-4ea0-a1e1-ad4d4694a0a0",
        "comment": "Customer service was great/friendly and quick.",
        "subject_group": "service",
        "category": "service",
        "attribute": "friendliness",
        "sentiment": "positive",
        "attribute_impact": 0.00047269803367360196,
        "id": "77bd2927-58d7-4d22-a378-e9cd226adc98"
      },
      {
        "review_id": "af457184-43ce-4ea0-a1e1-ad4d4694a0a0",
        "comment": "Pumpkin Spice Crescent was tasty.",
        "subject_group": "crescent",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.00047269803367360196,
        "id": "b4e2b537-5acc-4899-9c3c-d9836c47d1e3"
      },
      {
        "review_id": "af457184-43ce-4ea0-a1e1-ad4d4694a0a0",
        "comment": "Customer service was great/friendly and quick.",
        "subject_group": "service",
        "category": "service",
        "attribute": "speed",
        "sentiment": "positive",
        "attribute_impact": 0.00047269803367360196,
        "id": "d61ba621-b13b-4bcb-bd79-0e6a4d1d720c"
      },
      {
        "review_id": "af457184-43ce-4ea0-a1e1-ad4d4694a0a0",
        "comment": "Matcha latte was delicious and refreshing.",
        "subject_group": "latte",
        "category": "product",
        "attribute": "refreshment",
        "sentiment": "positive",
        "attribute_impact": 0.00047269803367360196,
        "id": "e3a0430e-2c28-4c34-91ce-073da1668c13"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-10-13T16:33:32",
    "profile_name": "Paul Daniel",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUM1N2RXanlBRRAB",
    "review_text": "Fantastic food and drinks! Just wish they had decaf espresso.",
    "cumulative_rating": 4.433628318584071,
    "review_impact": 0.00236349016836801,
    "api_order": 112,
    "id": "bca141b7-f111-4e09-985c-0975e5fffbc1",
    "analysis": [
      {
        "review_id": "bca141b7-f111-4e09-985c-0975e5fffbc1",
        "comment": "Just wish they had decaf espresso.",
        "subject_group": "espresso",
        "category": "product",
        "attribute": "availability",
        "sentiment": "negative",
        "attribute_impact": 0.0,
        "id": "51eca0de-99f8-47c2-bed5-2c804ba182cf"
      },
      {
        "review_id": "bca141b7-f111-4e09-985c-0975e5fffbc1",
        "comment": "Fantastic food and drinks!",
        "subject_group": "drink",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "142d700c-df11-446c-bc74-d029d871b54b"
      },
      {
        "review_id": "bca141b7-f111-4e09-985c-0975e5fffbc1",
        "comment": "Fantastic food and drinks!",
        "subject_group": "food",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "960d180a-1812-42ca-a84f-69cd890a9ec4"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-10-11T06:09:32",
    "profile_name": "Siddhi Vinay",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUM1a2NTemd3RRAB",
    "review_text": "I got an everything bagel donut. scrumptious.",
    "cumulative_rating": 4.428571428571429,
    "review_impact": 0.00236349016836801,
    "api_order": 111,
    "id": "25eb9964-02a2-43a6-99a4-a9834edddce3",
    "analysis": [
      {
        "review_id": "25eb9964-02a2-43a6-99a4-a9834edddce3",
        "comment": "scrumptious.",
        "subject_group": "taste",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "ead1f30a-20d8-42f2-9ede-83dfd4f63cd8"
      },
      {
        "review_id": "25eb9964-02a2-43a6-99a4-a9834edddce3",
        "comment": "I got an everything bagel donut.",
        "subject_group": "donut",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "fc660482-ba41-40b2-bce7-4762aa4edd50"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-10-08T19:45:32",
    "profile_name": "Raul Roman",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUM1a2JpcnVRRRAB",
    "review_text": "The pastries are huge. Assorted hot teas and coffees available. Unlike the DD across the street, they have a restroom which is hard to find in some locations.",
    "cumulative_rating": 4.423423423423423,
    "review_impact": 0.00236349016836801,
    "api_order": 110,
    "id": "f23d1ebb-b64d-4e6c-8890-e66d39e17065",
    "analysis": [
      {
        "review_id": "f23d1ebb-b64d-4e6c-8890-e66d39e17065",
        "comment": "The pastries are huge.",
        "subject_group": "pastry",
        "category": "product",
        "attribute": "size",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "026570d8-3cc5-4feb-adde-f362ac42968a"
      },
      {
        "review_id": "f23d1ebb-b64d-4e6c-8890-e66d39e17065",
        "comment": "they have a restroom which is hard to find in some locations.",
        "subject_group": "restroom",
        "category": "experience",
        "attribute": "availability",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "082a2a53-66e0-441e-988c-a0f578163c56"
      },
      {
        "review_id": "f23d1ebb-b64d-4e6c-8890-e66d39e17065",
        "comment": "Assorted hot teas and coffees available.",
        "subject_group": "tea",
        "category": "product",
        "attribute": "variety",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "53b1e3c0-5ef3-4235-8be8-7c9fa0bb7b94"
      },
      {
        "review_id": "f23d1ebb-b64d-4e6c-8890-e66d39e17065",
        "comment": "Assorted hot teas and coffees available.",
        "subject_group": "coffee",
        "category": "product",
        "attribute": "variety",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "b6bf5677-7346-4c7f-ac39-c5743bac1cd7"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-10-06T09:21:32",
    "profile_name": "George Avakian",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUM1bnZ1MXFBRRAB",
    "review_text": "Great place to get breakfast on the go, great coffee and fresh food with delicious desserts.",
    "cumulative_rating": 4.418181818181818,
    "review_impact": 0.00236349016836801,
    "api_order": 109,
    "id": "355be6a5-2b48-47c5-bc2b-d9f02bda6c81",
    "analysis": [
      {
        "review_id": "355be6a5-2b48-47c5-bc2b-d9f02bda6c81",
        "comment": "delicious desserts",
        "subject_group": "dessert",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "01eff5df-9a92-4292-b080-b7c71e79abe4"
      },
      {
        "review_id": "355be6a5-2b48-47c5-bc2b-d9f02bda6c81",
        "comment": "fresh food",
        "subject_group": "food",
        "category": "product",
        "attribute": "freshness",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "992c6549-bcc2-466a-be2e-9bee521859cc"
      },
      {
        "review_id": "355be6a5-2b48-47c5-bc2b-d9f02bda6c81",
        "comment": "great coffee",
        "subject_group": "coffee",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "b246ff59-a188-454e-a230-b5dbb8aabec1"
      },
      {
        "review_id": "355be6a5-2b48-47c5-bc2b-d9f02bda6c81",
        "comment": "Great place to get breakfast on the go",
        "subject_group": "breakfast",
        "category": "product",
        "attribute": "convenience",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "bd48a88f-eb70-4fbc-a1d0-004e79587799"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-10-03T22:57:32",
    "profile_name": "Marino Geldhof",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSURaMF9mY0pREAE",
    "review_text": "Super tasty filled croissants.\nDelicious coffee.",
    "cumulative_rating": 4.412844036697248,
    "review_impact": 0.00236349016836801,
    "api_order": 108,
    "id": "102789c7-1a14-4538-9761-6a22945d50d5",
    "analysis": [
      {
        "review_id": "102789c7-1a14-4538-9761-6a22945d50d5",
        "comment": "Super tasty filled croissants.",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "filling",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "6cb7c057-f06e-4009-95ca-7f7a500c63c1"
      },
      {
        "review_id": "102789c7-1a14-4538-9761-6a22945d50d5",
        "comment": "Delicious coffee.",
        "subject_group": "coffee",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "98bc1e79-18e4-4902-bd59-4c7f620ac506"
      },
      {
        "review_id": "102789c7-1a14-4538-9761-6a22945d50d5",
        "comment": "Super tasty filled croissants.",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "f8495a16-dae1-4197-9751-ebda3562629d"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-10-01T12:33:32",
    "profile_name": "Lukasz Grabowski",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSURaN0liNGdBRRAB",
    "review_text": null,
    "cumulative_rating": 4.407407407407407,
    "review_impact": 0.00236349016836801,
    "api_order": 107,
    "id": "824f405b-aae7-45c5-97bd-dea1fbe0cf91",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-09-29T02:09:32",
    "profile_name": "noa roman",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSURaOUxLa19RRRAB",
    "review_text": null,
    "cumulative_rating": 4.401869158878505,
    "review_impact": 0.00236349016836801,
    "api_order": 106,
    "id": "4a05277d-4bff-4d3d-84a8-1fb2ecdac10c",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-09-26T15:45:32",
    "profile_name": "Adekemi Adeniyan",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSURabEtDcTJBRRAB",
    "review_text": null,
    "cumulative_rating": 4.39622641509434,
    "review_impact": 0.00236349016836801,
    "api_order": 105,
    "id": "0e37f80b-d5f2-4299-98e3-a372cbfbce28",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-09-24T05:21:32",
    "profile_name": "Sonya Xioxi",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSURacU4yVjV3RRAB",
    "review_text": null,
    "cumulative_rating": 4.390476190476191,
    "review_impact": 0.00236349016836801,
    "api_order": 104,
    "id": "ee246094-a79f-41b1-bbb1-30463552bed8",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-09-21T18:57:32",
    "profile_name": "Susan Snyder",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNadzd1elBnEAE",
    "review_text": null,
    "cumulative_rating": 4.384615384615385,
    "review_impact": 0.00236349016836801,
    "api_order": 103,
    "id": "2586bc2d-fe80-493b-8443-c587b4ade8ab",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-09-19T08:33:32",
    "profile_name": "Platypus 3.14",
    "rating": 4,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUNaeXI3UHJnRRAB",
    "review_text": "Good pastries but everything is a bit pricey.",
    "cumulative_rating": 4.378640776699029,
    "review_impact": -0.0011330133281353127,
    "api_order": 102,
    "id": "d24be26d-48fc-43cd-b7c7-64164e8a7c12",
    "analysis": [
      {
        "review_id": "d24be26d-48fc-43cd-b7c7-64164e8a7c12",
        "comment": "Good pastries",
        "subject_group": "pastry",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "c5d91b8a-ee22-4083-b1a9-69b553ef185b"
      },
      {
        "review_id": "d24be26d-48fc-43cd-b7c7-64164e8a7c12",
        "comment": "everything is a bit pricey",
        "subject_group": "price",
        "category": "product",
        "attribute": "cost",
        "sentiment": "negative",
        "attribute_impact": -0.0011330133281353127,
        "id": "5922f222-8c4c-49eb-8372-fc933b78cf0d"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-09-16T22:09:32",
    "profile_name": "Kamie Sullivan",
    "rating": 4,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUNac3B2T2pnRRAB",
    "review_text": "Pastries are absolutely amazing and deserve a 5/5 for that but the other food doesn’t look as appetizing",
    "cumulative_rating": 4.382352941176471,
    "review_impact": -0.0011330133281353127,
    "api_order": 101,
    "id": "666130e8-9a50-47ff-911d-7acca7dd7fed",
    "analysis": [
      {
        "review_id": "666130e8-9a50-47ff-911d-7acca7dd7fed",
        "comment": "Pastries are absolutely amazing",
        "subject_group": "pastry",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "b01eb910-5c17-44f2-8bca-8170f2727ea0"
      },
      {
        "review_id": "666130e8-9a50-47ff-911d-7acca7dd7fed",
        "comment": "the other food doesn’t look as appetizing",
        "subject_group": "food",
        "category": "product",
        "attribute": "appearance",
        "sentiment": "negative",
        "attribute_impact": -0.0011330133281353127,
        "id": "04b9fdaf-73cd-48e0-9876-43b0f872426c"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-09-14T11:45:32",
    "profile_name": "Googler 123",
    "rating": 4,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNaN05PS0RREAE",
    "review_text": null,
    "cumulative_rating": 4.3861386138613865,
    "review_impact": -0.0011330133281353127,
    "api_order": 100,
    "id": "25b9207b-93de-417d-80b6-e66fa7896097",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-09-12T01:21:32",
    "profile_name": "Thaís Silva-Marques",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUNaNUtiQV9nRRAB",
    "review_text": "I feel like this place is definitely underrated. The “pinwheel” croissants are amazing, as is the ham and cheese croissants. They are so worth the stop.",
    "cumulative_rating": 4.39,
    "review_impact": 0.00236349016836801,
    "api_order": 99,
    "id": "f5842af8-c556-4820-a469-e67056914ab7",
    "analysis": [
      {
        "review_id": "f5842af8-c556-4820-a469-e67056914ab7",
        "comment": "The “pinwheel” croissants are amazing",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "235dbac8-a93b-4ea8-a2bd-f1bb768708e9"
      },
      {
        "review_id": "f5842af8-c556-4820-a469-e67056914ab7",
        "comment": "They are so worth the stop",
        "subject_group": "experience",
        "category": "experience",
        "attribute": "value",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "269641ad-0367-4622-ac70-cf8dd4d93e51"
      },
      {
        "review_id": "f5842af8-c556-4820-a469-e67056914ab7",
        "comment": "The ham and cheese croissants are amazing",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "d2d24b5e-2d07-4de0-baf8-4f5e9001f82a"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-09-09T14:57:32",
    "profile_name": "Karri Lybeck",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNaLU9pck1REAE",
    "review_text": "NY croissant rolls are pure bliss! I always take the raspberry one.",
    "cumulative_rating": 4.383838383838384,
    "review_impact": 0.00236349016836801,
    "api_order": 98,
    "id": "ba0ef6ed-902d-49fe-a4cb-e169c671f8d1",
    "analysis": [
      {
        "review_id": "ba0ef6ed-902d-49fe-a4cb-e169c671f8d1",
        "comment": "I always take the raspberry one.",
        "subject_group": "raspberry",
        "category": "product",
        "attribute": "preference",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "730aeef3-84a8-4573-adce-641bf5893462"
      },
      {
        "review_id": "ba0ef6ed-902d-49fe-a4cb-e169c671f8d1",
        "comment": "NY croissant rolls are pure bliss!",
        "subject_group": "croissant roll",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "f7d05d8e-cf45-46fa-aed3-474f6034ce5a"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-09-07T04:33:32",
    "profile_name": "Alan oneill",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSURwODR6NU53EAE",
    "review_text": "Cracking place, and lovely to hear pleasantries from the staff.",
    "cumulative_rating": 4.377551020408164,
    "review_impact": 0.00236349016836801,
    "api_order": 97,
    "id": "40abd565-0330-4ae8-86a2-3d54c9b58381",
    "analysis": [
      {
        "review_id": "40abd565-0330-4ae8-86a2-3d54c9b58381",
        "comment": "lovely to hear pleasantries from the staff",
        "subject_group": "staff",
        "category": "service",
        "attribute": "communication",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "2b1b0acd-c420-4354-954d-783c9520c81a"
      },
      {
        "review_id": "40abd565-0330-4ae8-86a2-3d54c9b58381",
        "comment": "Cracking place",
        "subject_group": "place",
        "category": "experience",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "f3e568bb-0386-400f-8984-4821cf510ffc"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-09-04T18:09:32",
    "profile_name": "Fatima Acosta",
    "rating": 4,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSURwa1p1cUhnEAE",
    "review_text": "The croissants were very delicious, crunchy and the Chai latte that I ordered was very delicious. The staff was very friendly and the place was very clean except for the bathroom, which was a little dirty for me. The location is that very pretty little corner that you can see, I can imagine an afternoon snowing in that place :). I found the prices very affordable. It is very close to the 9/11 Memorial and a few blocks from Battery Park.",
    "cumulative_rating": 4.371134020618556,
    "review_impact": -0.0011330133281353127,
    "api_order": 96,
    "id": "4c40b749-4441-496e-b764-7a256b846db4",
    "analysis": [
      {
        "review_id": "4c40b749-4441-496e-b764-7a256b846db4",
        "comment": "The croissants were very delicious",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "deliciousness",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "553e5e86-c0b0-41f2-802d-40b0a667ad47"
      },
      {
        "review_id": "4c40b749-4441-496e-b764-7a256b846db4",
        "comment": "the Chai latte that I ordered was very delicious",
        "subject_group": "chai latte",
        "category": "product",
        "attribute": "deliciousness",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "a6d9ffd7-371a-43a6-956c-caf1bf1155b0"
      },
      {
        "review_id": "4c40b749-4441-496e-b764-7a256b846db4",
        "comment": "The staff was very friendly",
        "subject_group": "staff",
        "category": "service",
        "attribute": "friendliness",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "a39451dd-95be-4a82-9db2-45e5f276ef03"
      },
      {
        "review_id": "4c40b749-4441-496e-b764-7a256b846db4",
        "comment": "the place was very clean except for the bathroom, which was a little dirty for me",
        "subject_group": "place",
        "category": "experience",
        "attribute": "cleanliness",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "10cbabe4-e445-43d4-876e-3cab5baf9b1d"
      },
      {
        "review_id": "4c40b749-4441-496e-b764-7a256b846db4",
        "comment": "I found the prices very affordable",
        "subject_group": "price",
        "category": "product",
        "attribute": "affordability",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "84a77e3a-fee7-43c5-ac3d-46cb8ccb4883"
      },
      {
        "review_id": "4c40b749-4441-496e-b764-7a256b846db4",
        "comment": "The location is that very pretty little corner",
        "subject_group": "location",
        "category": "experience",
        "attribute": "aesthetic",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "ee732eaf-ab84-40ee-978d-6c73d473adcc"
      },
      {
        "review_id": "4c40b749-4441-496e-b764-7a256b846db4",
        "comment": "the place was very clean except for the bathroom, which was a little dirty for me",
        "subject_group": "bathroom",
        "category": "experience",
        "attribute": "cleanliness",
        "sentiment": "negative",
        "attribute_impact": -0.0011330133281353127,
        "id": "d985acae-6e3e-4480-b486-b6513a4fed79"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-09-02T07:45:32",
    "profile_name": "Togl Blo",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSURwa3FtZzN3RRAB",
    "review_text": "Great cafe/bakery.\nGood coffee, delicious croissants and cakes and at very reasonable prices compared to other cafes.",
    "cumulative_rating": 4.375,
    "review_impact": 0.00236349016836801,
    "api_order": 95,
    "id": "61da0207-db9c-466b-afa8-d8e72402891f",
    "analysis": [
      {
        "review_id": "61da0207-db9c-466b-afa8-d8e72402891f",
        "comment": "Good coffee, delicious croissants and cakes and at very reasonable prices compared to other cafes.",
        "subject_group": "price",
        "category": "product",
        "attribute": "value",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "0677a186-7d0d-4e37-a8c7-21f512eef5a3"
      },
      {
        "review_id": "61da0207-db9c-466b-afa8-d8e72402891f",
        "comment": "Good coffee, delicious croissants and cakes and at very reasonable prices compared to other cafes.",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "7da1bf25-d434-41cc-be3e-61191d6c2a48"
      },
      {
        "review_id": "61da0207-db9c-466b-afa8-d8e72402891f",
        "comment": "Good coffee, delicious croissants and cakes and at very reasonable prices compared to other cafes.",
        "subject_group": "coffee",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "a3776d81-4ff6-40fe-903e-02b5e9c13a29"
      },
      {
        "review_id": "61da0207-db9c-466b-afa8-d8e72402891f",
        "comment": "Good coffee, delicious croissants and cakes and at very reasonable prices compared to other cafes.",
        "subject_group": "cake",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "f46ae6b9-7110-48a8-8965-5c07eba67153"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-08-30T21:21:32",
    "profile_name": "Ravenone",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSURwbUpiWXhRRRAB",
    "review_text": "We thought it was great. Something for everyone. We'd love to come back!",
    "cumulative_rating": 4.368421052631579,
    "review_impact": 0.00236349016836801,
    "api_order": 94,
    "id": "fe18b116-255a-47f3-a599-a6abe8e44c5c",
    "analysis": [
      {
        "review_id": "fe18b116-255a-47f3-a599-a6abe8e44c5c",
        "comment": "We thought it was great",
        "subject_group": "experience",
        "category": "experience",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "193ca598-2296-4b31-96ec-a3d24b0b63c5"
      },
      {
        "review_id": "fe18b116-255a-47f3-a599-a6abe8e44c5c",
        "comment": "We'd love to come back",
        "subject_group": "experience",
        "category": "experience",
        "attribute": "desire",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "c1ec2a0f-6c64-4c30-965a-da46ef43085c"
      },
      {
        "review_id": "fe18b116-255a-47f3-a599-a6abe8e44c5c",
        "comment": "Something for everyone",
        "subject_group": "product",
        "category": "product",
        "attribute": "variety",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "cf59b936-768d-48c6-b04c-467057cdd9e5"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-08-28T10:57:32",
    "profile_name": "Atishay Jand",
    "rating": 4,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNwOThfakpBEAE",
    "review_text": "Good vibes and decent food",
    "cumulative_rating": 4.361702127659575,
    "review_impact": -0.0011330133281353127,
    "api_order": 93,
    "id": "c058de7f-e669-4147-8b5e-6b9771bf2cde",
    "analysis": [
      {
        "review_id": "c058de7f-e669-4147-8b5e-6b9771bf2cde",
        "comment": "Good vibes",
        "subject_group": "vibe",
        "category": "experience",
        "attribute": "positivity",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "efac235c-6217-40f6-a707-c4b6a79c50ca"
      },
      {
        "review_id": "c058de7f-e669-4147-8b5e-6b9771bf2cde",
        "comment": "decent food",
        "subject_group": "food",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "7100612f-002b-494c-b0d5-7559344e5e55"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-08-26T00:33:32",
    "profile_name": "Taylor Stapleton",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNwOTZ5Z0h3EAE",
    "review_text": "The \"Everything Cream Cheese Brioche Doughnut\" is both fun and delicious. I was expecting it to be a gimmick, but it's actually just good.",
    "cumulative_rating": 4.365591397849462,
    "review_impact": 0.00236349016836801,
    "api_order": 92,
    "id": "0bb93ce6-87f7-4b21-85ff-8fafaa8afde7",
    "analysis": [
      {
        "review_id": "0bb93ce6-87f7-4b21-85ff-8fafaa8afde7",
        "comment": "I was expecting it to be a gimmick, but it's actually just good.",
        "subject_group": "expectation",
        "category": "experience",
        "attribute": "gimmick",
        "sentiment": "negative",
        "attribute_impact": 0.0,
        "id": "428c362a-c52d-4be4-b4f9-554961e6482e"
      },
      {
        "review_id": "0bb93ce6-87f7-4b21-85ff-8fafaa8afde7",
        "comment": "The 'Everything Cream Cheese Brioche Doughnut' is both fun and delicious.",
        "subject_group": "doughnut",
        "category": "product",
        "attribute": "deliciousness",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "4b1073ac-e136-4e20-89bc-1f152a7fb676"
      },
      {
        "review_id": "0bb93ce6-87f7-4b21-85ff-8fafaa8afde7",
        "comment": "The 'Everything Cream Cheese Brioche Doughnut' is both fun and delicious.",
        "subject_group": "doughnut",
        "category": "product",
        "attribute": "fun",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "7cbe0d1a-af52-4ca4-bee8-b1d164ec6eb0"
      },
      {
        "review_id": "0bb93ce6-87f7-4b21-85ff-8fafaa8afde7",
        "comment": "I was expecting it to be a gimmick, but it's actually just good.",
        "subject_group": "expectation",
        "category": "experience",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "a697daeb-4dff-4bc8-a15d-c46a2c8b30d7"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-08-23T14:09:32",
    "profile_name": "Jackie Lee",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUNwczhHRjJnRRAB",
    "review_text": "The service here is excellent and most importantly so is the food. We've now been 4 times and we've not been disappointed at all. Their almond croissants are delicious as are the individual cheesecakes. We also had a delicious aubergine and mozzarella sandwich here. As vegetarians it's so nice to find an unusual filling.\n\nCoffe is good too.",
    "cumulative_rating": 4.358695652173913,
    "review_impact": 0.00236349016836801,
    "api_order": 91,
    "id": "79fb1bab-3b61-42c7-8486-2423278be3d5",
    "analysis": [
      {
        "review_id": "79fb1bab-3b61-42c7-8486-2423278be3d5",
        "comment": "as are the individual cheesecakes",
        "subject_group": "cheesecake",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.0003376414526240014,
        "id": "1137aa15-a826-4729-bc26-9862f05fee6b"
      },
      {
        "review_id": "79fb1bab-3b61-42c7-8486-2423278be3d5",
        "comment": "Coffe is good too",
        "subject_group": "coffee",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0003376414526240014,
        "id": "15ca7080-425e-4b09-bce6-3b269dcaca18"
      },
      {
        "review_id": "79fb1bab-3b61-42c7-8486-2423278be3d5",
        "comment": "it's so nice to find an unusual filling",
        "subject_group": "filling",
        "category": "product",
        "attribute": "uniqueness",
        "sentiment": "positive",
        "attribute_impact": 0.0003376414526240014,
        "id": "6e72dafc-186e-4b68-abeb-6416ebc5a319"
      },
      {
        "review_id": "79fb1bab-3b61-42c7-8486-2423278be3d5",
        "comment": "We also had a delicious aubergine and mozzarella sandwich here",
        "subject_group": "sandwich",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.0003376414526240014,
        "id": "c7327e39-1368-4272-9305-383a7dae392f"
      },
      {
        "review_id": "79fb1bab-3b61-42c7-8486-2423278be3d5",
        "comment": "Their almond croissants are delicious",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.0003376414526240014,
        "id": "cf671e14-8ad2-4d73-aa0d-74f9b86affe8"
      },
      {
        "review_id": "79fb1bab-3b61-42c7-8486-2423278be3d5",
        "comment": "most importantly so is the food",
        "subject_group": "food",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0003376414526240014,
        "id": "d7aedfb3-0922-4d01-bf7e-1cc905c0cc0d"
      },
      {
        "review_id": "79fb1bab-3b61-42c7-8486-2423278be3d5",
        "comment": "The service here is excellent",
        "subject_group": "service",
        "category": "service",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0003376414526240014,
        "id": "ed801475-4d61-4d6a-b34f-4ddbe3482919"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-08-21T03:45:32",
    "profile_name": "Maria Mondora",
    "rating": 4,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNwb191aFlREAE",
    "review_text": "Good quality but excessive prices for us Italians, still in line with the New York average. Cappuccino and croissant about $10",
    "cumulative_rating": 4.351648351648351,
    "review_impact": -0.0011330133281353127,
    "api_order": 90,
    "id": "2f676c7f-7b8c-49c8-89a9-3727d7cef42a",
    "analysis": [
      {
        "review_id": "2f676c7f-7b8c-49c8-89a9-3727d7cef42a",
        "comment": "Good quality but excessive prices for us Italians",
        "subject_group": "quality",
        "category": "product",
        "attribute": "goodness",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "05e80268-a944-4899-bf83-ee61ae7711ba"
      },
      {
        "review_id": "2f676c7f-7b8c-49c8-89a9-3727d7cef42a",
        "comment": "still in line with the New York average",
        "subject_group": "price",
        "category": "product",
        "attribute": "averageness",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "ba8e2c35-17dd-4f5e-89a9-4b880c6a6669"
      },
      {
        "review_id": "2f676c7f-7b8c-49c8-89a9-3727d7cef42a",
        "comment": "Cappuccino and croissant about $10",
        "subject_group": "price",
        "category": "product",
        "attribute": "amount",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "d8e8466e-d1ec-4603-a52f-4d1f7f491221"
      },
      {
        "review_id": "2f676c7f-7b8c-49c8-89a9-3727d7cef42a",
        "comment": "Good quality but excessive prices for us Italians",
        "subject_group": "price",
        "category": "product",
        "attribute": "excessiveness",
        "sentiment": "negative",
        "attribute_impact": -0.0011330133281353127,
        "id": "8ab303dc-8868-4e11-a289-d35d1db4abab"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-08-18T17:21:32",
    "profile_name": "ilse van den bosch",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNwbmZiZlp3EAE",
    "review_text": "Super tasty",
    "cumulative_rating": 4.355555555555555,
    "review_impact": 0.00236349016836801,
    "api_order": 89,
    "id": "ca0e1b19-a2c2-410b-9cb3-a60ade1511e0",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-08-16T06:57:32",
    "profile_name": "Klaas Pieter Roemeling",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNwbmRiU0RBEAE",
    "review_text": "Had lunch here, delicious eggplant sandwich and good coffee. Great service and finally a restaurant where the air conditioning is not freezing",
    "cumulative_rating": 4.348314606741573,
    "review_impact": 0.00236349016836801,
    "api_order": 88,
    "id": "8fd25a65-cd12-45fd-8612-c1c008c96223",
    "analysis": [
      {
        "review_id": "8fd25a65-cd12-45fd-8612-c1c008c96223",
        "comment": "delicious eggplant sandwich",
        "subject_group": "sandwich",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "0e9996a8-a7ff-4c62-b01a-7dfe4c7c876a"
      },
      {
        "review_id": "8fd25a65-cd12-45fd-8612-c1c008c96223",
        "comment": "Great service",
        "subject_group": "service",
        "category": "service",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "12076c77-267c-4841-bcfe-b2e2ea870125"
      },
      {
        "review_id": "8fd25a65-cd12-45fd-8612-c1c008c96223",
        "comment": "finally a restaurant where the air conditioning is not freezing",
        "subject_group": "air conditioning",
        "category": "experience",
        "attribute": "comfort",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "385117bd-8ebc-42e6-b6e4-9b92cfccf6cc"
      },
      {
        "review_id": "8fd25a65-cd12-45fd-8612-c1c008c96223",
        "comment": "good coffee",
        "subject_group": "coffee",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "7363126d-7161-4b5c-8dbc-4fc217c0f9a1"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-08-13T20:33:32",
    "profile_name": "QuiAyejia Cooper",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNwbFpYMFVnEAE",
    "review_text": "I just returned from France a month ago… This is the closest thing I can imagine. Don’t skip this hidden gem in the Finance district!",
    "cumulative_rating": 4.340909090909091,
    "review_impact": 0.00236349016836801,
    "api_order": 87,
    "id": "159f0660-b4ac-4b78-bc9c-edbcc1c5f60c",
    "analysis": [
      {
        "review_id": "159f0660-b4ac-4b78-bc9c-edbcc1c5f60c",
        "comment": "This is the closest thing I can imagine",
        "subject_group": "thing",
        "category": "experience",
        "attribute": "closeness",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "9184c03f-38ee-48bf-afd3-c6dc82fff357"
      },
      {
        "review_id": "159f0660-b4ac-4b78-bc9c-edbcc1c5f60c",
        "comment": "Don’t skip this hidden gem in the Finance district",
        "subject_group": "gem",
        "category": "experience",
        "attribute": "hidden",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "d7effb26-09f8-42e1-82c0-014ff04a8ea6"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-08-11T10:09:32",
    "profile_name": "Mario Lopez",
    "rating": 2,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUNwOGNPWTR3RRAB",
    "review_text": "I came for the Nutella croissant (supreme) and I was disappointed because they’re not using real Nutella. Pastry was Ok though!",
    "cumulative_rating": 4.333333333333333,
    "review_impact": -0.008126020321142846,
    "api_order": 86,
    "id": "7ad68dd7-90ac-4953-bca2-89d25e0686b0",
    "analysis": [
      {
        "review_id": "7ad68dd7-90ac-4953-bca2-89d25e0686b0",
        "comment": "Pastry was Ok though!",
        "subject_group": "pastry",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "96a21c0e-1750-46be-9e90-3c8c956bbbea"
      },
      {
        "review_id": "7ad68dd7-90ac-4953-bca2-89d25e0686b0",
        "comment": "I came for the Nutella croissant (supreme) and I was disappointed because they’re not using real Nutella.",
        "subject_group": "nutella",
        "category": "product",
        "attribute": "authenticity",
        "sentiment": "negative",
        "attribute_impact": -0.004063010160571423,
        "id": "7d632fec-474b-4c21-9a8b-6553037a6851"
      },
      {
        "review_id": "7ad68dd7-90ac-4953-bca2-89d25e0686b0",
        "comment": "I came for the Nutella croissant (supreme) and I was disappointed because they’re not using real Nutella.",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "quality",
        "sentiment": "negative",
        "attribute_impact": -0.004063010160571423,
        "id": "e66b31ca-be6b-428c-9bdc-a08cd43b6853"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-08-08T23:45:32",
    "profile_name": "Timing 4me",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNwM3JpeU5BEAE",
    "review_text": "Best pizza in Manhattan worth the price",
    "cumulative_rating": 4.3604651162790695,
    "review_impact": 0.00236349016836801,
    "api_order": 85,
    "id": "d888b811-fdee-441e-94b7-7a407208587c",
    "analysis": [
      {
        "review_id": "d888b811-fdee-441e-94b7-7a407208587c",
        "comment": "Best pizza in Manhattan worth the price",
        "subject_group": "pizza",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "2106abf2-3230-40f9-b26c-08bf4a2dff5d"
      },
      {
        "review_id": "d888b811-fdee-441e-94b7-7a407208587c",
        "comment": "Best pizza in Manhattan worth the price",
        "subject_group": "pizza",
        "category": "product",
        "attribute": "value",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "8eee0a72-80fc-4f8f-85d7-413b3dd7354f"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-08-06T13:21:32",
    "profile_name": "Gary Parker",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNwbXUySEtREAE",
    "review_text": "Really good strawberry cheesecake. It was $9, but it was worth it. Really creamy and not too sweet with a great crispy crust.",
    "cumulative_rating": 4.352941176470588,
    "review_impact": 0.00236349016836801,
    "api_order": 84,
    "id": "741380ad-8b4e-41de-a15f-ca07bd66d149",
    "analysis": [
      {
        "review_id": "741380ad-8b4e-41de-a15f-ca07bd66d149",
        "comment": "Really creamy and not too sweet with a great crispy crust",
        "subject_group": "texture",
        "category": "product",
        "attribute": "sweetness",
        "sentiment": "negative",
        "attribute_impact": 0.0,
        "id": "5d041d77-1bca-438d-ab4e-48404cc8f6c7"
      },
      {
        "review_id": "741380ad-8b4e-41de-a15f-ca07bd66d149",
        "comment": "Really good strawberry cheesecake",
        "subject_group": "cheesecake",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "ad0fd4a2-248b-4b77-9da7-5bfe52d35518"
      },
      {
        "review_id": "741380ad-8b4e-41de-a15f-ca07bd66d149",
        "comment": "Really creamy and not too sweet with a great crispy crust",
        "subject_group": "texture",
        "category": "product",
        "attribute": "creaminess",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "b6fcb375-ae4e-4aa7-aed4-826eb86cf740"
      },
      {
        "review_id": "741380ad-8b4e-41de-a15f-ca07bd66d149",
        "comment": "It was $9, but it was worth it",
        "subject_group": "price",
        "category": "product",
        "attribute": "value",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "e4135308-e5c1-4fd9-b148-20220f4ec1e8"
      },
      {
        "review_id": "741380ad-8b4e-41de-a15f-ca07bd66d149",
        "comment": "Really creamy and not too sweet with a great crispy crust",
        "subject_group": "texture",
        "category": "product",
        "attribute": "crust",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "fd37e353-fb33-4d15-9729-0621930504a4"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-08-04T02:57:32",
    "profile_name": "Jason Wolfe",
    "rating": 3,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUNwbkxQYS1BRRAB",
    "review_text": null,
    "cumulative_rating": 4.345238095238095,
    "review_impact": -0.004629516824638635,
    "api_order": 83,
    "id": "2dcfb354-de0d-46bd-9eff-bc16e6fac0db",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-08-01T16:33:32",
    "profile_name": "Leo Gaguine",
    "rating": 4,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNwaE5HaFNREAE",
    "review_text": "Very good pastry, great coffee very reasonable prices. Good breakfast in NY",
    "cumulative_rating": 4.36144578313253,
    "review_impact": -0.0011330133281353127,
    "api_order": 82,
    "id": "b3f5ec5e-96ce-463e-9d92-8dc842c02889",
    "analysis": [
      {
        "review_id": "b3f5ec5e-96ce-463e-9d92-8dc842c02889",
        "comment": "Very good pastry",
        "subject_group": "pastry",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "97cfd60c-7cb9-43c1-bb42-85a9236ab857"
      },
      {
        "review_id": "b3f5ec5e-96ce-463e-9d92-8dc842c02889",
        "comment": "great coffee",
        "subject_group": "coffee",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "6fe064bc-1327-41a3-8b5b-5ec6e9e13cf9"
      },
      {
        "review_id": "b3f5ec5e-96ce-463e-9d92-8dc842c02889",
        "comment": "very reasonable prices",
        "subject_group": "price",
        "category": "product",
        "attribute": "value",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "cc1e4f22-d92b-4b65-a6df-ea9fd74b578a"
      },
      {
        "review_id": "b3f5ec5e-96ce-463e-9d92-8dc842c02889",
        "comment": "Good breakfast in NY",
        "subject_group": "breakfast",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "29ec66c0-d362-4dad-b019-8525ae123ff5"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-07-30T06:09:32",
    "profile_name": "Lisa SB.",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSURKbjlLeU5BEAE",
    "review_text": "Very tasty breakfast offering. The crossaints filled with pistachios are amazing. Very soft, buttery and lots of filling. An excellent culinary delight. The vanilla iced latte is also fabulous and very tasty. The hearty French toast was also juicy and extremely fluffy.\n\nThe prices are typical for New York and are not cheap for German tourists, but that's how New York is in general. The service is also very nice and quick.",
    "cumulative_rating": 4.365853658536586,
    "review_impact": 0.00236349016836801,
    "api_order": 81,
    "id": "fc6814a5-3e20-4a4b-888f-f36f93b80141",
    "analysis": [
      {
        "review_id": "fc6814a5-3e20-4a4b-888f-f36f93b80141",
        "comment": "The service is also very nice and quick.",
        "subject_group": "service",
        "category": "service",
        "attribute": "friendliness",
        "sentiment": "positive",
        "attribute_impact": 0.00023634901683680098,
        "id": "028128c9-8728-4e52-926f-17f48dad22c4"
      },
      {
        "review_id": "fc6814a5-3e20-4a4b-888f-f36f93b80141",
        "comment": "Very soft, buttery and lots of filling.",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "texture",
        "sentiment": "positive",
        "attribute_impact": 0.00023634901683680098,
        "id": "07819923-e094-454c-aa7d-f6554d6a2eae"
      },
      {
        "review_id": "fc6814a5-3e20-4a4b-888f-f36f93b80141",
        "comment": "The hearty French toast was also juicy and extremely fluffy.",
        "subject_group": "french toast",
        "category": "product",
        "attribute": "moisture",
        "sentiment": "positive",
        "attribute_impact": 0.00023634901683680098,
        "id": "1fb1e4ca-d365-4321-9747-544d66d8ba88"
      },
      {
        "review_id": "fc6814a5-3e20-4a4b-888f-f36f93b80141",
        "comment": "Very soft, buttery and lots of filling.",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "flavor",
        "sentiment": "positive",
        "attribute_impact": 0.00023634901683680098,
        "id": "26cc7e4f-c4bb-4412-b270-b9d273dd96a3"
      },
      {
        "review_id": "fc6814a5-3e20-4a4b-888f-f36f93b80141",
        "comment": "An excellent culinary delight.",
        "subject_group": "culinary delight",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00023634901683680098,
        "id": "4167ce6d-15d8-4aba-8f57-9fab36e478a8"
      },
      {
        "review_id": "fc6814a5-3e20-4a4b-888f-f36f93b80141",
        "comment": "Very tasty breakfast offering.",
        "subject_group": "breakfast",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.00023634901683680098,
        "id": "4c148d95-90a8-4515-b737-c0157dfe20de"
      },
      {
        "review_id": "fc6814a5-3e20-4a4b-888f-f36f93b80141",
        "comment": "The vanilla iced latte is also fabulous and very tasty.",
        "subject_group": "latte",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.00023634901683680098,
        "id": "6ef92360-987b-40d5-8d03-47e923c91610"
      },
      {
        "review_id": "fc6814a5-3e20-4a4b-888f-f36f93b80141",
        "comment": "The service is also very nice and quick.",
        "subject_group": "service",
        "category": "service",
        "attribute": "speed",
        "sentiment": "positive",
        "attribute_impact": 0.00023634901683680098,
        "id": "97cf8121-e279-4711-a8cc-97f05f45f125"
      },
      {
        "review_id": "fc6814a5-3e20-4a4b-888f-f36f93b80141",
        "comment": "The hearty French toast was also juicy and extremely fluffy.",
        "subject_group": "french toast",
        "category": "product",
        "attribute": "texture",
        "sentiment": "positive",
        "attribute_impact": 0.00023634901683680098,
        "id": "c3be3a8e-e639-4bbf-a4a9-dc2c264f9c11"
      },
      {
        "review_id": "fc6814a5-3e20-4a4b-888f-f36f93b80141",
        "comment": "The croissant filled with pistachios are amazing.",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.00023634901683680098,
        "id": "fe13cb35-96d1-4636-9bbf-aba0bd56918d"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-07-27T19:45:32",
    "profile_name": "Kayla Vaselewski",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSURKMmNEN2RREAE",
    "review_text": "Very good food and prices are very good too definitely would recommend!!!",
    "cumulative_rating": 4.3580246913580245,
    "review_impact": 0.00236349016836801,
    "api_order": 80,
    "id": "0ed2c5a1-f3af-4e44-a4f4-a47399e6b522",
    "analysis": [
      {
        "review_id": "0ed2c5a1-f3af-4e44-a4f4-a47399e6b522",
        "comment": "definitely would recommend",
        "subject_group": "recommendation",
        "category": "experience",
        "attribute": "satisfaction",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "69d3e4ec-8a3b-430f-8d4e-17c8dedfb50b"
      },
      {
        "review_id": "0ed2c5a1-f3af-4e44-a4f4-a47399e6b522",
        "comment": "Very good food",
        "subject_group": "food",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "93c4ae98-2abc-49a7-aada-de4fc61c7d79"
      },
      {
        "review_id": "0ed2c5a1-f3af-4e44-a4f4-a47399e6b522",
        "comment": "prices are very good too",
        "subject_group": "price",
        "category": "product",
        "attribute": "value",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "ede54bbe-dda1-4020-8063-07e91a200181"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-07-25T09:21:32",
    "profile_name": "Aileen Janßen",
    "rating": 4,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSURKMGZtZENBEAE",
    "review_text": "Very tasty but expensive",
    "cumulative_rating": 4.35,
    "review_impact": -0.0011330133281353127,
    "api_order": 79,
    "id": "6d9f5c9f-a482-4323-96cb-c62aa8e7477d",
    "analysis": [
      {
        "review_id": "6d9f5c9f-a482-4323-96cb-c62aa8e7477d",
        "comment": "Very tasty but expensive",
        "subject_group": "product",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "9aba9fbc-a537-423b-aa66-d6d307c3995e"
      },
      {
        "review_id": "6d9f5c9f-a482-4323-96cb-c62aa8e7477d",
        "comment": "Very tasty but expensive",
        "subject_group": "product",
        "category": "product",
        "attribute": "price",
        "sentiment": "negative",
        "attribute_impact": -0.0011330133281353127,
        "id": "5a7d42ad-f659-4d0f-b229-545a8385d7d2"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-07-22T22:57:32",
    "profile_name": "Renata Ville",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSURKdm9ubm1BRRAB",
    "review_text": "Delicious salmon sandwich, croissant, and cappuccino! We were simply surprised how good it was! Recommend",
    "cumulative_rating": 4.3544303797468356,
    "review_impact": 0.00236349016836801,
    "api_order": 78,
    "id": "aa6ce973-20ed-4cc7-b5f9-f6c3fa76421e",
    "analysis": [
      {
        "review_id": "aa6ce973-20ed-4cc7-b5f9-f6c3fa76421e",
        "comment": "Delicious croissant",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.00047269803367360196,
        "id": "63e5292e-4750-448e-8e0d-87c986704bbe"
      },
      {
        "review_id": "aa6ce973-20ed-4cc7-b5f9-f6c3fa76421e",
        "comment": "We were simply surprised how good it was",
        "subject_group": "experience",
        "category": "experience",
        "attribute": "satisfaction",
        "sentiment": "positive",
        "attribute_impact": 0.00047269803367360196,
        "id": "671449df-fe9f-4993-9b10-f6e88c60c838"
      },
      {
        "review_id": "aa6ce973-20ed-4cc7-b5f9-f6c3fa76421e",
        "comment": "Delicious salmon sandwich",
        "subject_group": "sandwich",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.00047269803367360196,
        "id": "69882231-79cb-473b-beff-791eeaf5fa92"
      },
      {
        "review_id": "aa6ce973-20ed-4cc7-b5f9-f6c3fa76421e",
        "comment": "Delicious cappuccino",
        "subject_group": "cappuccino",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.00047269803367360196,
        "id": "9a293a1e-69a6-4de8-b0c7-4ad44fd91885"
      },
      {
        "review_id": "aa6ce973-20ed-4cc7-b5f9-f6c3fa76421e",
        "comment": "Recommend",
        "subject_group": "recommendation",
        "category": "experience",
        "attribute": "value",
        "sentiment": "positive",
        "attribute_impact": 0.00047269803367360196,
        "id": "d234102b-696f-4c3c-960d-303cfa8db9d5"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-07-20T12:33:32",
    "profile_name": "Hugo Chacon",
    "rating": 1,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSURKeHRPS0pREAE",
    "review_text": "Today at 7:20 p.m. we entered the establishment to serve ourselves something and when we said hello, the person, a man at the end of the hallway, responded rudely to us saying that it was closed. I mean, it's understandable that it was closed, but was that the way to respond? He wasn't even friendly as he didn't respond when I said hello.",
    "cumulative_rating": 4.346153846153846,
    "review_impact": -0.011622523817646169,
    "api_order": 77,
    "id": "c3a7dee8-7bf9-4e2f-bb6e-0d0d67f764bf",
    "analysis": [
      {
        "review_id": "c3a7dee8-7bf9-4e2f-bb6e-0d0d67f764bf",
        "comment": "it's understandable that it was closed, but was that the way to respond?",
        "subject_group": "response",
        "category": "service",
        "attribute": "understanding",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "d41bea42-12fd-457d-ba7d-1c4f4d3c90dd"
      },
      {
        "review_id": "c3a7dee8-7bf9-4e2f-bb6e-0d0d67f764bf",
        "comment": "it's understandable that it was closed, but was that the way to respond?",
        "subject_group": "response",
        "category": "service",
        "attribute": "manner",
        "sentiment": "negative",
        "attribute_impact": -0.003874174605882056,
        "id": "0397bd36-18b3-400b-b9c7-34bc8f11c0ed"
      },
      {
        "review_id": "c3a7dee8-7bf9-4e2f-bb6e-0d0d67f764bf",
        "comment": "the person, a man at the end of the hallway, responded rudely to us saying that it was closed",
        "subject_group": "person",
        "category": "service",
        "attribute": "friendliness",
        "sentiment": "negative",
        "attribute_impact": -0.003874174605882056,
        "id": "2e8ad3d6-92dc-47df-ae80-45dd445d53d0"
      },
      {
        "review_id": "c3a7dee8-7bf9-4e2f-bb6e-0d0d67f764bf",
        "comment": "the person, a man at the end of the hallway, responded rudely to us saying that it was closed",
        "subject_group": "person",
        "category": "service",
        "attribute": "rudeness",
        "sentiment": "negative",
        "attribute_impact": -0.003874174605882056,
        "id": "b7c5f73d-b2a2-48be-9a87-66327b102916"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-07-18T02:09:32",
    "profile_name": "Peach Baugh",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSURKLW9MWVd3EAE",
    "review_text": "Staff members were kind and the food was great. Make sure that you get there early because they do sell out of some of the better items.",
    "cumulative_rating": 4.3896103896103895,
    "review_impact": 0.00236349016836801,
    "api_order": 76,
    "id": "308675a2-f38d-4c3a-8d73-29f9328d13f5",
    "analysis": [
      {
        "review_id": "308675a2-f38d-4c3a-8d73-29f9328d13f5",
        "comment": "they do sell out of some of the better items",
        "subject_group": "items",
        "category": "product",
        "attribute": "availability",
        "sentiment": "negative",
        "attribute_impact": 0.0,
        "id": "c3bc1f43-dc28-4fda-b6f4-d57d2e8b94b1"
      },
      {
        "review_id": "308675a2-f38d-4c3a-8d73-29f9328d13f5",
        "comment": "Staff members were kind",
        "subject_group": "staff",
        "category": "service",
        "attribute": "kindness",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "1d445dec-ebb2-477d-aca7-97fdceadec9c"
      },
      {
        "review_id": "308675a2-f38d-4c3a-8d73-29f9328d13f5",
        "comment": "the food was great",
        "subject_group": "food",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "2e6aed59-79f1-4089-a289-5afb86b0d4af"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-07-15T15:45:32",
    "profile_name": "Ilya Toiberman",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSURKaXZXSnp3RRAB",
    "review_text": "Perfect coffee and bakery, bit expensive",
    "cumulative_rating": 4.381578947368421,
    "review_impact": 0.00236349016836801,
    "api_order": 75,
    "id": "b8d44cf2-a9f5-4433-82e3-33a14786efe2",
    "analysis": [
      {
        "review_id": "b8d44cf2-a9f5-4433-82e3-33a14786efe2",
        "comment": "bit expensive",
        "subject_group": "price",
        "category": "product",
        "attribute": "value",
        "sentiment": "negative",
        "attribute_impact": 0.0,
        "id": "6f087f1e-60d1-4b1a-828f-6422eb285a29"
      },
      {
        "review_id": "b8d44cf2-a9f5-4433-82e3-33a14786efe2",
        "comment": "Perfect coffee and bakery",
        "subject_group": "bakery",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "7427d6c4-e8f5-4f58-9b0d-93bb1894e344"
      },
      {
        "review_id": "b8d44cf2-a9f5-4433-82e3-33a14786efe2",
        "comment": "Perfect coffee and bakery",
        "subject_group": "coffee",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "a7135ac4-6c3a-44c1-8640-bcaf2f109339"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-07-13T05:21:32",
    "profile_name": "Olga Titova",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUNoM2NYdC1BRRAB",
    "review_text": null,
    "cumulative_rating": 4.373333333333333,
    "review_impact": 0.00236349016836801,
    "api_order": 74,
    "id": "6c9423c9-4df7-4c31-a441-1905c110948c",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-07-10T18:57:32",
    "profile_name": "Laura Crotty Alexander",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSURKb3FPNDN3RRAB",
    "review_text": "Delicious prosciutto sandwich! I also had a shot of espresso, which was perfect. Next time I’ll have to try some of their tasty treats (the butter croissants look super flaky and perfectly baked).",
    "cumulative_rating": 4.364864864864865,
    "review_impact": 0.00236349016836801,
    "api_order": 73,
    "id": "4fb14747-19d0-471d-a2b9-41b0d478c590",
    "analysis": [
      {
        "review_id": "4fb14747-19d0-471d-a2b9-41b0d478c590",
        "comment": "I also had a shot of espresso, which was perfect.",
        "subject_group": "espresso",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "32babeeb-f4f4-4b73-95d5-47b256a28d7e"
      },
      {
        "review_id": "4fb14747-19d0-471d-a2b9-41b0d478c590",
        "comment": "Delicious prosciutto sandwich!",
        "subject_group": "sandwich",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "62603b9a-6e11-4d5d-9184-c7ef7115454e"
      },
      {
        "review_id": "4fb14747-19d0-471d-a2b9-41b0d478c590",
        "comment": "the butter croissants look super flaky and perfectly baked.",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "baking",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "890d7000-4478-463e-a9d9-0fe6e3a390d6"
      },
      {
        "review_id": "4fb14747-19d0-471d-a2b9-41b0d478c590",
        "comment": "the butter croissants look super flaky and perfectly baked.",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "texture",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "af7776f0-c950-4d5c-bc1c-de5ea9d52011"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-07-08T08:33:32",
    "profile_name": "pavla smetankova",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSURKbE9INDJnRRAB",
    "review_text": "Excelent coffee, we had to look for such delicious coffee in NYC for very long time, also very tasty sandwiches.",
    "cumulative_rating": 4.3561643835616435,
    "review_impact": 0.00236349016836801,
    "api_order": 72,
    "id": "9c6472db-68e1-45cc-bf5d-e4b4c5d3a8ba",
    "analysis": [
      {
        "review_id": "9c6472db-68e1-45cc-bf5d-e4b4c5d3a8ba",
        "comment": "very tasty sandwiches",
        "subject_group": "sandwich",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "174615d6-b1f2-49db-92e3-51cc02e06659"
      },
      {
        "review_id": "9c6472db-68e1-45cc-bf5d-e4b4c5d3a8ba",
        "comment": "Excelent coffee",
        "subject_group": "coffee",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "56b06620-faee-4816-962d-005e88b589ef"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-07-05T22:09:32",
    "profile_name": "Carlo Dallara",
    "rating": 4,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSURKNEk3RmhnRRAB",
    "review_text": null,
    "cumulative_rating": 4.347222222222222,
    "review_impact": -0.0011330133281353127,
    "api_order": 71,
    "id": "208a0ee5-3516-45a2-88a5-d010f3beb7c4",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-07-03T11:45:32",
    "profile_name": "Beb",
    "rating": 1,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUNKcDZmMG9nRRAB",
    "review_text": "Was craving a cream filled donut like Angelina’s, but there are none near our hotel so settled for this instead. Was a bit disappointed in the product, especially for the price - the croissant was over baked and hard and the cream was not very tasty. Not sure what the discrepancy is with the other reviews but I don’t think it was worth the $9, where other bakeries average $5-6 for a better product",
    "cumulative_rating": 4.352112676056338,
    "review_impact": -0.011622523817646169,
    "api_order": 70,
    "id": "6b7903dd-cb15-4d9a-a716-dcca93169d48",
    "analysis": [
      {
        "review_id": "6b7903dd-cb15-4d9a-a716-dcca93169d48",
        "comment": "the croissant was over baked and hard.",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "texture",
        "sentiment": "negative",
        "attribute_impact": -0.001937087302941028,
        "id": "050010de-932d-4369-a855-cbc1cdb230e4"
      },
      {
        "review_id": "6b7903dd-cb15-4d9a-a716-dcca93169d48",
        "comment": "the croissant was over baked and hard.",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "baking",
        "sentiment": "negative",
        "attribute_impact": -0.001937087302941028,
        "id": "0728aa45-d361-4a51-9d0a-bc81ed9cef7e"
      },
      {
        "review_id": "6b7903dd-cb15-4d9a-a716-dcca93169d48",
        "comment": "Was a bit disappointed in the product, especially for the price.",
        "subject_group": "product",
        "category": "product",
        "attribute": "price",
        "sentiment": "negative",
        "attribute_impact": -0.001937087302941028,
        "id": "11082ad0-af77-4d4e-9b6d-a832def8681d"
      },
      {
        "review_id": "6b7903dd-cb15-4d9a-a716-dcca93169d48",
        "comment": "Was a bit disappointed in the product, especially for the price.",
        "subject_group": "product",
        "category": "product",
        "attribute": "disappointment",
        "sentiment": "negative",
        "attribute_impact": -0.001937087302941028,
        "id": "319b9338-d45a-42b0-984a-78dabf671442"
      },
      {
        "review_id": "6b7903dd-cb15-4d9a-a716-dcca93169d48",
        "comment": "the cream was not very tasty.",
        "subject_group": "cream",
        "category": "product",
        "attribute": "taste",
        "sentiment": "negative",
        "attribute_impact": -0.001937087302941028,
        "id": "9958a9ae-acde-4737-a060-78b665ce7adf"
      },
      {
        "review_id": "6b7903dd-cb15-4d9a-a716-dcca93169d48",
        "comment": "Not sure what the discrepancy is with the other reviews but I don’t think it was worth the $9, where other bakeries average $5-6 for a better product.",
        "subject_group": "product",
        "category": "product",
        "attribute": "value",
        "sentiment": "negative",
        "attribute_impact": -0.001937087302941028,
        "id": "ddce6d6f-c52c-46b4-ac54-6c8b952ebf53"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-07-01T01:21:32",
    "profile_name": "Stanislav Ferzik",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUNKcC1MYS1RRRAB",
    "review_text": "Great breakfast, a bit more expensive, about 15-20$ per person, but worth it.",
    "cumulative_rating": 4.4,
    "review_impact": 0.00236349016836801,
    "api_order": 69,
    "id": "3d1b27cb-11d5-43dc-9323-58cca56b43e8",
    "analysis": [
      {
        "review_id": "3d1b27cb-11d5-43dc-9323-58cca56b43e8",
        "comment": "a bit more expensive",
        "subject_group": "price",
        "category": "product",
        "attribute": "cost",
        "sentiment": "negative",
        "attribute_impact": 0.0,
        "id": "e033694d-87a6-44de-a5de-0489a71f7f41"
      },
      {
        "review_id": "3d1b27cb-11d5-43dc-9323-58cca56b43e8",
        "comment": "Great breakfast",
        "subject_group": "breakfast",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "2201c543-cf31-4c51-832c-970a1c0309f2"
      },
      {
        "review_id": "3d1b27cb-11d5-43dc-9323-58cca56b43e8",
        "comment": "but worth it",
        "subject_group": "value",
        "category": "experience",
        "attribute": "worth",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "3d282837-c548-4a77-aabb-32bcd6054161"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-06-28T14:57:32",
    "profile_name": "Eleni Ke",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNKbzVmOEJBEAE",
    "review_text": null,
    "cumulative_rating": 4.391304347826087,
    "review_impact": 0.00236349016836801,
    "api_order": 68,
    "id": "e54e02a2-07f2-486c-a410-c424dde6ba83",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-06-26T04:33:32",
    "profile_name": "Zuleidy Lai",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNKM3ZLSldREAE",
    "review_text": null,
    "cumulative_rating": 4.382352941176471,
    "review_impact": 0.00236349016836801,
    "api_order": 67,
    "id": "19a7f12c-00f5-491c-a764-9573a97ece40",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-06-23T18:09:32",
    "profile_name": "Naidona Ott",
    "rating": 3,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUNKb3IzenhBRRAB",
    "review_text": "So, we went to try the cream filled croissants.  We got the raspberry and the Nutella. The appearance of the raspberry was clean and the flavor was good. The cream was a bit thin but still had a nice flavor. The Nutella was an issue. It really was a bit of a mess. The drizzle on the top looked very amateur.  Unfortunately it tasted nothing like Nutella. It just tasted like chocolate. Making your own Nutella is impressive if its delicious and has that beautiful stick to the roof of your mouth nutty unctuous goodness. Unfortunately this had none of those notes. We decided to get the Nutella cheesecake and see if it was just the croissant but unfortunately it was the same dull chocolate flavor. The cheesecake itself was smooth and typical of most bakery cheesecake. Its definitely worth stopping in and trying it out. The regular croissants were beautiful. I will say a friendly happy staff can make a place and the staff didn't seem very happy to be there.",
    "cumulative_rating": 4.373134328358209,
    "review_impact": -0.004629516824638635,
    "api_order": 66,
    "id": "187f3e12-3ec9-45c1-96cf-34dfb226dffc",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-06-21T07:45:32",
    "profile_name": "Tania Alvarez Verde",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNKOUt5Uld3EAE",
    "review_text": "A lovely place!\nSmall, cozy!\nVery clean!\nExcellent attention!\nAnd everything delicious!!\nHighly recommended!",
    "cumulative_rating": 4.393939393939394,
    "review_impact": 0.00236349016836801,
    "api_order": 65,
    "id": "aab648ed-2a9e-440e-a0ff-76c61a73bbd5",
    "analysis": [
      {
        "review_id": "aab648ed-2a9e-440e-a0ff-76c61a73bbd5",
        "comment": "Excellent attention!",
        "subject_group": "attention",
        "category": "service",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0003376414526240014,
        "id": "001a7e72-5e2e-4e40-86d0-5a1f4412fc12"
      },
      {
        "review_id": "aab648ed-2a9e-440e-a0ff-76c61a73bbd5",
        "comment": "Small, cozy!",
        "subject_group": "place",
        "category": "experience",
        "attribute": "size",
        "sentiment": "positive",
        "attribute_impact": 0.0003376414526240014,
        "id": "084265d8-6cf6-4075-a0c8-7fbd8f0fb521"
      },
      {
        "review_id": "aab648ed-2a9e-440e-a0ff-76c61a73bbd5",
        "comment": "A lovely place!",
        "subject_group": "place",
        "category": "experience",
        "attribute": "loveliness",
        "sentiment": "positive",
        "attribute_impact": 0.0003376414526240014,
        "id": "380186b7-7919-4936-a43a-1cc4a6df1838"
      },
      {
        "review_id": "aab648ed-2a9e-440e-a0ff-76c61a73bbd5",
        "comment": "Highly recommended!",
        "subject_group": "recommendation",
        "category": "experience",
        "attribute": "strength",
        "sentiment": "positive",
        "attribute_impact": 0.0003376414526240014,
        "id": "3c9fd471-f97c-437e-bf73-ceebdfec53ca"
      },
      {
        "review_id": "aab648ed-2a9e-440e-a0ff-76c61a73bbd5",
        "comment": "Very clean!",
        "subject_group": "place",
        "category": "experience",
        "attribute": "cleanliness",
        "sentiment": "positive",
        "attribute_impact": 0.0003376414526240014,
        "id": "a8671f5e-2f2b-4884-9185-21532f36f02f"
      },
      {
        "review_id": "aab648ed-2a9e-440e-a0ff-76c61a73bbd5",
        "comment": "And everything delicious!!",
        "subject_group": "food",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.0003376414526240014,
        "id": "ad2016e4-cafa-4caa-add5-0dda89fda666"
      },
      {
        "review_id": "aab648ed-2a9e-440e-a0ff-76c61a73bbd5",
        "comment": "Small, cozy!",
        "subject_group": "place",
        "category": "experience",
        "attribute": "comfort",
        "sentiment": "positive",
        "attribute_impact": 0.0003376414526240014,
        "id": "d7a41d5c-93cc-40f8-8ac3-02de687704db"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-06-18T21:21:32",
    "profile_name": "Yash Patel",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUR4aWVMaURnEAE",
    "review_text": "Nice atmosphere with a public restroom and an amazing cheesecake with the perfect balance of sweet and savory.",
    "cumulative_rating": 4.384615384615385,
    "review_impact": 0.00236349016836801,
    "api_order": 64,
    "id": "15a8fbb9-ffbd-497d-951f-d160f859ae4a",
    "analysis": [
      {
        "review_id": "15a8fbb9-ffbd-497d-951f-d160f859ae4a",
        "comment": "public restroom",
        "subject_group": "restroom",
        "category": "experience",
        "attribute": "availability",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "1dcea996-c2ee-4b97-a0e7-65251109e7f7"
      },
      {
        "review_id": "15a8fbb9-ffbd-497d-951f-d160f859ae4a",
        "comment": "Nice atmosphere",
        "subject_group": "atmosphere",
        "category": "experience",
        "attribute": "pleasantness",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "2da6d84d-fd1f-4968-b1b2-10e8db159fde"
      },
      {
        "review_id": "15a8fbb9-ffbd-497d-951f-d160f859ae4a",
        "comment": "perfect balance of sweet and savory",
        "subject_group": "balance",
        "category": "product",
        "attribute": "flavor",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "b5a6f2ca-5d9e-498d-aca2-0417854a5f85"
      },
      {
        "review_id": "15a8fbb9-ffbd-497d-951f-d160f859ae4a",
        "comment": "amazing cheesecake",
        "subject_group": "cheesecake",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "ceb56aa3-b3d2-4226-9462-bdfb1ea1ba56"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-06-16T10:57:32",
    "profile_name": "Migdalia Rivera",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUR4Z1lqaUpREAE",
    "review_text": "Great experience! Delicious food!",
    "cumulative_rating": 4.375,
    "review_impact": 0.00236349016836801,
    "api_order": 63,
    "id": "d6ff8b34-2e60-4a01-b11b-b645585e780c",
    "analysis": [
      {
        "review_id": "d6ff8b34-2e60-4a01-b11b-b645585e780c",
        "comment": "Great experience!",
        "subject_group": "experience",
        "category": "experience",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "642704b4-eb89-44e0-aa42-3cba4e0b1282"
      },
      {
        "review_id": "d6ff8b34-2e60-4a01-b11b-b645585e780c",
        "comment": "Delicious food!",
        "subject_group": "food",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "bee2d097-c66a-42cb-9acd-7e7bfe017b90"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-06-14T00:33:32",
    "profile_name": "Priyanka Minde",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUR4cnFQOXhRRRAB",
    "review_text": "The pastries are too good. It’s a must try place for breakfast and coffee.",
    "cumulative_rating": 4.365079365079365,
    "review_impact": 0.00236349016836801,
    "api_order": 62,
    "id": "7e63eec6-6498-48e5-b783-d292c5cfbb44",
    "analysis": [
      {
        "review_id": "7e63eec6-6498-48e5-b783-d292c5cfbb44",
        "comment": "The pastries are too good",
        "subject_group": "pastry",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "68992e02-9de4-4df0-bddd-4dfd4ef1ac1a"
      },
      {
        "review_id": "7e63eec6-6498-48e5-b783-d292c5cfbb44",
        "comment": "It’s a must try place for breakfast and coffee",
        "subject_group": "coffee",
        "category": "product",
        "attribute": "recommendation",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "86be24f0-0aa2-41f7-a16d-505a55cfe533"
      },
      {
        "review_id": "7e63eec6-6498-48e5-b783-d292c5cfbb44",
        "comment": "It’s a must try place for breakfast and coffee",
        "subject_group": "place",
        "category": "experience",
        "attribute": "recommendation",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "e28ea2ca-5c19-4c2d-b111-352f56f5293f"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-06-11T14:09:32",
    "profile_name": "Dhroov Patel",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUR4dHBMSFp3EAE",
    "review_text": "Great little bakehouse with reasonable prices. The strawberry cheesecake was so good, and I also had a white mocha which wasn't too sweet, which is the way I prefer!",
    "cumulative_rating": 4.354838709677419,
    "review_impact": 0.00236349016836801,
    "api_order": 61,
    "id": "de96cb68-ae01-4a89-9635-b3796d09023f",
    "analysis": [
      {
        "review_id": "de96cb68-ae01-4a89-9635-b3796d09023f",
        "comment": "I also had a white mocha which wasn't too sweet",
        "subject_group": "mocha",
        "category": "product",
        "attribute": "sweetness",
        "sentiment": "negative",
        "attribute_impact": 0.0,
        "id": "01566987-3ab9-4248-93d2-f0388eb3f888"
      },
      {
        "review_id": "de96cb68-ae01-4a89-9635-b3796d09023f",
        "comment": "Great little bakehouse with reasonable prices",
        "subject_group": "bakehouse",
        "category": "experience",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "0363da5f-0dc7-47d1-8337-9db3927364d2"
      },
      {
        "review_id": "de96cb68-ae01-4a89-9635-b3796d09023f",
        "comment": "The strawberry cheesecake was so good",
        "subject_group": "cheesecake",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "823653b1-48c3-4c7c-a980-ffc3e30626cc"
      },
      {
        "review_id": "de96cb68-ae01-4a89-9635-b3796d09023f",
        "comment": "Great little bakehouse with reasonable prices",
        "subject_group": "bakehouse",
        "category": "experience",
        "attribute": "price",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "dbe13389-3a78-41ef-bd2d-e1355e0b9401"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-06-09T03:45:32",
    "profile_name": "Ian Ward",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUR4aXJxRFRREAE",
    "review_text": "We wish we could give you more than 5 stars ... Amazing food and service! Even super comfy seats!",
    "cumulative_rating": 4.344262295081967,
    "review_impact": 0.00236349016836801,
    "api_order": 60,
    "id": "5b8371f4-b82a-410c-96c6-10abf68597ca",
    "analysis": [
      {
        "review_id": "5b8371f4-b82a-410c-96c6-10abf68597ca",
        "comment": "Even super comfy seats",
        "subject_group": "seat",
        "category": "experience",
        "attribute": "comfort",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "bf5510a7-6cbf-47c2-bd43-3ad3bd9bfc55"
      },
      {
        "review_id": "5b8371f4-b82a-410c-96c6-10abf68597ca",
        "comment": "Amazing food and service",
        "subject_group": "food",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "d1df5f66-9a81-48ed-bc17-2c5ad75fadbc"
      },
      {
        "review_id": "5b8371f4-b82a-410c-96c6-10abf68597ca",
        "comment": "Amazing food and service",
        "subject_group": "service",
        "category": "service",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "e39e6b94-d82a-4552-aa59-14b37adb6bcb"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-06-06T17:21:32",
    "profile_name": "Neyssa Malave Quesada",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUR4c3VTWDFnRRAB",
    "review_text": "The best place to have an awesome Croissant, need to try the smoke avocado salmon is a 💯. Service out of this world. Highly recommended",
    "cumulative_rating": 4.333333333333333,
    "review_impact": 0.00236349016836801,
    "api_order": 59,
    "id": "7011c5c6-3912-4e6b-883c-c0ddc53c520c",
    "analysis": [
      {
        "review_id": "7011c5c6-3912-4e6b-883c-c0ddc53c520c",
        "comment": "need to try the smoke avocado salmon is a 💯",
        "subject_group": "salmon",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "afb859f6-7aae-49c2-90f6-bded51afb711"
      },
      {
        "review_id": "7011c5c6-3912-4e6b-883c-c0ddc53c520c",
        "comment": "The best place to have an awesome Croissant",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "b051a8d2-bc2d-44cd-b147-ee898f205da2"
      },
      {
        "review_id": "7011c5c6-3912-4e6b-883c-c0ddc53c520c",
        "comment": "Service out of this world",
        "subject_group": "service",
        "category": "service",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "d8fdcc05-a8ce-464a-ad59-92ee7793874c"
      },
      {
        "review_id": "7011c5c6-3912-4e6b-883c-c0ddc53c520c",
        "comment": "Highly recommended",
        "subject_group": "recommendation",
        "category": "experience",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "e74db923-0a96-4ac5-83ef-4ab29726c7b6"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-06-04T06:57:32",
    "profile_name": "María José Alvarado Oliva",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUR4NHJqWnBnRRAB",
    "review_text": "Delicious. Simply an optimal place to always have breakfast. Very friendly people",
    "cumulative_rating": 4.322033898305085,
    "review_impact": 0.00236349016836801,
    "api_order": 58,
    "id": "17a8e8e2-76e2-4833-8bf0-36798ccf0d28",
    "analysis": [
      {
        "review_id": "17a8e8e2-76e2-4833-8bf0-36798ccf0d28",
        "comment": "Delicious.",
        "subject_group": "food",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "48b55495-28fd-4ccd-b09c-d7ea2eb444e6"
      },
      {
        "review_id": "17a8e8e2-76e2-4833-8bf0-36798ccf0d28",
        "comment": "Very friendly people.",
        "subject_group": "staff",
        "category": "service",
        "attribute": "friendliness",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "5c2ac6a5-45d9-4d85-b441-06af0eb53dd4"
      },
      {
        "review_id": "17a8e8e2-76e2-4833-8bf0-36798ccf0d28",
        "comment": "Simply an optimal place to always have breakfast.",
        "subject_group": "place",
        "category": "experience",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "e6ecfd02-4466-4a62-b4a7-f8c5a4739d52"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-06-01T20:33:32",
    "profile_name": "DM MY",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUR4OUxHWWNREAE",
    "review_text": "Friendly staff, nice cakes, good doughnuts, cold drinks",
    "cumulative_rating": 4.310344827586207,
    "review_impact": 0.00236349016836801,
    "api_order": 57,
    "id": "23e75e8c-cbdd-4e7c-a348-9dfbfd2e3052",
    "analysis": [
      {
        "review_id": "23e75e8c-cbdd-4e7c-a348-9dfbfd2e3052",
        "comment": "Nice cakes",
        "subject_group": "cake",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "08d43b93-9df7-4d6a-bd4b-0664f37f042f"
      },
      {
        "review_id": "23e75e8c-cbdd-4e7c-a348-9dfbfd2e3052",
        "comment": "Friendly staff",
        "subject_group": "staff",
        "category": "service",
        "attribute": "friendliness",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "61affe01-24f3-4890-8220-bc051473feda"
      },
      {
        "review_id": "23e75e8c-cbdd-4e7c-a348-9dfbfd2e3052",
        "comment": "Good doughnut",
        "subject_group": "doughnut",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "9357abe6-f30c-4a1c-b08e-53d47f47c2ee"
      },
      {
        "review_id": "23e75e8c-cbdd-4e7c-a348-9dfbfd2e3052",
        "comment": "Cold drinks",
        "subject_group": "drink",
        "category": "product",
        "attribute": "temperature",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "f518265a-94b2-4942-926f-5a7ea6ffb0c5"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-05-30T10:09:32",
    "profile_name": "Robert Browarek",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUN4NTlxQ2hnRRAB",
    "review_text": "The Supreme Croissants. The croissant sandwiches. The nutella & raspberry jam donuts. Hit this place twice in two days , it was soooo good.",
    "cumulative_rating": 4.298245614035087,
    "review_impact": 0.00236349016836801,
    "api_order": 56,
    "id": "fc585856-16fe-4610-abe0-ba1e60ae2b4a",
    "analysis": [
      {
        "review_id": "fc585856-16fe-4610-abe0-ba1e60ae2b4a",
        "comment": "Hit this place twice in two days, it was soooo good.",
        "subject_group": "experience",
        "category": "experience",
        "attribute": "satisfaction",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "47df0ee7-9ab1-4ff7-aa9b-5e5d8d144796"
      },
      {
        "review_id": "fc585856-16fe-4610-abe0-ba1e60ae2b4a",
        "comment": "The croissant sandwiches.",
        "subject_group": "sandwich",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "5bf5319b-e6e3-4fe9-83b6-ef2e551a73e4"
      },
      {
        "review_id": "fc585856-16fe-4610-abe0-ba1e60ae2b4a",
        "comment": "The nutella & raspberry jam donuts.",
        "subject_group": "donut",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "a8c3da93-5736-46df-bb16-313f44b033f9"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-05-27T23:45:32",
    "profile_name": "Aurélie Boreux",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUN4bTdMQ2p3RRAB",
    "review_text": "I found this place by chance and I was really glad to eat there. The coffee and the chocolate croissant (pain au chocolat) were very good. The staff is really friendly. And the place is really cute and well decorated.",
    "cumulative_rating": 4.285714285714286,
    "review_impact": 0.00236349016836801,
    "api_order": 55,
    "id": "35da1dd3-3b10-47ec-a5ff-17ee9f7976f8",
    "analysis": [
      {
        "review_id": "35da1dd3-3b10-47ec-a5ff-17ee9f7976f8",
        "comment": "The place is really cute and well decorated.",
        "subject_group": "place",
        "category": "experience",
        "attribute": "cuteness",
        "sentiment": "positive",
        "attribute_impact": 0.00047269803367360196,
        "id": "0b862d85-6f97-436c-b7b2-0719b03103a5"
      },
      {
        "review_id": "35da1dd3-3b10-47ec-a5ff-17ee9f7976f8",
        "comment": "The coffee and the chocolate croissant (pain au chocolat) were very good.",
        "subject_group": "coffee",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00047269803367360196,
        "id": "1ee0ac17-3ff8-4dd2-8240-28a2df39573b"
      },
      {
        "review_id": "35da1dd3-3b10-47ec-a5ff-17ee9f7976f8",
        "comment": "The coffee and the chocolate croissant (pain au chocolat) were very good.",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00047269803367360196,
        "id": "382f6bbd-6dba-4192-95d3-069ec0ecc268"
      },
      {
        "review_id": "35da1dd3-3b10-47ec-a5ff-17ee9f7976f8",
        "comment": "The place is really cute and well decorated.",
        "subject_group": "place",
        "category": "experience",
        "attribute": "decoration",
        "sentiment": "positive",
        "attribute_impact": 0.00047269803367360196,
        "id": "b4f922de-8d67-4830-8451-93771d455e1b"
      },
      {
        "review_id": "35da1dd3-3b10-47ec-a5ff-17ee9f7976f8",
        "comment": "The staff is really friendly.",
        "subject_group": "staff",
        "category": "service",
        "attribute": "friendliness",
        "sentiment": "positive",
        "attribute_impact": 0.00047269803367360196,
        "id": "f20da3b3-8cd9-437e-bf9b-cc05a8fe2291"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-05-25T13:21:32",
    "profile_name": "Victoria Basaldu",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUN4N1luemx3RRAB",
    "review_text": "I cannot say enough good things about this place!! I got the BEC croissant and a vanilla latte both hot and iced—absolutely delicious. My go to while in the city! Will def be back every NY trip 😍",
    "cumulative_rating": 4.2727272727272725,
    "review_impact": 0.00236349016836801,
    "api_order": 54,
    "id": "93e6368a-69af-46bd-b568-c0f3107a6ade",
    "analysis": [
      {
        "review_id": "93e6368a-69af-46bd-b568-c0f3107a6ade",
        "comment": "I got the BEC croissant and a vanilla latte both hot and iced—absolutely delicious.",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "1f5d91a8-643d-484e-bf75-a2d113d93b38"
      },
      {
        "review_id": "93e6368a-69af-46bd-b568-c0f3107a6ade",
        "comment": "I got the BEC croissant and a vanilla latte both hot and iced—absolutely delicious.",
        "subject_group": "latte",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "6dd14fa4-c275-4884-a251-818dbe350810"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-05-23T02:57:32",
    "profile_name": "Matteo Marinelli",
    "rating": 1,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUN4anF5ZTR3RRAB",
    "review_text": "Good bakery products but staff friendliness close to zero. An attitude against customers that is hard to believe especially of the two ladies at the cashier and coffee machine. They should not be given those clients facing roles as the company will loose business if they keep treating customers the way we were treated.",
    "cumulative_rating": 4.2592592592592595,
    "review_impact": -0.011622523817646169,
    "api_order": 53,
    "id": "a22e7e09-16cb-46b5-8fa5-0238f6d5075a",
    "analysis": [
      {
        "review_id": "a22e7e09-16cb-46b5-8fa5-0238f6d5075a",
        "comment": "Good bakery products",
        "subject_group": "product",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "22565df3-bf83-4ac7-be47-90e0f6ffa5cc"
      },
      {
        "review_id": "a22e7e09-16cb-46b5-8fa5-0238f6d5075a",
        "comment": "staff friendliness close to zero",
        "subject_group": "staff",
        "category": "service",
        "attribute": "friendliness",
        "sentiment": "negative",
        "attribute_impact": -0.002905630954411542,
        "id": "077a0e25-b04e-4ef9-88d3-8eb826c2d8db"
      },
      {
        "review_id": "a22e7e09-16cb-46b5-8fa5-0238f6d5075a",
        "comment": "they should not be given those clients facing roles",
        "subject_group": "roles",
        "category": "service",
        "attribute": "suitability",
        "sentiment": "negative",
        "attribute_impact": -0.002905630954411542,
        "id": "c053f9cd-6c7e-4062-bdc2-b659fd8ae592"
      },
      {
        "review_id": "a22e7e09-16cb-46b5-8fa5-0238f6d5075a",
        "comment": "the company will lose business if they keep treating customers the way we were treated",
        "subject_group": "business",
        "category": "experience",
        "attribute": "customer retention",
        "sentiment": "negative",
        "attribute_impact": -0.002905630954411542,
        "id": "e60fa8ba-8e86-41f8-b6e9-e955a529703f"
      },
      {
        "review_id": "a22e7e09-16cb-46b5-8fa5-0238f6d5075a",
        "comment": "An attitude against customers that is hard to believe",
        "subject_group": "attitude",
        "category": "service",
        "attribute": "customer treatment",
        "sentiment": "negative",
        "attribute_impact": -0.002905630954411542,
        "id": "ec1894dd-d5e0-4d8b-823a-ca40b24a9a1e"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-05-20T16:33:32",
    "profile_name": "CJ",
    "rating": 1,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUN4bXBIeWRnEAE",
    "review_text": "Nice atmosphere and ok food. Staff seems aloof and unmotivated.",
    "cumulative_rating": 4.320754716981132,
    "review_impact": -0.011622523817646169,
    "api_order": 52,
    "id": "43a70dfa-be0c-4f3f-8879-c291e20d6086",
    "analysis": [
      {
        "review_id": "43a70dfa-be0c-4f3f-8879-c291e20d6086",
        "comment": "Nice atmosphere",
        "subject_group": "atmosphere",
        "category": "experience",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "c18b05f6-4251-442b-99f1-951b29c07055"
      },
      {
        "review_id": "43a70dfa-be0c-4f3f-8879-c291e20d6086",
        "comment": "Staff seems aloof and unmotivated",
        "subject_group": "staff",
        "category": "service",
        "attribute": "attitude",
        "sentiment": "negative",
        "attribute_impact": -0.005811261908823084,
        "id": "7e1c93f2-9564-478c-8527-f989539e9127"
      },
      {
        "review_id": "43a70dfa-be0c-4f3f-8879-c291e20d6086",
        "comment": "ok food",
        "subject_group": "food",
        "category": "product",
        "attribute": "quality",
        "sentiment": "negative",
        "attribute_impact": -0.005811261908823084,
        "id": "80c8c7e6-e891-4a93-a4e7-72960c4ef45f"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-05-18T06:09:32",
    "profile_name": "Hudci",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUN4N1BMbWRREAE",
    "review_text": "Tasty food, good coffee",
    "cumulative_rating": 4.384615384615385,
    "review_impact": 0.00236349016836801,
    "api_order": 51,
    "id": "85a371d3-3c72-4cd5-af54-3c09a9e66481",
    "analysis": [
      {
        "review_id": "85a371d3-3c72-4cd5-af54-3c09a9e66481",
        "comment": "Tasty food",
        "subject_group": "food",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "2570b6c4-4c7a-4cc1-8f72-c1bf4adf9a3d"
      },
      {
        "review_id": "85a371d3-3c72-4cd5-af54-3c09a9e66481",
        "comment": "good coffee",
        "subject_group": "coffee",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "9a3fac98-c8cf-4ae3-9bf7-64821d448ab5"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-05-15T19:45:32",
    "profile_name": "Ashley Bushala",
    "rating": 5,
    "provider_review_id": "ChRDSUhNMG9nS0VJQ0FnSUN4Nk9VSxAB",
    "review_text": "Great quick breakfast! Tons of beautiful and delicious pastries!",
    "cumulative_rating": 4.372549019607843,
    "review_impact": 0.00236349016836801,
    "api_order": 50,
    "id": "fa6b70ba-c208-4f1f-8b81-d3f2acd3e1a6",
    "analysis": [
      {
        "review_id": "fa6b70ba-c208-4f1f-8b81-d3f2acd3e1a6",
        "comment": "Tons of beautiful and delicious pastries!",
        "subject_group": "pastry",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "04b69e61-dedd-4771-82b7-2be381f1b3ee"
      },
      {
        "review_id": "fa6b70ba-c208-4f1f-8b81-d3f2acd3e1a6",
        "comment": "Great quick breakfast!",
        "subject_group": "breakfast",
        "category": "experience",
        "attribute": "speed",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "2ae7887b-812d-4528-9f7e-6e005cc5c9d2"
      },
      {
        "review_id": "fa6b70ba-c208-4f1f-8b81-d3f2acd3e1a6",
        "comment": "Great quick breakfast!",
        "subject_group": "breakfast",
        "category": "experience",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "45f3899b-8a80-44fc-b222-f8f99e2d81a7"
      },
      {
        "review_id": "fa6b70ba-c208-4f1f-8b81-d3f2acd3e1a6",
        "comment": "Tons of beautiful and delicious pastries!",
        "subject_group": "pastry",
        "category": "product",
        "attribute": "appearance",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "50448799-62bb-4623-b84d-ce93ed2ca4ff"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-05-13T09:21:32",
    "profile_name": "Jazmin Escamilla",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSURSXy16WUZnEAE",
    "review_text": "It has been the best coffee I have ever had, we spent 7 days in New York in a hotel that is two blocks away and we had breakfast here all 7 days, everything was perfect, the service, the staff, the cleanliness, the quality and the flavor 👌🏼 all 10!\nExcellent place!!",
    "cumulative_rating": 4.36,
    "review_impact": 0.00236349016836801,
    "api_order": 49,
    "id": "b21bfef4-335e-496c-9407-994bd1e2c118",
    "analysis": [
      {
        "review_id": "b21bfef4-335e-496c-9407-994bd1e2c118",
        "comment": "It has been the best coffee I have ever had",
        "subject_group": "coffee",
        "category": "product",
        "attribute": "flavor",
        "sentiment": "positive",
        "attribute_impact": 0.00029543627104600123,
        "id": "1dd5c327-1a1d-431c-b741-0b89d6308d18"
      },
      {
        "review_id": "b21bfef4-335e-496c-9407-994bd1e2c118",
        "comment": "everything was perfect, the service, the staff, the cleanliness, the quality and the flavor",
        "subject_group": "cleanliness",
        "category": "experience",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00029543627104600123,
        "id": "3bfdbe83-15da-4cac-83a5-6b14af0b30f1"
      },
      {
        "review_id": "b21bfef4-335e-496c-9407-994bd1e2c118",
        "comment": "Excellent place!!",
        "subject_group": "place",
        "category": "experience",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00029543627104600123,
        "id": "56fb2520-9e9a-4d6e-af7d-b5eb19aca1a8"
      },
      {
        "review_id": "b21bfef4-335e-496c-9407-994bd1e2c118",
        "comment": "everything was perfect, the service, the staff, the cleanliness, the quality and the flavor",
        "subject_group": "quality",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00029543627104600123,
        "id": "593caec5-3d7c-4326-b536-52d4e622164e"
      },
      {
        "review_id": "b21bfef4-335e-496c-9407-994bd1e2c118",
        "comment": "everything was perfect, the service, the staff, the cleanliness, the quality and the flavor",
        "subject_group": "service",
        "category": "service",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00029543627104600123,
        "id": "83b8dace-a1d3-42f2-af83-e63c67cd6ddc"
      },
      {
        "review_id": "b21bfef4-335e-496c-9407-994bd1e2c118",
        "comment": "everything was perfect, the service, the staff, the cleanliness, the quality and the flavor",
        "subject_group": "flavor",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00029543627104600123,
        "id": "8708ca7b-d8af-49ea-b83d-80009bbd4ad8"
      },
      {
        "review_id": "b21bfef4-335e-496c-9407-994bd1e2c118",
        "comment": "everything was perfect, the service, the staff, the cleanliness, the quality and the flavor",
        "subject_group": "staff",
        "category": "service",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00029543627104600123,
        "id": "c0e7590c-6796-4a23-aa5b-89fba2299678"
      },
      {
        "review_id": "b21bfef4-335e-496c-9407-994bd1e2c118",
        "comment": "It has been the best coffee I have ever had",
        "subject_group": "coffee",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00029543627104600123,
        "id": "e4af0b6a-e76c-41cc-80dc-2868c34cf0c3"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-05-10T22:57:32",
    "profile_name": "TheJorgebaez87",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSURSXzh6VzRBRRAB",
    "review_text": "Everything is very delicious, the coffee 🤤 greetings to the countryman from Puebla! Everyone very friendly!",
    "cumulative_rating": 4.346938775510204,
    "review_impact": 0.00236349016836801,
    "api_order": 48,
    "id": "ab7835c7-dcdc-4ee8-87cb-97a197adfd8a",
    "analysis": [
      {
        "review_id": "ab7835c7-dcdc-4ee8-87cb-97a197adfd8a",
        "comment": "Everything is very delicious",
        "subject_group": "product",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "2d81d3d8-168f-4bb1-8c07-139247f8f463"
      },
      {
        "review_id": "ab7835c7-dcdc-4ee8-87cb-97a197adfd8a",
        "comment": "Everyone very friendly",
        "subject_group": "person",
        "category": "service",
        "attribute": "friendliness",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "7eac890f-1fe1-40e6-bbec-b41d82aac9b1"
      },
      {
        "review_id": "ab7835c7-dcdc-4ee8-87cb-97a197adfd8a",
        "comment": "the coffee 🤤",
        "subject_group": "product",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "e4b1a78e-c078-47f9-8d6f-98a5becf30fa"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-05-08T12:33:32",
    "profile_name": "Zuzanna Wierzba",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSURSN19PV0FREAE",
    "review_text": "Delicious pastries. Had the everything cheese cream doughnut which was very nice as well. Quite expensive but it must be the NYC prices!",
    "cumulative_rating": 4.333333333333333,
    "review_impact": 0.00236349016836801,
    "api_order": 47,
    "id": "113964c8-82d0-470c-84f3-aba0190cce29",
    "analysis": [
      {
        "review_id": "113964c8-82d0-470c-84f3-aba0190cce29",
        "comment": "Quite expensive but it must be the NYC prices!",
        "subject_group": "price",
        "category": "product",
        "attribute": "cost",
        "sentiment": "negative",
        "attribute_impact": 0.0,
        "id": "899080f2-3e86-41cd-8780-3eca72665a2a"
      },
      {
        "review_id": "113964c8-82d0-470c-84f3-aba0190cce29",
        "comment": "Delicious pastries.",
        "subject_group": "pastry",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "1c076e35-94f3-44e2-8233-7892aef59d87"
      },
      {
        "review_id": "113964c8-82d0-470c-84f3-aba0190cce29",
        "comment": "Had the everything cheese cream doughnut which was very nice as well.",
        "subject_group": "doughnut",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "eeef1eb6-8545-45b6-926d-dc004d3fb388"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-05-06T02:09:32",
    "profile_name": "Aaron Schorr",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSURSejdUMi13RRAB",
    "review_text": "Paid $16 for a berry cheese danish and a three-chocolate mousse. Top quality ingredients and beautiful presentation. Danish filling was 10/10, but the dough was a little too dense.",
    "cumulative_rating": 4.319148936170213,
    "review_impact": 0.00236349016836801,
    "api_order": 46,
    "id": "b3ce38b9-7592-4548-88b0-b031569cc128",
    "analysis": [
      {
        "review_id": "b3ce38b9-7592-4548-88b0-b031569cc128",
        "comment": "Paid $16 for a berry cheese danish and a three-chocolate mousse.",
        "subject_group": "danish",
        "category": "product",
        "attribute": "price",
        "sentiment": "negative",
        "attribute_impact": 0.0,
        "id": "69c0c979-9295-4e28-9759-5a24170f24ee"
      },
      {
        "review_id": "b3ce38b9-7592-4548-88b0-b031569cc128",
        "comment": "Paid $16 for a berry cheese danish and a three-chocolate mousse.",
        "subject_group": "mousse",
        "category": "product",
        "attribute": "price",
        "sentiment": "negative",
        "attribute_impact": 0.0,
        "id": "4048fb22-b6dc-4736-82a9-fa8a26cf7226"
      },
      {
        "review_id": "b3ce38b9-7592-4548-88b0-b031569cc128",
        "comment": "Danish filling was 10/10, but the dough was a little too dense.",
        "subject_group": "dough",
        "category": "product",
        "attribute": "texture",
        "sentiment": "negative",
        "attribute_impact": 0.0,
        "id": "9716de6a-39fb-4160-8f4b-85eed2b73e33"
      },
      {
        "review_id": "b3ce38b9-7592-4548-88b0-b031569cc128",
        "comment": "Top quality ingredients and beautiful presentation.",
        "subject_group": "presentation",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "828e17f7-ac74-412e-9008-771fe5397aa5"
      },
      {
        "review_id": "b3ce38b9-7592-4548-88b0-b031569cc128",
        "comment": "Danish filling was 10/10, but the dough was a little too dense.",
        "subject_group": "filling",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "c6c3c810-318f-4b18-9995-17d2906531be"
      },
      {
        "review_id": "b3ce38b9-7592-4548-88b0-b031569cc128",
        "comment": "Top quality ingredients and beautiful presentation.",
        "subject_group": "ingredients",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "e8d39f4d-a261-4e63-9100-6f46bd8f920a"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-05-03T15:45:32",
    "profile_name": "Julián Fernández",
    "rating": 4,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSURSdTk2MTNBRRAB",
    "review_text": "A tad expensive, but everything delicious",
    "cumulative_rating": 4.304347826086956,
    "review_impact": -0.0011330133281353127,
    "api_order": 45,
    "id": "af6bc015-a8eb-4a9b-baa1-4c8de42b4091",
    "analysis": [
      {
        "review_id": "af6bc015-a8eb-4a9b-baa1-4c8de42b4091",
        "comment": "everything delicious",
        "subject_group": "food",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "ed913416-bb1c-4fd6-ae90-d544a159838e"
      },
      {
        "review_id": "af6bc015-a8eb-4a9b-baa1-4c8de42b4091",
        "comment": "A tad expensive",
        "subject_group": "price",
        "category": "product",
        "attribute": "cost",
        "sentiment": "negative",
        "attribute_impact": -0.0011330133281353127,
        "id": "7315670c-1a03-47ab-8d2d-7f9456c6b875"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-05-01T05:21:32",
    "profile_name": "Tatyana Neverova",
    "rating": 3,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSURSbzktWlVBEAE",
    "review_text": "Food and coffee are good. Music level is too high for enjoying this place.",
    "cumulative_rating": 4.311111111111111,
    "review_impact": -0.004629516824638635,
    "api_order": 44,
    "id": "af3c6621-f667-4e08-8c89-0c94118b2eef",
    "analysis": [
      {
        "review_id": "af3c6621-f667-4e08-8c89-0c94118b2eef",
        "comment": "Food and coffee are good",
        "subject_group": "food",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "33efdbee-0029-4b98-bc58-ced2f569a4e1"
      },
      {
        "review_id": "af3c6621-f667-4e08-8c89-0c94118b2eef",
        "comment": "Food and coffee are good",
        "subject_group": "coffee",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "322db352-cfd0-4995-bbfc-dfb803646c1b"
      },
      {
        "review_id": "af3c6621-f667-4e08-8c89-0c94118b2eef",
        "comment": "Music level is too high for enjoying this place",
        "subject_group": "music",
        "category": "experience",
        "attribute": "volume",
        "sentiment": "negative",
        "attribute_impact": -0.004629516824638635,
        "id": "b7ebc702-5d4f-4ae2-b676-4b662a9688ce"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-04-28T18:57:32",
    "profile_name": "Abder Seridji",
    "rating": 3,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSURSdzU2Zkh3EAE",
    "review_text": null,
    "cumulative_rating": 4.340909090909091,
    "review_impact": -0.004629516824638635,
    "api_order": 43,
    "id": "c3302e9f-3d4b-491f-857b-36df9d23bcfc",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-04-26T08:33:32",
    "profile_name": "Joshua Hammer",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSURSOWJibzZBRRAB",
    "review_text": "I really loved the Nutella Cheesecake",
    "cumulative_rating": 4.372093023255814,
    "review_impact": 0.00236349016836801,
    "api_order": 42,
    "id": "e6a2612d-3d17-4759-917a-8f0db3e908ca",
    "analysis": [
      {
        "review_id": "e6a2612d-3d17-4759-917a-8f0db3e908ca",
        "comment": "I really loved the Nutella Cheesecake",
        "subject_group": "cheesecake",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.00236349016836801,
        "id": "730e7294-15d2-4974-a907-24e287f03269"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-04-23T22:09:32",
    "profile_name": "Rob Asen",
    "rating": 4,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSURScGVHbklBEAE",
    "review_text": "So glad to see this successful renovation' Great job on the food, and the staff have been very nice.  Nice gourmet sandwiches, the coffee is great, pastries fresh and good. Thumbs up!\n\nJust one complaint, I'm assuming this was either the manager of the owner, on my last visit few weeks back, this guy took (very) long, loud phone calls..with his phone on *speaker* ... Definitely not great for the atmosphere, hope it's not always like that.",
    "cumulative_rating": 4.357142857142857,
    "review_impact": -0.0011330133281353127,
    "api_order": 41,
    "id": "e184310d-d32f-4412-a4b0-dfbe7cf34271",
    "analysis": [
      {
        "review_id": "e184310d-d32f-4412-a4b0-dfbe7cf34271",
        "comment": "So glad to see this successful renovation",
        "subject_group": "renovation",
        "category": "experience",
        "attribute": "success",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "7e2c87b7-682d-4d46-adb6-07280f1d5cb3"
      },
      {
        "review_id": "e184310d-d32f-4412-a4b0-dfbe7cf34271",
        "comment": "Great job on the food",
        "subject_group": "food",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "e0190561-e624-4b02-9455-26c2fff84e6e"
      },
      {
        "review_id": "e184310d-d32f-4412-a4b0-dfbe7cf34271",
        "comment": "the staff have been very nice",
        "subject_group": "staff",
        "category": "service",
        "attribute": "kindness",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "b0998e17-a5b5-43fb-8b1b-f398c52cf910"
      },
      {
        "review_id": "e184310d-d32f-4412-a4b0-dfbe7cf34271",
        "comment": "Nice gourmet sandwiches",
        "subject_group": "sandwich",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "6de4122e-b479-4643-bb3e-6ddfa84f2cbb"
      },
      {
        "review_id": "e184310d-d32f-4412-a4b0-dfbe7cf34271",
        "comment": "the coffee is great",
        "subject_group": "coffee",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "1b87ee9a-bb07-457c-889c-3b0b81553e08"
      },
      {
        "review_id": "e184310d-d32f-4412-a4b0-dfbe7cf34271",
        "comment": "pastries fresh and good",
        "subject_group": "pastry",
        "category": "product",
        "attribute": "freshness",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "c860d177-185a-450a-82b6-c48e9efcde3b"
      },
      {
        "review_id": "e184310d-d32f-4412-a4b0-dfbe7cf34271",
        "comment": "this guy took (very) long, loud phone calls",
        "subject_group": "phone call",
        "category": "service",
        "attribute": "duration",
        "sentiment": "negative",
        "attribute_impact": -0.00037767110937843756,
        "id": "33ea89d1-7343-4e8c-9e85-964240211682"
      },
      {
        "review_id": "e184310d-d32f-4412-a4b0-dfbe7cf34271",
        "comment": "this guy took (very) long, loud phone calls",
        "subject_group": "phone call",
        "category": "service",
        "attribute": "volume",
        "sentiment": "negative",
        "attribute_impact": -0.00037767110937843756,
        "id": "6fac0588-6da0-44dd-a0f6-a5f494acb5ee"
      },
      {
        "review_id": "e184310d-d32f-4412-a4b0-dfbe7cf34271",
        "comment": "Definitely not great for the atmosphere",
        "subject_group": "atmosphere",
        "category": "experience",
        "attribute": "quality",
        "sentiment": "negative",
        "attribute_impact": -0.00037767110937843756,
        "id": "a44fc286-0462-4e6b-9efe-af7f9e38691d"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-04-21T11:45:32",
    "profile_name": "Laurent Delarue",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSURSLVllVVNBEAE",
    "review_text": "A nice little heaven next to Financial district. Some of the pastries are just delicious. A few tables are powered so ideal for people who want to work a bit",
    "cumulative_rating": 4.365853658536586,
    "review_impact": 0.00236349016836801,
    "api_order": 40,
    "id": "f1491303-87ac-471e-a00b-ea617a94d297",
    "analysis": [
      {
        "review_id": "f1491303-87ac-471e-a00b-ea617a94d297",
        "comment": "Some of the pastries are just delicious",
        "subject_group": "pastry",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "14c33a7e-b66c-4576-8b2e-0e55d9e7c87c"
      },
      {
        "review_id": "f1491303-87ac-471e-a00b-ea617a94d297",
        "comment": "A few tables are powered so ideal for people who want to work a bit",
        "subject_group": "table",
        "category": "experience",
        "attribute": "utility",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "77be5d26-9465-485c-a153-348edf6d3d66"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-04-19T01:21:32",
    "profile_name": "_TheBadWon _",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSURSNlpXdFhBEAE",
    "review_text": "Best Sandwich and Best Cheese Cake I’ve had in my entire life",
    "cumulative_rating": 4.35,
    "review_impact": 0.00236349016836801,
    "api_order": 39,
    "id": "41b2c972-e2c0-44f4-9478-20cc6a6fd45a",
    "analysis": [
      {
        "review_id": "41b2c972-e2c0-44f4-9478-20cc6a6fd45a",
        "comment": "Best Sandwich and Best Cheese Cake I’ve had in my entire life",
        "subject_group": "sandwich",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "526b248e-4069-4e68-8ec1-e85d8c14d587"
      },
      {
        "review_id": "41b2c972-e2c0-44f4-9478-20cc6a6fd45a",
        "comment": "Best Sandwich and Best Cheese Cake I’ve had in my entire life",
        "subject_group": "cheese cake",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "95375eb5-3cc7-47f8-9836-803565157ef6"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-04-16T14:57:32",
    "profile_name": "Brian Piccolo",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSURSeW9PdXlRRRAB",
    "review_text": "You MUST visit if you are ever in Lower Manhattan. A short walk from World Trade Center and the 9/11 Memorial, this bakery is amazing. The croissants are ridiculously good, honestly the best I have ever had, filled with creams and fresh fruit and jelly, so good\n\nBut the star of the show during my visit was the smoked salmon sandwich on a croissant with everything bagel seasoning, avocado, cream cheese and fresh tomatoes O.M.G. soooo good\n\nCoffee was great as well. Definitely check out this spot, you won't be disappointed.",
    "cumulative_rating": 4.333333333333333,
    "review_impact": 0.00236349016836801,
    "api_order": 38,
    "id": "7ddb19bc-c1b7-49b0-9595-665d7e6f64b8",
    "analysis": [
      {
        "review_id": "7ddb19bc-c1b7-49b0-9595-665d7e6f64b8",
        "comment": "The croissants are ridiculously good, honestly the best I have ever had, filled with creams and fresh fruit and jelly, so good.",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "filling",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "52480890-b674-491e-88bd-c9e1895ea356"
      },
      {
        "review_id": "7ddb19bc-c1b7-49b0-9595-665d7e6f64b8",
        "comment": "The croissants are ridiculously good, honestly the best I have ever had, filled with creams and fresh fruit and jelly, so good.",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "562b3736-9da8-4197-90cf-4e5ef4e9d301"
      },
      {
        "review_id": "7ddb19bc-c1b7-49b0-9595-665d7e6f64b8",
        "comment": "Coffee was great as well.",
        "subject_group": "coffee",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "7f81a9c0-5cd6-4ecc-8efc-9a1b3ebf025e"
      },
      {
        "review_id": "7ddb19bc-c1b7-49b0-9595-665d7e6f64b8",
        "comment": "But the star of the show during my visit was the smoked salmon sandwich on a croissant with everything bagel seasoning, avocado, cream cheese and fresh tomatoes O.M.G. soooo good.",
        "subject_group": "sandwich",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "c77af82f-77c6-4e0c-8a72-b1a010b6a2ce"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-04-14T04:33:32",
    "profile_name": "Cat S",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSURSbkoybzZRRRAB",
    "review_text": "Delicious croissants and cakes!",
    "cumulative_rating": 4.315789473684211,
    "review_impact": 0.00236349016836801,
    "api_order": 37,
    "id": "abbeee4b-cf94-4be4-8ae4-0052b12645bc",
    "analysis": [
      {
        "review_id": "abbeee4b-cf94-4be4-8ae4-0052b12645bc",
        "comment": "Delicious croissants and cakes!",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "01708d4b-11f6-4118-93bc-8e651023f61b"
      },
      {
        "review_id": "abbeee4b-cf94-4be4-8ae4-0052b12645bc",
        "comment": "Delicious croissants and cakes!",
        "subject_group": "cake",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "31ba9a30-5847-4663-97b7-e15d4def42d6"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-04-11T18:09:32",
    "profile_name": "Sabela Galego",
    "rating": 1,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSURSbkxLc2VnEAE",
    "review_text": "If you want to be charged 10$ for a cheesecake that can’t be cut with the plastic knife they give you, that's your place! And don't forget to clean your table before you go if you don't want to argue with the lazy people that work there. TERRIBLE SERVICE, RUDE STAFF.",
    "cumulative_rating": 4.297297297297297,
    "review_impact": -0.011622523817646169,
    "api_order": 36,
    "id": "a66fa920-cf3e-4367-a06a-4596a2073e0b",
    "analysis": [
      {
        "review_id": "a66fa920-cf3e-4367-a06a-4596a2073e0b",
        "comment": "TERRIBLE SERVICE, RUDE STAFF",
        "subject_group": "service",
        "category": "service",
        "attribute": "quality",
        "sentiment": "negative",
        "attribute_impact": -0.002905630954411542,
        "id": "9052e950-964b-4ffc-a610-7fb3f79c5fc6"
      },
      {
        "review_id": "a66fa920-cf3e-4367-a06a-4596a2073e0b",
        "comment": "TERRIBLE SERVICE, RUDE STAFF",
        "subject_group": "staff",
        "category": "service",
        "attribute": "behavior",
        "sentiment": "negative",
        "attribute_impact": -0.002905630954411542,
        "id": "b110956e-9476-4eb2-af7b-7d2d6903f6fa"
      },
      {
        "review_id": "a66fa920-cf3e-4367-a06a-4596a2073e0b",
        "comment": "If you want to be charged 10$ for a cheesecake that can’t be cut with the plastic knife they give you",
        "subject_group": "cheesecake",
        "category": "product",
        "attribute": "price",
        "sentiment": "negative",
        "attribute_impact": -0.002905630954411542,
        "id": "c0b752a0-f129-457d-8367-e660092de199"
      },
      {
        "review_id": "a66fa920-cf3e-4367-a06a-4596a2073e0b",
        "comment": "If you want to be charged 10$ for a cheesecake that can’t be cut with the plastic knife they give you",
        "subject_group": "cheesecake",
        "category": "product",
        "attribute": "cutting",
        "sentiment": "negative",
        "attribute_impact": -0.002905630954411542,
        "id": "d102f564-2a9c-4ad2-8205-b769894cc899"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-04-09T07:45:32",
    "profile_name": "Maxime BACQUET",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSURSeklDN2RnEAE",
    "review_text": "A nice place, which offers breakfast or lunch. Friendly welcome. Recommended 👍",
    "cumulative_rating": 4.388888888888889,
    "review_impact": 0.00236349016836801,
    "api_order": 35,
    "id": "a3282f39-59b7-4cc6-98cd-96b6f9dca694",
    "analysis": [
      {
        "review_id": "a3282f39-59b7-4cc6-98cd-96b6f9dca694",
        "comment": "A nice place",
        "subject_group": "place",
        "category": "experience",
        "attribute": "niceness",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "17b2201e-a75c-49f4-a5ec-f125766e8995"
      },
      {
        "review_id": "a3282f39-59b7-4cc6-98cd-96b6f9dca694",
        "comment": "Recommended",
        "subject_group": "recommendation",
        "category": "experience",
        "attribute": "value",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "5be418a6-aa07-4b65-bd24-2fd63ace25c7"
      },
      {
        "review_id": "a3282f39-59b7-4cc6-98cd-96b6f9dca694",
        "comment": "which offers breakfast or lunch",
        "subject_group": "offer",
        "category": "product",
        "attribute": "availability",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "6d9ea059-de9a-47cf-ab8e-a5a839deec77"
      },
      {
        "review_id": "a3282f39-59b7-4cc6-98cd-96b6f9dca694",
        "comment": "Friendly welcome",
        "subject_group": "welcome",
        "category": "service",
        "attribute": "friendliness",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "bdea9e57-87b4-4795-8170-2902732b3efe"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-04-06T21:21:32",
    "profile_name": "Γερασιμούλα Τζωρτζάτου",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSURSMEp1MVRnEAE",
    "review_text": null,
    "cumulative_rating": 4.371428571428571,
    "review_impact": 0.00236349016836801,
    "api_order": 34,
    "id": "a712cefd-2f94-48b6-b46c-77ed9fd05974",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-04-04T10:57:32",
    "profile_name": "Christina Monsisvais",
    "rating": 1,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSURSNE52ZkJBEAE",
    "review_text": "I usually don't write a review, but after spending nearly $70 on two breakfast croissants, both were rare in the middle, we had to throw them away.  The coffee could have been better. I had a latte, which didn't even come close to the latte back home.  Plus, the bakery, yeah, I didn't enjoy it.  I figured my breakfast and coffee sucked; hopefully, my bakery was good.  It was a waste of money because it ended up in the trash.  I expect more from the review and the money I spend.  Plus, the guy and the two girls weren't even friendly. I understand I am visiting New York, but can't you say good morning? The little hole in the wall me and my husband went to yesterday to have breakfast was way better, and the guys were friendly, and it cost us under $20. For the rest of our trip, we should find more places like that to experience food and bakery goods.",
    "cumulative_rating": 4.352941176470588,
    "review_impact": -0.011622523817646169,
    "api_order": 33,
    "id": "06cf947f-2e23-4127-8a21-1e92964d9c20",
    "analysis": [
      {
        "review_id": "06cf947f-2e23-4127-8a21-1e92964d9c20",
        "comment": "The little hole in the wall me and my husband went to yesterday to have breakfast was way better, and the guys were friendly.",
        "subject_group": "breakfast",
        "category": "experience",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "672e02ee-ec42-4791-95b9-bfb757477c7c"
      },
      {
        "review_id": "06cf947f-2e23-4127-8a21-1e92964d9c20",
        "comment": "The little hole in the wall me and my husband went to yesterday to have breakfast was way better, and the guys were friendly.",
        "subject_group": "staff",
        "category": "service",
        "attribute": "friendliness",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "51c4c27a-85cb-4379-8699-7c274f7dd998"
      },
      {
        "review_id": "06cf947f-2e23-4127-8a21-1e92964d9c20",
        "comment": "It was a waste of money because it ended up in the trash.",
        "subject_group": "money",
        "category": "product",
        "attribute": "value",
        "sentiment": "negative",
        "attribute_impact": -0.001660360545378024,
        "id": "2d710d2b-a872-4bb3-8a23-3b138f3a84e8"
      },
      {
        "review_id": "06cf947f-2e23-4127-8a21-1e92964d9c20",
        "comment": "Plus, the guy and the two girls weren't even friendly.",
        "subject_group": "staff",
        "category": "service",
        "attribute": "friendliness",
        "sentiment": "negative",
        "attribute_impact": -0.001660360545378024,
        "id": "4184cb89-ae3a-4a88-bb1d-b502a21092f6"
      },
      {
        "review_id": "06cf947f-2e23-4127-8a21-1e92964d9c20",
        "comment": "I usually don't write a review, but after spending nearly $70 on two breakfast croissants, both were rare in the middle, we had to throw them away.",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "quality",
        "sentiment": "negative",
        "attribute_impact": -0.001660360545378024,
        "id": "4c6f2998-120e-426c-8292-d20aff1ba3ea"
      },
      {
        "review_id": "06cf947f-2e23-4127-8a21-1e92964d9c20",
        "comment": "I usually don't write a review, but after spending nearly $70 on two breakfast croissants, both were rare in the middle, we had to throw them away.",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "price",
        "sentiment": "negative",
        "attribute_impact": -0.001660360545378024,
        "id": "637b24a5-6f87-48ea-81bc-79df0f2463ba"
      },
      {
        "review_id": "06cf947f-2e23-4127-8a21-1e92964d9c20",
        "comment": "The coffee could have been better.",
        "subject_group": "coffee",
        "category": "product",
        "attribute": "quality",
        "sentiment": "negative",
        "attribute_impact": -0.001660360545378024,
        "id": "6add670a-a0e5-43b1-adb0-6d72ca85c410"
      },
      {
        "review_id": "06cf947f-2e23-4127-8a21-1e92964d9c20",
        "comment": "I had a latte, which didn't even come close to the latte back home.",
        "subject_group": "latte",
        "category": "product",
        "attribute": "quality",
        "sentiment": "negative",
        "attribute_impact": -0.001660360545378024,
        "id": "a4023875-d3b9-463c-8056-2ea522901f1d"
      },
      {
        "review_id": "06cf947f-2e23-4127-8a21-1e92964d9c20",
        "comment": "Plus, the bakery, yeah, I didn't enjoy it.",
        "subject_group": "bakery",
        "category": "experience",
        "attribute": "enjoyment",
        "sentiment": "negative",
        "attribute_impact": -0.001660360545378024,
        "id": "fe7927fd-f712-433b-ab99-5226ceb7678a"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-04-02T00:33:32",
    "profile_name": "Oleg Smirnov",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNSXzduMWZ3EAE",
    "review_text": "Croissants with sausage and cheese are literally the best. Visited this place 5 times for breakfast.",
    "cumulative_rating": 4.454545454545454,
    "review_impact": 0.00236349016836801,
    "api_order": 32,
    "id": "aac7756a-c09c-4837-9219-85e8449fad94",
    "analysis": [
      {
        "review_id": "aac7756a-c09c-4837-9219-85e8449fad94",
        "comment": "Croissants with sausage and cheese are literally the best",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "14464d75-df70-4646-b1a3-fa7a1e7991c1"
      },
      {
        "review_id": "aac7756a-c09c-4837-9219-85e8449fad94",
        "comment": "Visited this place 5 times for breakfast",
        "subject_group": "experience",
        "category": "experience",
        "attribute": "frequency",
        "sentiment": "positive",
        "attribute_impact": 0.001181745084184005,
        "id": "27d18d8a-1932-4800-86b6-37458ebed6ea"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-03-30T14:09:32",
    "profile_name": "Catherine Fitz",
    "rating": 1,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUNSNzRuSS1BRRAB",
    "review_text": "My dessert was inedible.  I tried to return it after one bite.  No one on the premises could manage a simple return.  Total failure of management.",
    "cumulative_rating": 4.4375,
    "review_impact": -0.011622523817646169,
    "api_order": 31,
    "id": "c22ac90d-793d-4f64-a730-d13a2a87bec7",
    "analysis": [
      {
        "review_id": "c22ac90d-793d-4f64-a730-d13a2a87bec7",
        "comment": "My dessert was inedible.",
        "subject_group": "dessert",
        "category": "product",
        "attribute": "edibility",
        "sentiment": "negative",
        "attribute_impact": -0.002905630954411542,
        "id": "24ec92ad-8248-44bf-a1f9-f2b1b9dab559"
      },
      {
        "review_id": "c22ac90d-793d-4f64-a730-d13a2a87bec7",
        "comment": "Total failure of management.",
        "subject_group": "management",
        "category": "service",
        "attribute": "failure",
        "sentiment": "negative",
        "attribute_impact": -0.002905630954411542,
        "id": "5447734a-53bb-4c35-afe4-ddf2d7313837"
      },
      {
        "review_id": "c22ac90d-793d-4f64-a730-d13a2a87bec7",
        "comment": "No one on the premises could manage a simple return.",
        "subject_group": "management",
        "category": "service",
        "attribute": "capability",
        "sentiment": "negative",
        "attribute_impact": -0.002905630954411542,
        "id": "6057fd7c-914c-4211-ab74-fc9b6a12a777"
      },
      {
        "review_id": "c22ac90d-793d-4f64-a730-d13a2a87bec7",
        "comment": "I tried to return it after one bite.",
        "subject_group": "return",
        "category": "service",
        "attribute": "attempt",
        "sentiment": "negative",
        "attribute_impact": -0.002905630954411542,
        "id": "7f6dc3e3-0d98-4954-80ad-6afbcb10bd48"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-03-28T03:45:32",
    "profile_name": "Daniel M.",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNSeTY2OWJBEAE",
    "review_text": "Pastries super delicious 🤤\n\nWe tried NY cheesecake here which was really good, and the eclairs were also an absolute hit!\n\nThe young man behind the counter was absolutely friendly and an absolute reason for me to come back!\n\nConclusion:\nYou should take it with you!",
    "cumulative_rating": 4.548387096774194,
    "review_impact": 0.00236349016836801,
    "api_order": 30,
    "id": "54b090f6-f08c-4bf3-a74a-a42398071325",
    "analysis": [
      {
        "review_id": "54b090f6-f08c-4bf3-a74a-a42398071325",
        "comment": "Pastries super delicious 🤤",
        "subject_group": "pastry",
        "category": "product",
        "attribute": "deliciousness",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "2dd639bd-10a7-40e3-a2a9-94d52f9b539d"
      },
      {
        "review_id": "54b090f6-f08c-4bf3-a74a-a42398071325",
        "comment": "We tried NY cheesecake here which was really good, and the eclairs were also an absolute hit!",
        "subject_group": "eclair",
        "category": "product",
        "attribute": "popularity",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "cbdb81d5-8913-4c25-adba-9baa24cc7ae1"
      },
      {
        "review_id": "54b090f6-f08c-4bf3-a74a-a42398071325",
        "comment": "The young man behind the counter was absolutely friendly and an absolute reason for me to come back!",
        "subject_group": "man",
        "category": "service",
        "attribute": "friendliness",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "f7d07bd6-6c5e-4894-bdca-ee14f13669a7"
      },
      {
        "review_id": "54b090f6-f08c-4bf3-a74a-a42398071325",
        "comment": "We tried NY cheesecake here which was really good, and the eclairs were also an absolute hit!",
        "subject_group": "cheesecake",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "fc206061-7678-407a-9a9b-89effb4a627b"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-03-25T17:21:32",
    "profile_name": "Ricardo Luis Alvarez",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNSemNQX09nEAE",
    "review_text": null,
    "cumulative_rating": 4.533333333333333,
    "review_impact": 0.00236349016836801,
    "api_order": 29,
    "id": "b2e16386-20bc-43a1-bb81-9c9fb872a22f",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-03-23T06:57:32",
    "profile_name": "Michael Yankel",
    "rating": 1,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNSMWVUOEd3EAE",
    "review_text": null,
    "cumulative_rating": 4.517241379310345,
    "review_impact": -0.011622523817646169,
    "api_order": 28,
    "id": "6a464e92-36b2-49d3-9bfd-aeb397768138",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-03-20T20:33:32",
    "profile_name": "Mario Costa",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNSZ2ItblR3EAE",
    "review_text": "Very good",
    "cumulative_rating": 4.642857142857143,
    "review_impact": 0.00236349016836801,
    "api_order": 27,
    "id": "a7c408d2-c54f-4dfb-9c2c-ee34957effe8",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-03-18T10:09:32",
    "profile_name": "Tatjana",
    "rating": 4,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNSeHRuYmF3EAE",
    "review_text": "Delicious croissants & coffee in Downtown New York :) I would definitely recommend it for a nice breakfast.",
    "cumulative_rating": 4.62962962962963,
    "review_impact": -0.0011330133281353127,
    "api_order": 26,
    "id": "3ec78335-c2d9-4f33-af20-beffbd6822a2",
    "analysis": [
      {
        "review_id": "3ec78335-c2d9-4f33-af20-beffbd6822a2",
        "comment": "Delicious croissants",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "855ca82c-9e7e-4d33-a427-c8f1e0049070"
      },
      {
        "review_id": "3ec78335-c2d9-4f33-af20-beffbd6822a2",
        "comment": "coffee in Downtown New York",
        "subject_group": "coffee",
        "category": "product",
        "attribute": "location",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "6e5319eb-76bf-421f-aff8-b198330e39c9"
      },
      {
        "review_id": "3ec78335-c2d9-4f33-af20-beffbd6822a2",
        "comment": "I would definitely recommend it for a nice breakfast",
        "subject_group": "breakfast",
        "category": "experience",
        "attribute": "recommendation",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "7bf3763e-60be-4859-8884-a59fff470f82"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-03-15T23:45:32",
    "profile_name": "LEO dexter",
    "rating": 3,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUNScXNUenJRRRAB",
    "review_text": null,
    "cumulative_rating": 4.653846153846154,
    "review_impact": -0.004629516824638635,
    "api_order": 25,
    "id": "ac610acb-715b-41e8-9d54-b6a3b83d812a",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-03-13T13:21:32",
    "profile_name": "옥재훈",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNSb3BEMk1REAE",
    "review_text": null,
    "cumulative_rating": 4.72,
    "review_impact": 0.00236349016836801,
    "api_order": 24,
    "id": "14ff909a-7dfb-4133-94ac-1f7b854b817d",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-03-11T02:57:32",
    "profile_name": "Jerry Thomas",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUNSd29QZDZnRRAB",
    "review_text": null,
    "cumulative_rating": 4.708333333333333,
    "review_impact": 0.00236349016836801,
    "api_order": 23,
    "id": "90237025-4e6f-4488-bf43-ec93b6614383",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-03-08T16:33:32",
    "profile_name": "張本さくら",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUNSdU1HcXFnRRAB",
    "review_text": null,
    "cumulative_rating": 4.695652173913044,
    "review_impact": 0.00236349016836801,
    "api_order": 22,
    "id": "93856ddc-ed31-4792-b156-0d6a5dd81156",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-03-06T06:09:32",
    "profile_name": "Aziz Şen",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSURoaF9PMGVBEAE",
    "review_text": "Honestly, their croissants deserve 5 stars, even though they are pricey, they are rare.",
    "cumulative_rating": 4.681818181818182,
    "review_impact": 0.00236349016836801,
    "api_order": 21,
    "id": "717ef7b0-757f-48d7-960a-a5595f06464a",
    "analysis": [
      {
        "review_id": "717ef7b0-757f-48d7-960a-a5595f06464a",
        "comment": "even though they are pricey",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "price",
        "sentiment": "negative",
        "attribute_impact": 0.0,
        "id": "02f93f46-10d7-4fa9-a9f6-ccd411469eff"
      },
      {
        "review_id": "717ef7b0-757f-48d7-960a-a5595f06464a",
        "comment": "they are rare",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "availability",
        "sentiment": "negative",
        "attribute_impact": 0.0,
        "id": "156bc636-69a0-42aa-ba5f-18ea2f344a9d"
      },
      {
        "review_id": "717ef7b0-757f-48d7-960a-a5595f06464a",
        "comment": "Honestly, their croissants deserve 5 stars",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "rating",
        "sentiment": "positive",
        "attribute_impact": 0.00236349016836801,
        "id": "0f92ade4-2e5d-497c-872b-1c8684b08524"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-03-03T19:45:32",
    "profile_name": "Isabela Ramos Podboi",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSURocTZlb0pBEAE",
    "review_text": "This place has become our favorite breakfast/brunch spot. The bagels are amazing, and if you're a pistachio fan, you can't miss their croissant.",
    "cumulative_rating": 4.666666666666667,
    "review_impact": 0.00236349016836801,
    "api_order": 20,
    "id": "53c6b635-56ef-44fb-8d81-4e0db58ee189",
    "analysis": [
      {
        "review_id": "53c6b635-56ef-44fb-8d81-4e0db58ee189",
        "comment": "if you're a pistachio fan, you can't miss their croissant",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "appeal",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "39c6d4c7-3627-47a8-bf94-f54230044f9f"
      },
      {
        "review_id": "53c6b635-56ef-44fb-8d81-4e0db58ee189",
        "comment": "The bagels are amazing",
        "subject_group": "bagel",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "bc583348-02c8-4023-b94f-c7550966482b"
      },
      {
        "review_id": "53c6b635-56ef-44fb-8d81-4e0db58ee189",
        "comment": "This place has become our favorite breakfast/brunch spot",
        "subject_group": "place",
        "category": "experience",
        "attribute": "favorite",
        "sentiment": "positive",
        "attribute_impact": 0.00078783005612267,
        "id": "cb989cdf-be7c-4926-9284-47a3f21f3223"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-03-01T09:21:32",
    "profile_name": "Carlos Guerra",
    "rating": 3,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSURoazRtVkRBEAE",
    "review_text": null,
    "cumulative_rating": 4.65,
    "review_impact": -0.004629516824638635,
    "api_order": 19,
    "id": "046cfcdf-9d2c-4137-a41f-1c660b69e6b4",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-02-26T22:57:32",
    "profile_name": "Amy Lee",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSURoazQ3UjJRRRAB",
    "review_text": "Inexplicably good croissants, best ones I’ve had outside of Paris so far. Please never change the recipe!! The staff are always very friendly and the space is clean and bright. A great addition to the neighborhood!",
    "cumulative_rating": 4.7368421052631575,
    "review_impact": 0.00236349016836801,
    "api_order": 18,
    "id": "fa91e39b-3a9b-44cc-8806-ff8bb66a9661",
    "analysis": [
      {
        "review_id": "fa91e39b-3a9b-44cc-8806-ff8bb66a9661",
        "comment": "The staff are always very friendly.",
        "subject_group": "staff",
        "category": "service",
        "attribute": "friendliness",
        "sentiment": "positive",
        "attribute_impact": 0.00047269803367360196,
        "id": "282a5cf0-6505-4dfe-9cba-cae6fef815df"
      },
      {
        "review_id": "fa91e39b-3a9b-44cc-8806-ff8bb66a9661",
        "comment": "A great addition to the neighborhood!",
        "subject_group": "addition",
        "category": "experience",
        "attribute": "value",
        "sentiment": "positive",
        "attribute_impact": 0.00047269803367360196,
        "id": "67b39fbe-427e-4368-a1d8-d15f458e7b60"
      },
      {
        "review_id": "fa91e39b-3a9b-44cc-8806-ff8bb66a9661",
        "comment": "The space is clean and bright.",
        "subject_group": "space",
        "category": "experience",
        "attribute": "brightness",
        "sentiment": "positive",
        "attribute_impact": 0.00047269803367360196,
        "id": "e026fc15-9b45-4631-a01c-fa8b4a504afa"
      },
      {
        "review_id": "fa91e39b-3a9b-44cc-8806-ff8bb66a9661",
        "comment": "The space is clean and bright.",
        "subject_group": "space",
        "category": "experience",
        "attribute": "cleanliness",
        "sentiment": "positive",
        "attribute_impact": 0.00047269803367360196,
        "id": "e919f2e9-2799-48a3-9624-5fa8c9ff3590"
      },
      {
        "review_id": "fa91e39b-3a9b-44cc-8806-ff8bb66a9661",
        "comment": "Inexplicably good croissants, best ones I’ve had outside of Paris so far.",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00047269803367360196,
        "id": "f8cc4cde-ceb9-45b3-ac3f-cfd6fd89b803"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-02-24T12:33:32",
    "profile_name": "Maha Dallali",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSURoaWVIZVVBEAE",
    "review_text": null,
    "cumulative_rating": 4.722222222222222,
    "review_impact": 0.00236349016836801,
    "api_order": 17,
    "id": "8cbdda27-5e60-4b30-992d-cf9c9764a52e",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-02-22T02:09:32",
    "profile_name": "Magali Bertolazzi Vezzaro",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSURoOGYtM1FBEAE",
    "review_text": "I love it and recommend it for a little coffee break and some nice Parisian music.\n😉",
    "cumulative_rating": 4.705882352941177,
    "review_impact": 0.00236349016836801,
    "api_order": 16,
    "id": "1b92a760-3b50-4ce0-96f1-73a3da10b54d",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-02-19T15:45:32",
    "profile_name": "Edgar Fonteix",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSURoNU1TZWFnEAE",
    "review_text": null,
    "cumulative_rating": 4.6875,
    "review_impact": 0.00236349016836801,
    "api_order": 15,
    "id": "f0b8717d-2567-43e0-b2d8-21d995a96212",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-02-17T05:21:32",
    "profile_name": "Janvier NoM",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSURob0szZ0pnEAE",
    "review_text": "Loved the strawberry cheesecake! The sandwich I had was also decent. Also, one of the few places I can get Martinelli’s apple juice. Very convenient (right on top of Rector St station). I’ll definitely be back",
    "cumulative_rating": 4.666666666666667,
    "review_impact": 0.00236349016836801,
    "api_order": 14,
    "id": "e8ea705e-32a2-4233-826c-5c2b269317bb",
    "analysis": [
      {
        "review_id": "e8ea705e-32a2-4233-826c-5c2b269317bb",
        "comment": "The sandwich I had was also decent.",
        "subject_group": "sandwich",
        "category": "product",
        "attribute": "quality",
        "sentiment": "negative",
        "attribute_impact": 0.0,
        "id": "d618d664-896e-4682-b0a8-5a689d120379"
      },
      {
        "review_id": "e8ea705e-32a2-4233-826c-5c2b269317bb",
        "comment": "Very convenient (right on top of Rector St station).",
        "subject_group": "location",
        "category": "experience",
        "attribute": "accessibility",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "12e9cd54-7e41-4b11-922d-55b4352860e2"
      },
      {
        "review_id": "e8ea705e-32a2-4233-826c-5c2b269317bb",
        "comment": "one of the few places I can get Martinelli’s apple juice.",
        "subject_group": "juice",
        "category": "product",
        "attribute": "availability",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "77bcacbd-e624-42a5-b9d1-5b9bd18d25c3"
      },
      {
        "review_id": "e8ea705e-32a2-4233-826c-5c2b269317bb",
        "comment": "I’ll definitely be back.",
        "subject_group": "return",
        "category": "experience",
        "attribute": "intention",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "783a1955-3ec9-4e16-a4a0-ac35d59c532e"
      },
      {
        "review_id": "e8ea705e-32a2-4233-826c-5c2b269317bb",
        "comment": "Loved the strawberry cheesecake!",
        "subject_group": "cheesecake",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "93c3ea2b-b0d5-4703-86a0-535ca9ba68a0"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-02-14T18:57:32",
    "profile_name": "Michael Stellati",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNoNzkyQ2NnEAE",
    "review_text": "Great croissants etc",
    "cumulative_rating": 4.642857142857143,
    "review_impact": 0.00236349016836801,
    "api_order": 13,
    "id": "a1598708-4da1-4476-81fd-e5e934690ded",
    "analysis": [
      {
        "review_id": "a1598708-4da1-4476-81fd-e5e934690ded",
        "comment": "Great croissants",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00236349016836801,
        "id": "08548131-0bf6-4883-a7ed-aee722de540f"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-02-12T08:33:32",
    "profile_name": "Sang Hyup Lee",
    "rating": 1,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNoOVpHekZREAE",
    "review_text": "Did not enjoy it",
    "cumulative_rating": 4.615384615384615,
    "review_impact": -0.011622523817646169,
    "api_order": 12,
    "id": "8f0fe9ff-da1e-41f2-bc51-b0c5fb65a459",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-02-09T22:09:32",
    "profile_name": "Michael Papadopoulos",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUNoOWJELThnRRAB",
    "review_text": "The Best Croissants, pastries and coffee! High quality products and amazing atmosphere!",
    "cumulative_rating": 4.916666666666667,
    "review_impact": 0.00236349016836801,
    "api_order": 11,
    "id": "ae12d222-3db3-46dc-9573-9bb7b1c6bb02",
    "analysis": [
      {
        "review_id": "ae12d222-3db3-46dc-9573-9bb7b1c6bb02",
        "comment": "pastries",
        "subject_group": "pastry",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00047269803367360196,
        "id": "289f2f91-ca8f-448b-bb18-97c88a7294fc"
      },
      {
        "review_id": "ae12d222-3db3-46dc-9573-9bb7b1c6bb02",
        "comment": "The Best Croissants",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00047269803367360196,
        "id": "3b0a9cdf-063f-4a21-9498-8794ba9a36fd"
      },
      {
        "review_id": "ae12d222-3db3-46dc-9573-9bb7b1c6bb02",
        "comment": "amazing atmosphere",
        "subject_group": "atmosphere",
        "category": "experience",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00047269803367360196,
        "id": "49d90a93-e3ab-411b-bc60-28924396a8bd"
      },
      {
        "review_id": "ae12d222-3db3-46dc-9573-9bb7b1c6bb02",
        "comment": "High quality products",
        "subject_group": "product",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00047269803367360196,
        "id": "50c5f229-8a64-4ea5-93d5-f5d600122f7f"
      },
      {
        "review_id": "ae12d222-3db3-46dc-9573-9bb7b1c6bb02",
        "comment": "coffee",
        "subject_group": "coffee",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00047269803367360196,
        "id": "d6ec158a-2135-4807-ab91-3a305c5347f8"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-02-07T11:45:32",
    "profile_name": "Elizabeth McNutt",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNoN3Bfa0t3EAE",
    "review_text": "Very fresh food!! Great coffee, breakfast and cheesecakes!",
    "cumulative_rating": 4.909090909090909,
    "review_impact": 0.00236349016836801,
    "api_order": 10,
    "id": "db42e058-4b23-4f0b-ba69-60653af1e11b",
    "analysis": [
      {
        "review_id": "db42e058-4b23-4f0b-ba69-60653af1e11b",
        "comment": "Great coffee, breakfast and cheesecakes!",
        "subject_group": "breakfast",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "1c18bcb5-c5d4-4f9b-b30e-233c07371a51"
      },
      {
        "review_id": "db42e058-4b23-4f0b-ba69-60653af1e11b",
        "comment": "Great coffee, breakfast and cheesecakes!",
        "subject_group": "cheesecake",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "6ff96eea-e4d2-4588-9521-dfb0de7135ec"
      },
      {
        "review_id": "db42e058-4b23-4f0b-ba69-60653af1e11b",
        "comment": "Very fresh food!!",
        "subject_group": "food",
        "category": "product",
        "attribute": "freshness",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "af78145f-061b-45af-88f4-f08a908a8e67"
      },
      {
        "review_id": "db42e058-4b23-4f0b-ba69-60653af1e11b",
        "comment": "Great coffee, breakfast and cheesecakes!",
        "subject_group": "coffee",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "b29595b9-7398-4d9d-8fd7-f2d8cf5baa9b"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-02-05T01:21:32",
    "profile_name": "Daniel Pino",
    "rating": 4,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSUNobkl2cVNnEAE",
    "review_text": "Layout/atmosphere\n*Display case to right; tables for dine in; one TV\n\nFood/drink\n*Creme brûlée brioche doughnut - good",
    "cumulative_rating": 4.9,
    "review_impact": -0.0011330133281353127,
    "api_order": 9,
    "id": "617a3e0f-ff07-46d5-8ecb-cdfba96a4a25",
    "analysis": [
      {
        "review_id": "617a3e0f-ff07-46d5-8ecb-cdfba96a4a25",
        "comment": "Layout/atmosphere",
        "subject_group": "layout",
        "category": "experience",
        "attribute": "display case",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "daf25e49-0b04-454b-b859-3fc24c65344d"
      },
      {
        "review_id": "617a3e0f-ff07-46d5-8ecb-cdfba96a4a25",
        "comment": "Layout/atmosphere",
        "subject_group": "layout",
        "category": "experience",
        "attribute": "tables",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "0af67aae-72c3-41bd-b1c1-624e1d8e25e7"
      },
      {
        "review_id": "617a3e0f-ff07-46d5-8ecb-cdfba96a4a25",
        "comment": "Layout/atmosphere",
        "subject_group": "layout",
        "category": "experience",
        "attribute": "tv",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "f6ba413b-8d9d-4149-93b1-b40e0b35d1d0"
      },
      {
        "review_id": "617a3e0f-ff07-46d5-8ecb-cdfba96a4a25",
        "comment": "Creme brûlée brioche doughnut - good",
        "subject_group": "doughnut",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.0,
        "id": "fd5eac37-d892-4c98-9afc-ceeb171b84c8"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-02-02T14:57:32",
    "profile_name": "TraMi MN",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSUNoMk5hNXp3RRAB",
    "review_text": "Excellent bakery!! Comparable to the Paris boulangerie that I’ve eaten recently. We had the crescent, strawberry & matcha filled pasties\nIt’s next door to Seina Pizza (great too)",
    "cumulative_rating": 5.0,
    "review_impact": 0.00236349016836801,
    "api_order": 8,
    "id": "0072064a-0ea3-4be8-9d31-fc8b1ca1937d",
    "analysis": [
      {
        "review_id": "0072064a-0ea3-4be8-9d31-fc8b1ca1937d",
        "comment": "We had the crescent, strawberry & matcha filled pasties.",
        "subject_group": "pasties",
        "category": "product",
        "attribute": "variety",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "162240c4-9827-4433-b566-9b29dccdfc4f"
      },
      {
        "review_id": "0072064a-0ea3-4be8-9d31-fc8b1ca1937d",
        "comment": "It’s next door to Seina Pizza (great too).",
        "subject_group": "pizza",
        "category": "experience",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "38a44532-c079-40bc-98dc-c55165e52202"
      },
      {
        "review_id": "0072064a-0ea3-4be8-9d31-fc8b1ca1937d",
        "comment": "Excellent bakery!!",
        "subject_group": "bakery",
        "category": "experience",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "c2e3b5e0-fd58-4640-bf05-6fad03cf4144"
      },
      {
        "review_id": "0072064a-0ea3-4be8-9d31-fc8b1ca1937d",
        "comment": "Comparable to the Paris boulangerie that I’ve eaten recently.",
        "subject_group": "boulangerie",
        "category": "experience",
        "attribute": "comparison",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "ed279bd9-90d5-45ef-bfae-59a725a12227"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-01-31T04:33:32",
    "profile_name": "Polly Anywhere",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSURCcF9qRFlREAE",
    "review_text": "Such a good new place for good coffee and fresh baked goods in the neighborhood!!!  The service is friendly and fast too.",
    "cumulative_rating": 5.0,
    "review_impact": 0.00236349016836801,
    "api_order": 7,
    "id": "d67320f9-e23a-41ca-9809-1d204acbfc80",
    "analysis": [
      {
        "review_id": "d67320f9-e23a-41ca-9809-1d204acbfc80",
        "comment": "Such a good new place for good coffee and fresh baked goods in the neighborhood!!!",
        "subject_group": "coffee",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "030267ca-a33c-4522-93f8-c1513492f059"
      },
      {
        "review_id": "d67320f9-e23a-41ca-9809-1d204acbfc80",
        "comment": "The service is friendly and fast too.",
        "subject_group": "service",
        "category": "service",
        "attribute": "friendliness",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "be07a7f1-42f0-4cdd-9b20-c86a8528dcdb"
      },
      {
        "review_id": "d67320f9-e23a-41ca-9809-1d204acbfc80",
        "comment": "Such a good new place for good coffee and fresh baked goods in the neighborhood!!!",
        "subject_group": "baked good",
        "category": "product",
        "attribute": "freshness",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "c3dcf59e-feff-40ed-906f-7af3abf6d068"
      },
      {
        "review_id": "d67320f9-e23a-41ca-9809-1d204acbfc80",
        "comment": "The service is friendly and fast too.",
        "subject_group": "service",
        "category": "service",
        "attribute": "speed",
        "sentiment": "positive",
        "attribute_impact": 0.0005908725420920025,
        "id": "f673b2a7-4153-4cd5-b62b-4e8d479d31b1"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "a year ago",
    "estimated_datetime": "2023-01-28T18:09:32",
    "profile_name": "Victoria Dubeau",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSURCaV9mMFB3EAE",
    "review_text": null,
    "cumulative_rating": 5.0,
    "review_impact": 0.00236349016836801,
    "api_order": 6,
    "id": "27c3d4bd-1cb7-4856-91fd-ce93794983f4",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "2 years ago",
    "estimated_datetime": "2022-12-28T02:57:32",
    "profile_name": "Vicente Salazar",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSURCcmN6dVhREAE",
    "review_text": null,
    "cumulative_rating": 5.0,
    "review_impact": 0.00236349016836801,
    "api_order": 5,
    "id": "66394f97-86b9-49c4-a801-7f5fea2ec8a6",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "2 years ago",
    "estimated_datetime": "2022-10-28T06:57:32",
    "profile_name": "Richalle Ritts",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSURCdnNfdDFBRRAB",
    "review_text": "Best coffee anywhere.",
    "cumulative_rating": 5.0,
    "review_impact": 0.00236349016836801,
    "api_order": 4,
    "id": "b1b223c1-d67f-46d5-8b91-5ea3e8477566",
    "analysis": [
      {
        "review_id": "b1b223c1-d67f-46d5-8b91-5ea3e8477566",
        "comment": "Best coffee anywhere.",
        "subject_group": "coffee",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00236349016836801,
        "id": "0606264d-be1e-47a4-984d-d0a220e41621"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "2 years ago",
    "estimated_datetime": "2022-08-28T10:57:32",
    "profile_name": "Shweta Garg",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSURCenRHR2NREAE",
    "review_text": "The bakehouse just quietly opened on the corner and has a gorgeous interior! The almond croissant was incredible and the coffee is great. A bit expensive for the drinks ranging from $5-7, but expected for the area considering Starbucks would be pricier. Plenty of to go breakfast options and treats. Excited to have something like this in FiDi!",
    "cumulative_rating": 5.0,
    "review_impact": 0.00236349016836801,
    "api_order": 3,
    "id": "f09c53c8-2a5d-46d6-946f-12bfb79f3293",
    "analysis": [
      {
        "review_id": "f09c53c8-2a5d-46d6-946f-12bfb79f3293",
        "comment": "A bit expensive for the drinks ranging from $5-7, but expected for the area considering Starbucks would be pricier.",
        "subject_group": "drinks",
        "category": "product",
        "attribute": "price",
        "sentiment": "negative",
        "attribute_impact": 0.0,
        "id": "7e8cc0d6-020c-4f3f-88c2-c8b2128f54b0"
      },
      {
        "review_id": "f09c53c8-2a5d-46d6-946f-12bfb79f3293",
        "comment": "The almond croissant was incredible and the coffee is great.",
        "subject_group": "coffee",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.00047269803367360196,
        "id": "06382830-a0ba-4ba9-a2dd-6f9ed5603cdd"
      },
      {
        "review_id": "f09c53c8-2a5d-46d6-946f-12bfb79f3293",
        "comment": "Plenty of to go breakfast options and treats.",
        "subject_group": "options",
        "category": "product",
        "attribute": "variety",
        "sentiment": "positive",
        "attribute_impact": 0.00047269803367360196,
        "id": "19a85c9a-a14d-4e89-809d-76497a2c24a1"
      },
      {
        "review_id": "f09c53c8-2a5d-46d6-946f-12bfb79f3293",
        "comment": "Excited to have something like this in FiDi!",
        "subject_group": "experience",
        "category": "experience",
        "attribute": "excitement",
        "sentiment": "positive",
        "attribute_impact": 0.00047269803367360196,
        "id": "30c551f1-f427-4cdd-acc3-2dbca775795e"
      },
      {
        "review_id": "f09c53c8-2a5d-46d6-946f-12bfb79f3293",
        "comment": "The bakehouse just quietly opened on the corner and has a gorgeous interior!",
        "subject_group": "interior",
        "category": "experience",
        "attribute": "beauty",
        "sentiment": "positive",
        "attribute_impact": 0.00047269803367360196,
        "id": "63d8fb1f-3b9c-4f7d-82e2-b163fb241870"
      },
      {
        "review_id": "f09c53c8-2a5d-46d6-946f-12bfb79f3293",
        "comment": "The almond croissant was incredible and the coffee is great.",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.00047269803367360196,
        "id": "92c93783-b784-40ea-83f9-0ee9da113165"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "2 years ago",
    "estimated_datetime": "2022-06-28T14:57:32",
    "profile_name": "George Milesis",
    "rating": 5,
    "provider_review_id": "ChZDSUhNMG9nS0VJQ0FnSURCMXZubFNREAE",
    "review_text": "Excellent little place! Definitely worth the visit!",
    "cumulative_rating": 5.0,
    "review_impact": 0.00236349016836801,
    "api_order": 2,
    "id": "25cee9ac-ba3c-4a8b-b21d-e6b271f3fa8f",
    "analysis": []
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "2 years ago",
    "estimated_datetime": "2022-04-28T18:57:32",
    "profile_name": "Sondra",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSURCNnBMbXZ3RRAB",
    "review_text": "Amazing bakery. Fantastic Croissant! Absolutely delicious desserts. All the food we had and we have never been disappointed.\nTerrific staff. Great atmosphere. White mocha is the best.",
    "cumulative_rating": 5.0,
    "review_impact": 0.00236349016836801,
    "api_order": 1,
    "id": "1c997bdf-d8a5-439c-9b25-d0bc6b7db252",
    "analysis": [
      {
        "review_id": "1c997bdf-d8a5-439c-9b25-d0bc6b7db252",
        "comment": "White mocha is the best.",
        "subject_group": "mocha",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0003376414526240014,
        "id": "09c0fdab-7694-42c8-93c1-9b98cc0a7ade"
      },
      {
        "review_id": "1c997bdf-d8a5-439c-9b25-d0bc6b7db252",
        "comment": "Great atmosphere.",
        "subject_group": "atmosphere",
        "category": "experience",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0003376414526240014,
        "id": "7d050a0b-0dd8-4d8b-8f12-9e85e7df23dd"
      },
      {
        "review_id": "1c997bdf-d8a5-439c-9b25-d0bc6b7db252",
        "comment": "Fantastic Croissant!",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0003376414526240014,
        "id": "8f0286e6-399c-44f1-ad60-1594f93e4ee2"
      },
      {
        "review_id": "1c997bdf-d8a5-439c-9b25-d0bc6b7db252",
        "comment": "Terrific staff.",
        "subject_group": "staff",
        "category": "service",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0003376414526240014,
        "id": "bc7d2139-aff5-4b0d-b5e9-448dedd9016f"
      },
      {
        "review_id": "1c997bdf-d8a5-439c-9b25-d0bc6b7db252",
        "comment": "Absolutely delicious desserts.",
        "subject_group": "dessert",
        "category": "product",
        "attribute": "taste",
        "sentiment": "positive",
        "attribute_impact": 0.0003376414526240014,
        "id": "d056e6ee-1e64-477a-8510-5d182587467c"
      },
      {
        "review_id": "1c997bdf-d8a5-439c-9b25-d0bc6b7db252",
        "comment": "Amazing bakery.",
        "subject_group": "bakery",
        "category": "experience",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.0003376414526240014,
        "id": "d3d83dae-63a3-41b7-9e9b-73069186d4ec"
      },
      {
        "review_id": "1c997bdf-d8a5-439c-9b25-d0bc6b7db252",
        "comment": "All the food we had and we have never been disappointed.",
        "subject_group": "food",
        "category": "product",
        "attribute": "satisfaction",
        "sentiment": "positive",
        "attribute_impact": 0.0003376414526240014,
        "id": "eb5c10aa-6468-4951-92b3-d87a965c47a2"
      }
    ]
  },
  {
    "business_id": "05257296-867d-4aff-bdf7-04f6f2fcaabb",
    "scrape_datetime": "2025-01-27T12:57:32",
    "time_ago": "2 years ago",
    "estimated_datetime": "2022-02-26T22:57:32",
    "profile_name": "Danielle Riggin",
    "rating": 5,
    "provider_review_id": "ChdDSUhNMG9nS0VJQ0FnSURCcW9Ici1RRRAB",
    "review_text": "Cute new bakery in FiDi with great pastry selection and fast service. The croissant was very flaky and fresh. Good coffee too!",
    "cumulative_rating": 5.0,
    "review_impact": 0.00236349016836801,
    "api_order": 0,
    "id": "ca00a2d0-0bfd-4517-a9da-d4a157796161",
    "analysis": [
      {
        "review_id": "ca00a2d0-0bfd-4517-a9da-d4a157796161",
        "comment": "Cute new bakery in FiDi with great pastry selection and fast service",
        "subject_group": "bakery",
        "category": "experience",
        "attribute": "appearance",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "15ede6ee-d30e-400f-9086-5414579ace7c"
      },
      {
        "review_id": "ca00a2d0-0bfd-4517-a9da-d4a157796161",
        "comment": "The croissant was very flaky and fresh",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "texture",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "3f64fdb2-5dd8-4b9c-bc78-578a2f15816f"
      },
      {
        "review_id": "ca00a2d0-0bfd-4517-a9da-d4a157796161",
        "comment": "Good coffee too!",
        "subject_group": "coffee",
        "category": "product",
        "attribute": "quality",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "59c1feb1-c42c-4d0e-bf30-1767d0b0f510"
      },
      {
        "review_id": "ca00a2d0-0bfd-4517-a9da-d4a157796161",
        "comment": "The croissant was very flaky and fresh",
        "subject_group": "croissant",
        "category": "product",
        "attribute": "freshness",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "59d0fa43-19af-4040-8447-5e993ac0709e"
      },
      {
        "review_id": "ca00a2d0-0bfd-4517-a9da-d4a157796161",
        "comment": "Cute new bakery in FiDi with great pastry selection and fast service",
        "subject_group": "service",
        "category": "service",
        "attribute": "speed",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "ef7c296a-456c-439c-a37b-fa70eb249df5"
      },
      {
        "review_id": "ca00a2d0-0bfd-4517-a9da-d4a157796161",
        "comment": "Cute new bakery in FiDi with great pastry selection and fast service",
        "subject_group": "pastry",
        "category": "product",
        "attribute": "selection",
        "sentiment": "positive",
        "attribute_impact": 0.000393915028061335,
        "id": "fa426da9-836b-4694-8c09-c2931d157691"
      }
    ]
  }
]
